(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bH.aN === region.ce.aN)
	{
		return 'on line ' + region.bH.aN;
	}
	return 'on lines ' + region.bH.aN + ' through ' + region.ce.aN;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ew,
		impl.fP,
		impl.fD,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		T: func(record.T),
		fB: record.fB,
		fl: record.fl
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.T;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.fB;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.fl) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ew,
		impl.fP,
		impl.fD,
		function(sendToApp, initialModel) {
			var view = impl.fT;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ew,
		impl.fP,
		impl.fD,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.bG && impl.bG(sendToApp)
			var view = impl.fT;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dI);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.fK) && (_VirtualDom_doc.title = title = doc.fK);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.e0;
	var onUrlRequest = impl.e1;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		bG: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.c_ === next.c_
							&& curr.co === next.co
							&& curr.cT.a === next.cT.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ew: function(flags)
		{
			return A3(impl.ew, flags, _Browser_getUrl(), key);
		},
		fT: impl.fT,
		fP: impl.fP,
		fD: impl.fD
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { en: 'hidden', dP: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { en: 'mozHidden', dP: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { en: 'msHidden', dP: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { en: 'webkitHidden', dP: 'webkitvisibilitychange' }
		: { en: 'hidden', dP: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		c7: _Browser_getScene(),
		dr: {
			dv: _Browser_window.pageXOffset,
			dw: _Browser_window.pageYOffset,
			dt: _Browser_doc.documentElement.clientWidth,
			cm: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		dt: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		cm: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			c7: {
				dt: node.scrollWidth,
				cm: node.scrollHeight
			},
			dr: {
				dv: node.scrollLeft,
				dw: node.scrollTop,
				dt: node.clientWidth,
				cm: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			c7: _Browser_getScene(),
			dr: {
				dv: x,
				dw: y,
				dt: _Browser_doc.documentElement.clientWidth,
				cm: _Browser_doc.documentElement.clientHeight
			},
			ea: {
				dv: x + rect.left,
				dw: y + rect.top,
				dt: rect.width,
				cm: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.eO) { flags += 'm'; }
	if (options.dO) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$GT = 2;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.l) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.n),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.n);
		} else {
			var treeLen = builder.l * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.o) : builder.o;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.l);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.n) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.n);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{o: nodeList, l: (len / $elm$core$Array$branchFactor) | 0, n: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$HeadPort$sendHead = _Platform_outgoingPort(
	'sendHead',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'favicon',
					$elm$json$Json$Encode$string($.ei)),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string($.fK))
				]));
	});
var $author$project$View$viewFavicon = F2(
	function (assets, display) {
		return display.c9 ? assets.bv.fp : assets.bv.fb;
	});
var $author$project$View$Resume$viewResumePageName = function (data) {
	return data.bV.cD + '’s resume';
};
var $author$project$View$viewTitle = F2(
	function (data, display) {
		return display.c9 ? $author$project$View$Resume$viewResumePageName(data) : (data.bV.cD + '’s portfolio homepage');
	});
var $author$project$View$viewHead = F2(
	function (data, _v0) {
		var assets = _v0.bR;
		var display = _v0.b8;
		return {
			ei: A2($author$project$View$viewFavicon, assets, display),
			fK: A2($author$project$View$viewTitle, data, display)
		};
	});
var $author$project$View$alsoViewHead = F2(
	function (data, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$HeadPort$sendHead(
						A2($author$project$View$viewHead, data, model))
					])));
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ci: fragment, co: host, cQ: path, cT: port_, c_: protocol, c$: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Navigation$initScroll = _Platform_outgoingPort(
	'initScroll',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$initCmd = $author$project$Navigation$initScroll(0);
var $author$project$Assets$initAssets = function (flags) {
	return {bv: flags.bv, by: flags.by};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Details$getDetails = F6(
	function (itemURLSelector, capitalizeName, noun, item, previousItem, nextItem) {
		var itemURLPart = function (part) {
			return A2(
				$elm$core$Maybe$andThen,
				part,
				itemURLSelector(item));
		};
		return {
			b_: capitalizeName,
			cn: itemURLPart(
				function ($) {
					return $.cn;
				}),
			cs: item.d3,
			cD: item.cD,
			cI: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cD;
				},
				nextItem),
			cK: noun,
			cS: item.d5,
			cV: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cD;
				},
				previousItem),
			dd: itemURLPart(
				function ($) {
					return $.dd;
				})
		};
	});
var $elm$core$List$map3 = _List_map3;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Data$Details$allDetailsItems = function (data) {
	var convert = F3(
		function (sectionSelector, itemsSelector, transform) {
			var section = sectionSelector(data);
			var items = itemsSelector(section);
			return A4(
				$elm$core$List$map3,
				transform(section.d4),
				items,
				_Utils_ap(
					_List_fromArray(
						[$elm$core$Maybe$Nothing]),
					A2($elm$core$List$map, $elm$core$Maybe$Just, items)),
				_Utils_ap(
					A2(
						$elm$core$List$drop,
						1,
						A2($elm$core$List$map, $elm$core$Maybe$Just, items)),
					_List_fromArray(
						[$elm$core$Maybe$Nothing])));
		});
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A3(
				convert,
				function ($) {
					return $.du;
				},
				function ($) {
					return $.ff;
				},
				A2(
					$author$project$Data$Details$getDetails,
					$elm$core$Basics$always($elm$core$Maybe$Nothing),
					false)),
				A3(
				convert,
				function ($) {
					return $.cA;
				},
				function ($) {
					return $.bA;
				},
				A2(
					$author$project$Data$Details$getDetails,
					$elm$core$Basics$always($elm$core$Maybe$Nothing),
					true)),
				A3(
				convert,
				function ($) {
					return $.dl;
				},
				function ($) {
					return $.bA;
				},
				F2(
					function (detailsNoun, item) {
						return A4(
							$author$project$Data$Details$getDetails,
							$elm$core$Basics$always($elm$core$Maybe$Nothing),
							!A2($elm$core$List$member, item.cD, data.dl.eQ),
							detailsNoun,
							item);
					})),
				A3(
				convert,
				function ($) {
					return $.cY;
				},
				function ($) {
					return $.bA;
				},
				A2($author$project$Data$Details$getDetails, $elm$core$Maybe$Just, false))
			]));
};
var $author$project$Display$initDisplay = F2(
	function (flags, data) {
		return {
			b6: $elm$core$Maybe$Nothing,
			b7: $author$project$Data$Details$allDetailsItems(data),
			c9: flags.el === 'resume'
		};
	});
var $author$project$Model$initModel = F2(
	function (data, flags) {
		return {
			bR: $author$project$Assets$initAssets(flags),
			b8: A2($author$project$Display$initDisplay, flags, data)
		};
	});
var $author$project$Model$init = F2(
	function (data, flags) {
		return _Utils_Tuple2(
			A2($author$project$Model$initModel, data, flags),
			$author$project$Model$initCmd);
	});
var $author$project$Data$Basic$homepageURL = 'https://dcecile.github.io';
var $author$project$MarkedString$NormalSubstring = function (a) {
	return {$: 0, a: a};
};
var $author$project$MarkedString$SpecialSubstring = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$MarkedString$markedString = function () {
	var loop = function (index) {
		return (!A2($elm$core$Basics$modBy, 2, index)) ? $author$project$MarkedString$NormalSubstring : $author$project$MarkedString$SpecialSubstring;
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$split('`'),
		$elm$core$List$indexedMap(loop));
}();
var $author$project$Data$Basic$sourceURL = 'https://github.com/dcecile/dcecile-resume-portfolio';
var $author$project$Data$Basic$initBasicData = {
	b3: 'Canada (remote, Eastern Time)',
	cd: 'dancecile@gmail.com',
	cn: $author$project$Data$Basic$homepageURL,
	cz: 'https://calendly.com/dancecile/virtual-30',
	cD: 'Dan Cecile',
	cU: _List_fromArray(
		['I have more than 14 years of experience making high quality software. This includes expertise in a wide variety of technologies, but I’m always open to learning new programming languages, frameworks, and services. And regardless of the tech stack, I maintain an emphasis on software engineering best practices and effective communication.', 'In my projects, I take ambiguous problem definitions, and work with stakeholders to develop innovative and practical solutions. It’s an iterative process that includes structured brainstorming, successive refinement, frequent releases, and regular check-ins. For quality control along the way, I take advantage of continuous integration, code reviews, unit tests, and static analysis. By the time I’m done, I am proud of my work and stakeholders are confident that the problem is solved.', 'I look forward to the opportunity to learn, to improve my skills, and to bring positive customer impact. I am committed to mentoring and helping out wherever I can, so that as a team we can grow together and ship some great software.', 'Outside of work, I find my bliss spending time with my family, lost in library book stacks, and skating the city on my rollerblades.']),
	cZ: 'he/him',
	c0: _Utils_Tuple2('“To love the plateau is to love what is most essential and enduring in your life.”', 'George Leonard (Mastery)'),
	c4: $author$project$MarkedString$markedString('I have `14+ years of experience` making high quality software, with an emphasis on best practices and effective communication. I’m dedicated to the success of my team through learning, mentoring, and constant iteration.'),
	dc: $elm$core$Maybe$Just('https://git.io/dcecile-resume'),
	dd: $author$project$Data$Basic$sourceURL,
	dk: 'Senior Full-Stack Software Engineer'
};
var $author$project$Data$Education$initEducationData = {cD: 'University of Waterloo', de: 'Bachelor of Computer Science (Co-op, Graduated with Distinction)'};
var $author$project$Data$Links$LinksItemData = F4(
	function (name, iconBackground, url, shortURL) {
		return {eq: iconBackground, cD: name, fA: shortURL, fR: url};
	});
var $author$project$Data$Links$initLinksData = function () {
	var twitter = A4(
		$author$project$Data$Links$LinksItemData,
		'Twitter',
		function ($) {
			return $.fM;
		},
		'https://twitter.com/dancecile',
		$elm$core$Maybe$Nothing);
	var linkedin = A4(
		$author$project$Data$Links$LinksItemData,
		'LinkedIn',
		function ($) {
			return $.eF;
		},
		'https://www.linkedin.com/in/dancecile/',
		$elm$core$Maybe$Just('https://linkedin.com/in/dancecile'));
	var github = A4(
		$author$project$Data$Links$LinksItemData,
		'GitHub',
		function ($) {
			return $.ek;
		},
		'https://github.com/dcecile',
		$elm$core$Maybe$Nothing);
	return {
		ff: _List_fromArray(
			[github, linkedin, twitter]),
		c5: _List_fromArray(
			[linkedin, github])
	};
}();
var $author$project$Data$Mindsets$MindsetsItemData = F3(
	function (name, detailsIntro, detailsPoints) {
		return {d3: detailsIntro, d5: detailsPoints, cD: name};
	});
var $author$project$Data$Mindsets$initMindsetsData = function () {
	var teaching = A3(
		$author$project$Data$Mindsets$MindsetsItemData,
		'teaching',
		$author$project$MarkedString$markedString('I help others learn by breaking complex topics down into pieces that they understand:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('At `Meya`, I onboarded other developers to our `React` and `Flutter` chat SDKs, and provided mentoring throughout projects (including `code review`)'),
				$author$project$MarkedString$markedString('At `Sonova`, I used my knowledge of related business and software systems to teach others how to avoid bugs and perform more thorough `testing`'),
				$author$project$MarkedString$markedString('At `Sonova`, I used code reviews as teaching opportunities, to help my teammates improve their `C#` code maintainability'),
				$author$project$MarkedString$markedString('At `NexJ Systems` with bugfix `pair programming`, I taught my partner to see the causes and effects that I saw'),
				$author$project$MarkedString$markedString('As a volunteer makerspace assistant, I taught kids the skills required to succeed at (and enjoy) each maker activity')
			]));
	var making = A3(
		$author$project$Data$Mindsets$MindsetsItemData,
		'making',
		$author$project$MarkedString$markedString('The reason I’m a software developer is because I enjoy making ideas come alive as working software:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('At `Meya`, I helped make a chatbot platform in `Python` and `TypeScript`, pushing the boundaries of conversational user experience and striving to provide an excellent developer experience'),
				$author$project$MarkedString$markedString('At `Sonova`, I made manufacturing software in `C#`—by listening for details hidden behind rough wishes, then building solutions to fit the needs and the context'),
				$author$project$MarkedString$markedString('With `Off-Grid Orcs`, I created an HTML Canvas `Scala` game—from concept to release—during a 17-day game jam'),
				$author$project$MarkedString$markedString('With `Forks in the Road`, I’m making a Rails + `React` web app that helps users make decisions via probability-based value estimation'),
				$author$project$MarkedString$markedString('With `My Portfolio and Resume`, I turned my simple sketches into multi-element, animated `SVG` illustrations')
			]));
	var learning = A3(
		$author$project$Data$Mindsets$MindsetsItemData,
		'learning',
		$author$project$MarkedString$markedString('My curiosity and my passion for `improving` my work motivate me to always continue learning:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('At `Meya`, I learned how to put my web dev skills into action at a large scale SaaS platform and picked up many new technologies along th way'),
				$author$project$MarkedString$markedString('At `Sonova`, I learned the keys to effective communication in a large, geographically-distributed organization'),
				$author$project$MarkedString$markedString('In `Forks in the Road`, I learned how to use JWT authentication for an API-only Rails app'),
				$author$project$MarkedString$markedString('In `Off-Grid Orcs`, I learned how to apply a `functional programming` architecture to a real-time `Scala` strategy game'),
				$author$project$MarkedString$markedString('In `Yomikata`, I learned how to use multiple processes and `threads` in C++, to give a smooth user experience while loading images')
			]));
	var improving = A3(
		$author$project$Data$Mindsets$MindsetsItemData,
		'improving',
		$author$project$MarkedString$markedString('When I work on a project, I always look for potential improvements that have good cost/benefit value:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('At `Meya`, I incorporated team feedback at all stages to improve my projects: from kickoff to demos, to `code review`'),
				$author$project$MarkedString$markedString('Also at `Meya`, I continually improved our internal developer tools and our `continuous integration & deployment` processes based'),
				$author$project$MarkedString$markedString('At `Sonova`, I listened for pain points in our daily work, and led improvements to development and QA team processes'),
				$author$project$MarkedString$markedString('In `Ultra Rainbow Bake Sale`, I listened to player feedback, and created dynamic hints to improve the experience for new players')
			]));
	var coordinating = A3(
		$author$project$Data$Mindsets$MindsetsItemData,
		'coordinating',
		$author$project$MarkedString$markedString('As a Senior Software Developer at `Sonova`, I helped keep everyone on the same page:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I worked with developers, QA, and project management to coordinate software release milestones'),
				$author$project$MarkedString$markedString('I worked on-site with production managers to negotiate and coordinate custom software solutions'),
				$author$project$MarkedString$markedString('I worked with developers and technical support to coordinate patch releases'),
				$author$project$MarkedString$markedString('I clearly documented all findings, discussions, action items, and status information in our issue tracking system'),
				$author$project$MarkedString$markedString('I used a custom spreadsheet plus reports from our issue tracking system to manage and communicate timelines')
			]));
	var analyzing = A3(
		$author$project$Data$Mindsets$MindsetsItemData,
		'analyzing',
		$author$project$MarkedString$markedString('At `Sonova`, my team often encountered questions that could only be answered by analyzing production data. Using a combination of `SQL` and Excel,'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I researched the value of maintaining software solutions vs. the cost of setting up manual workarounds'),
				$author$project$MarkedString$markedString('I investigated the hardware component causes of firmware bugs'),
				$author$project$MarkedString$markedString('I communicated my findings using easy-to-understand tables, charts, and summaries'),
				$author$project$MarkedString$markedString('I created reports and internal tools to help others carry out their own analysis tasks'),
				$author$project$MarkedString$markedString('I expanded `testing` coverage using real-world test cases')
			]));
	return {
		dB: analyzing,
		dW: coordinating,
		d4: 'mindset',
		er: 'mindsets',
		eu: improving,
		bA: _List_fromArray(
			[making, learning, teaching, analyzing, coordinating, improving]),
		eC: learning,
		eH: making,
		cD: 'Mindsets',
		fd: function ($) {
			return $.eg;
		},
		fe: 'Because I see building software as more than just writing code, I use all of these mindsets as I work:',
		fh: $elm$core$Maybe$Nothing,
		fH: teaching
	};
}();
var $author$project$Data$Visibility$ElmResume = 1;
var $author$project$Data$Visibility$GeneralResume = 0;
var $author$project$Data$Visibility$GoResume = 2;
var $author$project$Data$Projects$ProjectsItemData = function (name) {
	return function (shortName) {
		return function (period) {
			return function (tech) {
				return function (description) {
					return function (homepageURL) {
						return function (sourceURL) {
							return function (detailsIntro) {
								return function (detailsPoints) {
									return function (visibility) {
										return {d2: description, d3: detailsIntro, d5: detailsPoints, cn: homepageURL, cD: name, e6: period, fz: shortName, dd: sourceURL, dl: tech, fU: visibility};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Visibility$portfolioAndResume = $elm$core$Basics$identity;
var $author$project$Data$Visibility$portfolioOnly = _List_Nil;
var $author$project$Data$Projects$initProjectsData = {
	d4: 'project',
	er: 'projects',
	bA: _List_fromArray(
		[
			$author$project$Data$Projects$ProjectsItemData('Pentagram')($elm$core$Maybe$Nothing)('2010–present')('Python / FP')('RPN programming language')($elm$core$Maybe$Nothing)(
			$elm$core$Maybe$Just('https://github.com/pentagram-lang'))(
			$author$project$MarkedString$markedString('I’m `making` a programming language, inspired by learning Haskell and finding out about concatenative languages. It’s still largely in the design phase, and I’ve gone through multiple evolutions in my approach.'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('The current interpreter is written in `Python`, using stages of `functional programming` transformations to get from input text to runnable code'),
					$author$project$MarkedString$markedString('My next milestone is to interpret in-language unit `testing`, so I can start writing a prelude that’s tested with `continuous integration & deployment`')
				]))(
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[2]))),
			$author$project$Data$Projects$ProjectsItemData('Fertile Earth')($elm$core$Maybe$Nothing)('2021–present')('TypeScript / Rust')('Forum web app with FTS')($elm$core$Maybe$Nothing)(
			$elm$core$Maybe$Just('https://github.com/dcecile/fertile-earth'))(
			$author$project$MarkedString$markedString('I’ve started `making` a forum web app, to experiment with new back-end and front-end technologies.'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('It uses custom HTML and `CSS` `domain-specific languages` written in `TypeScript` for the front-end'),
					$author$project$MarkedString$markedString('The back-end is split into `Node.js` app and Rust full-text search services'),
					$author$project$MarkedString$markedString('All `TypeScript` code is executed as ES Modules, with hot reloading powered by esbuild'),
					$author$project$MarkedString$markedString('The data layer uses CockroachDB (distributed, `PostgreSQL`-compatible), `Redis` (caching), and Tantivy (full-text search)'),
					$author$project$MarkedString$markedString('I’ve set up GitHub Actions `continuous integration & deployment` to release to Fly.io with each commit that passes unit `testing`')
				]))(
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 1]))),
			$author$project$Data$Projects$ProjectsItemData('Forks in the Road')($elm$core$Maybe$Nothing)('2018')('React / Rails')('Value estimation web app')(
			$elm$core$Maybe$Just('https://forks-in-the-road.herokuapp.com/'))(
			$elm$core$Maybe$Just('https://github.com/dcecile/forks-in-the-road'))(
			$author$project$MarkedString$markedString('In 2018, to improve my web dev skills, I was `making` a web app that helps users make data-informed decisions. It estimates expected values based on user-specified probabilities, and its first task is helping me pick the companies that I want to apply to for my job search.'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I used Ruby and Rails for the back-end (`PostgreSQL` database), with GitHub-based JWT authentication'),
					$author$project$MarkedString$markedString('I used `React` and `JavaScript` for the front-end, with an emphasis on `functional programming`'),
					$author$project$MarkedString$markedString('I used Sass to simplify `CSS` syntax, Bootstrap for base styling, and `functional animation` for every state change'),
					$author$project$MarkedString$markedString('I set up Semaphore `continuous integration & deployment` to release to Heroku with each commit that passes unit `testing`')
				]))(
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 1]))),
			$author$project$Data$Projects$ProjectsItemData('Off-Grid Orcs')($elm$core$Maybe$Nothing)('2017')('Scala.js / FP')('64x64 pixel web game')(
			$elm$core$Maybe$Just('https://dcecile.itch.io/off-grid-orcs'))(
			$elm$core$Maybe$Just('https://github.com/dcecile/off-grid-orcs'))(
			$author$project$MarkedString$markedString('In 2017, I joined a 17-day game jam, and created this pixel-art, real-time strategy HTML game using `Scala` and Scala.js:'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I made a simple software rendering engine that uploads image data directly to the HTML5 Canvas'),
					$author$project$MarkedString$markedString('I used this rendering engine to create my 64x64 pixel `visual design`'),
					$author$project$MarkedString$markedString('I implemented a goal-based, pathfinding AI for orcs to gather resources and construct buildings'),
					$author$project$MarkedString$markedString('I designed a custom font, and converted it to TTF format for outside-game-use via `bitfontmake`'),
					$author$project$MarkedString$markedString('I used a `functional programming` architecture that transforms immutable data every frame')
				]))(
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 1]))),
			$author$project$Data$Projects$ProjectsItemData('bitfontmake')($elm$core$Maybe$Nothing)('2017')('Python / UFO')('Bitmap font compiler')($elm$core$Maybe$Nothing)(
			$elm$core$Maybe$Just('https://github.com/dcecile/bitfontmake'))(
			$author$project$MarkedString$markedString('After creating a custom pixel-based font for `Off-Grid Orcs`, I decided to use `Python` to export that font to vector-based TTF:'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I learned how TTF and UFO font formats work'),
					$author$project$MarkedString$markedString('I designed and implemented a custom image-based font specification format, which I documented in a `technical requirements` Markdown file'),
					$author$project$MarkedString$markedString('I converted pixels into vector glyph contours—and together with the correct metadata, I created a working TTF font file'),
					$author$project$MarkedString$markedString('I turned my Python code into a Flask application and deployed it to Heroku')
				]))(
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[2]))),
			$author$project$Data$Projects$ProjectsItemData('Yomikata')($elm$core$Maybe$Nothing)('2007–2009')('C++ / Qt')('Snappy desktop manga reader')($elm$core$Maybe$Nothing)(
			$elm$core$Maybe$Just('https://github.com/dcecile/yomikata-qt'))(
			$author$project$MarkedString$markedString('From 2007 to 2009 I worked to create a Qt comics and manga reader using C++:'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I used processes and `threads` to unpack and decode images in the background'),
					$author$project$MarkedString$markedString('I used unit `testing` to verify my page turning logic (complicated by the presence of spread pages)'),
					$author$project$MarkedString$markedString('I used a full-screen `functional animation` during image loading to provide user feedback')
				]))($author$project$Data$Visibility$portfolioOnly),
			$author$project$Data$Projects$ProjectsItemData('Ultra Rainbow Bake Sale')(
			$elm$core$Maybe$Just('URBS'))('2016')('Lua / LÖVE')('Deck building + baking game')(
			$elm$core$Maybe$Just('https://dcecile.itch.io/ultra-rainbow-bake-sale'))(
			$elm$core$Maybe$Just('https://github.com/dcecile/ultra-rainbow-bake-sale'))(
			$author$project$MarkedString$markedString('In 2016, I had an idea for a deck-building baking game, and brought it to life with the `Lua`, the LÖVE game development library, and lots of listening to players:'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I started with a simple implementation—gradually adding features informed by feedback from friends and forum users'),
					$author$project$MarkedString$markedString('I learned a new style of programming: prototype-based OOP'),
					$author$project$MarkedString$markedString('I used `functional animation` to give the game an element of juiciness'),
					$author$project$MarkedString$markedString('I implemented an AI-like dynamic hints system using a sequence of play conditions and suggestions')
				]))($author$project$Data$Visibility$portfolioOnly),
			$author$project$Data$Projects$ProjectsItemData('My Portfolio and Resume')(
			$elm$core$Maybe$Just('(This website)'))('2018–present')('Elm / CSS')('Interactive skills showcase')(
			$elm$core$Maybe$Just($author$project$Data$Basic$homepageURL))(
			$elm$core$Maybe$Just($author$project$Data$Basic$sourceURL))(
			$author$project$MarkedString$markedString('For my 2018 job search, I decided to create a GitHub homepage to host my portfolio and my resume:'))(
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I use `CSS` (via an `Elm` DSL) for the `visual design`—screen, print, `responsive design`, and `functional animation`'),
					$author$project$MarkedString$markedString('I use `Elm`’s `functional programming` architecture to transform immutable data during state changes and display it as HTML'),
					$author$project$MarkedString$markedString('I use `Elm` to construct custom `SVG` illustrations, which I style and animate via `CSS`'),
					$author$project$MarkedString$markedString('I use GitHub Actions `continuous integration & deployment` for unit `testing`, style tests, and release to GitHub Pages')
				]))(
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[1])))
		]),
	cD: 'Side projects',
	fd: function ($) {
		return $.em;
	},
	fe: 'In my spare time, I’ve been working on a few of my own software ideas. Come take a look!',
	fh: $elm$core$Maybe$Nothing
};
var $author$project$Data$Startup$initStartupData = {
	d4: 'skill',
	er: 'startup',
	bA: _List_fromArray(
		['active listening', 'async', 'collaboration', 'continuous improvement', 'curiosity', 'customer success', 'learning on-the-fly', 'mentoring', 'nondualism', 'ownership', 'product thinking', 'shipping', 'tenacity']),
	cD: 'Startup skills',
	fd: function ($) {
		return $.dJ;
	},
	fe: '...',
	fh: $elm$core$Maybe$Nothing
};
var $author$project$Data$Tech$TechItemData = F5(
	function (name, shortName, detailsIntro, detailsPoints, visibility) {
		return {d3: detailsIntro, d5: detailsPoints, cD: name, fz: shortName, fU: visibility};
	});
var $author$project$Data$Tech$initTechData = {
	d4: 'skill',
	er: 'tech',
	bA: _List_fromArray(
		[
			A5(
			$author$project$Data$Tech$TechItemData,
			'Amazon Web Services',
			$elm$core$Maybe$Just('AWS'),
			$author$project$MarkedString$markedString('At `Meya`, our `Python` chatbot platform was originally built for and hosted on AWS.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I set up a CloudWatch `monitoring` dashboard, tied to alerts and including custom metrics'),
					$author$project$MarkedString$markedString('I helped debug and resolve issues related to DynamoDB and ElastiCache (`Redis`) load'),
					$author$project$MarkedString$markedString('I set up a new `Docker`-based, `Node.js` ECS service that used ALB sticky sessions'),
					$author$project$MarkedString$markedString('I tuned our EC2 autoscaling rules to optimize costs while maintaining platform stability and low latency')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'bug reporting',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Writing clear and informative bug reports is a key skill for any member of a software development team. It’s one that I’ve been practising since my second internship:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Coreworx`, during my time helping QA with testing, I learned the keys to effective bug reporting'),
					$author$project$MarkedString$markedString('At `Sonova`, I continued to work at `improving` my bug reporting as I logged bugs for software components maintained by other teams'),
					$author$project$MarkedString$markedString('At `Sonova`, I regularly triaged my team’s bugs, and spent time `teaching` others what to fix for unclear bug reports'),
					$author$project$MarkedString$markedString('At `Meya`, I converted customer problem reports into clear and actionable bug reports for our team to resolve')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'C#',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('By now, I’ve read and written more code in .NET’s C# than in any other programming language. I have a solid grasp of advanced features like LINQ, reflection, code generation, and generics. I know how to write good, maintainable C#.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Coreworx`, I first used C# to add features to an ASP.NET document management system'),
					$author$project$MarkedString$markedString('At `Sonova`, I used C# for 8 years as I implemented and maintained manufacturing subsystems'),
					$author$project$MarkedString$markedString('At `Sonova`, I used C# together with `SQL` to create internal tools focused on `improving` development and QA processes'),
					$author$project$MarkedString$markedString('At `Sonova`, I used C# `threads` and async/await to build WinForms apps that don’t freeze during extended network and CPU tasks')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'continuous integration & deployment',
			$elm$core$Maybe$Just('CI/CD'),
			$author$project$MarkedString$markedString('I have a strong interest in build systems and continuous integration and deployment:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('Starting at `LSI Logic`, and continuing at `NexJ Systems`, `Sonova`, and `Meya`, I’ve made build systems improvements for maintainability and productivity'),
					$author$project$MarkedString$markedString('At `Meya`, I set up continuous deployment that included `Kubernetes` rolling deployment upgrades, `React` builds, and `Google Cloud Platform` cloud storage uploads'),
					$author$project$MarkedString$markedString('For all my recent projects (incluing at `Meya` and in `Pentagram` and `My Portfolio and Resume`), I’m using GitHub Actions for CI/CD, taking advantage of PR status reporting, caching, and branch-conditional steps')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'code review',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('With my teams at `Meya` and `Sonova`, every change required code review approval before merging in `version control`:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('This offers excellent opportunities for `learning` and `teaching` about code maintainability as well as specific software features, components, and technologies'),
					$author$project$MarkedString$markedString('Diligently using code reviews was a key step in `improving` the quality of our software'),
					$author$project$MarkedString$markedString('We found that the time spent on reviews was a net positive for our team’s productivity')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'CSS',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('These days, my primary tool for `visual design` is CSS, for making HTML web applications:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I used CSS with `React` to build our chat UI SDK, developer web console, and new company website'),
					$author$project$MarkedString$markedString('At `Sonova`, I used CSS to implement a hybrid HTML desktop app according to initial mockups'),
					$author$project$MarkedString$markedString('In `Forks in the Road`, I leveraged my Qt experience to set up CSS flexbox layouts'),
					$author$project$MarkedString$markedString('In `My Portfolio and Resume` and `Meya`, I used media queries for `responsive design`'),
					$author$project$MarkedString$markedString('With `Forks in the Road`, I began `learning` how to do `functional animation` with CSS3 transitions and animations')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 1]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'data analysis',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('At `Sonova`, I used Excel together with `SQL` for `analyzing` data:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I used pivot tables and pivot charts to explore trends and correlations'),
					$author$project$MarkedString$markedString('I copied table and chart summaries into emails—to help communicate the data to managers'),
					$author$project$MarkedString$markedString('I linked data directly to `SQL` tables and views, to create live reports'),
					$author$project$MarkedString$markedString('I imported data into Microsoft’s Power BI for more advanced drill-down reporting')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'debugging',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('A core software developer skill, I approach debugging as an exiting puzzle to solve, no matter how challenging.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I debugged complex customer issues using `log tracing` and clearly communicated my findings, whether that included customer fixes, workarounds, or bugfixes on our side'),
					$author$project$MarkedString$markedString('At `Sonova`, I debugged manufacturing issues with the help of `data analysis` which resulted in manufacturing process and QC changes'),
					$author$project$MarkedString$markedString('At `LSI Logic`, I worked on a visual debugger capable of visually highlighting how a video was encoded')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Django',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('The SaaS business logic at `Meya` was all written in this `Python` web framework, so I am very comfortable with Django after `learning` and using it for more than 4 years.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('We used Celery for scheduling periodic and delayed tasks'),
					$author$project$MarkedString$markedString('We used Graphene-Django for serving `GraphQL` requests and Django REST framework for `REST` requests')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Docker',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Although I have some experience running desktop VMs and EC2 VMs on `Amazon Web Services`, `Linux` Docker images have been great for `making` back-end software.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, we used Docker heavily, with a couple services runing on `Amazon Web Services` ECS and our new platform running entirely on `Google Cloud Platform` Kubernetes'),
					$author$project$MarkedString$markedString('I architected and set up our Docker image build pipeline at `Meya` for running customer apps, using Kaniko inside of `Kubernetes`, dynamically generated Dockerfiles, and an init container that checks out code from `Git`'),
					$author$project$MarkedString$markedString('With `Fertile Earth`, I set up Docker images for running `Node.js`, Rust, and `Redis` services on Fly.io')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'domain-specific languages',
			$elm$core$Maybe$Just('DSLs'),
			$author$project$MarkedString$markedString('I have experience both using and creating DSLs:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I wrote the parser and interpreter for our YAML / Jinja workflow language, including labeled jumps, tail calls, static checks, and encryption/decryption filters'),
					$author$project$MarkedString$markedString('At `NexJ Systems`, I used an in-house Scheme DSL with my work on the CRM user interface and business logic'),
					$author$project$MarkedString$markedString('At `Sonova`, I created a `C#` DSL for specifying related test plans—to improve maintainability and to track history in `version control`'),
					$author$project$MarkedString$markedString('With `My Portfolio and Resume` and `Fertile Earth`, I’m using `Elm` and `TypeScript` DSLs for writing HTML and `CSS` code')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Elm',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Elm is a front-end framework and `functional programming` language that I’m `learning` as I make `My Portfolio and Resume`.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[1]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'event streams',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Using an event-oriented architecture was key to `scale` and `security` of the `Meya` v2 platform I worked on. We used event streams to represent all runtime \'happenings\', from user events to bot flow calls to log entries, and emergent benefits were excellent. `Redis` Streams also turned out to be a great match for `WebSockets` used for live client updates.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Flutter',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Although the `Meya` web chat UI was written in `React`, we decided Flutter would be a better fit for our mobile UI. I handled some of the initial project setup (including `WebSockets`), and implemented multiple features in Flutter to maintain web/mobile parity.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'functional programming',
			$elm$core$Maybe$Just('FP'),
			$author$project$MarkedString$markedString('I use this programming style because it helps me cleanly extract sub-problems:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `NexJ Systems`, I had my first, basic introduction to functional programming as I used Scheme for fixing bugs and unit `testing`'),
					$author$project$MarkedString$markedString('At `Sonova`, functional programming made `test-driven development` easier to apply for a test run comparison `C#` GUI app'),
					$author$project$MarkedString$markedString('In `My Portfolio and Resume`, functional programming helps keep my `Elm` code well-organized, and makes refactoring a breeze'),
					$author$project$MarkedString$markedString('In `Off-Grid Orcs`, functional programming helped prevent newly-implemented `Scala` features from breaking existing functionality')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 1, 2]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'functional animation',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Functional animation helps me remove surprise from my UIs during state changes:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I used Frame Motion animations in `React` to make the UI feel responsive as new conversational events happen'),
					$author$project$MarkedString$markedString('In `Ultra Rainbow Bake Sale`, I used functional animation in `Lua` to give the game a more lively feel'),
					$author$project$MarkedString$markedString('In `Forks in the Road`, I use functional animation for all `React` page changes and form actions')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Gatling',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Our tool of choice at `Meya` for load `testing` was Gatling. We ran it from an isolated pod in our `Kubernetes` cluster, and it helped me test `scale`-up surge scenarios and memory leak fixes.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Git',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('The new de facto standard `version control` system, I use it for all my new projects. At `Meya`, we also used it to store customer code and sync between server, CLI (using pygit2 in `Python`), and web console (using isomorphic-git in `JavaScript`).'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'GraphQL',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('To improve the dev loop speed for our web console at `Meya`, we used a GraphQL API for all our data access. I worked with the Apollo `JavaScript` and sgqlc `Python` clients and the Graphene-`Django` and aiohttp-graphql `Python` servers.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Google Cloud Platform',
			$elm$core$Maybe$Just('GCP'),
			$author$project$MarkedString$markedString('In my work at `Meya`, I became very familiar with GCP, `learning` and using my different services:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I deployed releases to Google `Kubernetes` Engine, `debugging` and `monitoring` as needed with the K9s terminal'),
					$author$project$MarkedString$markedString('I set up static hosting and secure user uploads using Google Cloud Storage'),
					$author$project$MarkedString$markedString('I investigated customer issues by `log tracing` in Cloud Logging, writing queries in GQL')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'integration',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Glue code, value add, whatever you call it, I have experience `making` high quality integrations:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya` with `Python`, I integrated our `event streams` with other messaging and customer service platforms using `REST` APIs and webhooks'),
					$author$project$MarkedString$markedString('At `Sonova` with `C#`, our team was integrated libraries and applications from other teams to deploy to manufacturing environments for configuring and `testing` hearing instruments'),
					$author$project$MarkedString$markedString('WIth `Yomikata` with C++, I integrated the 7-Zip executable over ICP for working with archive files')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'internationalization & localization',
			$elm$core$Maybe$Just('i18n & l10n'),
			$author$project$MarkedString$markedString('I’m passionate about languages, so `learning` and diving into i18n & l10n has felt like a natural progression for my dev career:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I enabled customers to use gettext in `Python` and our custom YAML language to add translations to their apps hosted in our `Kubernetes` cluster'),
					$author$project$MarkedString$markedString('On my team at `Sonova`, I was in charge of our translation processes—this included converting our apps to support translations and managing all of our translation tools and processes, `coordinating` translator activities for up to 14 languages')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'JavaScript',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I use JavaScript and `TypeScript` for most of my front-end development (including modern language features like modules, await, and classes):'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I used JavaScript to build the developer web console, including a visual flow editor powered by `SVG`'),
					$author$project$MarkedString$markedString('At `Sonova`, I used JavaScript for the UI logic of a hybrid HTML and `C#` desktop app'),
					$author$project$MarkedString$markedString('In `Forks in the Road`, I used JavaScript with `React` for the front-end of my value estimation web app')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Kubernetes',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('At `Meya`, Kubernetes was a perfect for the `scale` and `security` we needed to run customer apps.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I set up a `Docker` image build pipeline using Kaniko jobs'),
					$author$project$MarkedString$markedString('I designed services and deployments that spanned our console, gateway, and customer app'),
					$author$project$MarkedString$markedString('I used init containers to pull dev app code from `Git` for faster live coding'),
					$author$project$MarkedString$markedString('I used RBAC and service accounts to follow the principle of least privilege, and enable access to `Google Cloud Platform` services'),
					$author$project$MarkedString$markedString('I did all my `debugging` using K9s and `Google Cloud Platform` `log tracing`')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Linux',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I’m comfortable working in Linux, having used it for my primary development environment since university:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I know my way around the command line (e.g. for `version control`, shell scripts, and personal system adminitration)'),
					$author$project$MarkedString$markedString('I troubleshoot my Linux system problems using system logs, application logs, man pages, GDB, Google searches, and bug searches'),
					$author$project$MarkedString$markedString('I’ve built a couple cross-platform desktop applications: `Ultra Rainbow Bake Sale` and `Yomikata`'),
					$author$project$MarkedString$markedString('(I also have lots of experience using and troubleshooting Windows)')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[2]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'log tracing',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Depending on the problem, an interactive debugger might not be the right tool and you’ve gotta go to the logs:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I traced logs in `Google Cloud Platform`, piecing together timelines with the help of ad hoc `SQL` queries'),
					$author$project$MarkedString$markedString('At `Sonova`, I traced logs across multiple desktop PCs to solve production issues')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Lua',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I finally learned Lua and used it with LÖVE (a 2D game development library) to build a single-player, deck-building, baking game: `Ultra Rainbow Bake Sale`. At `Meya`, I also used `Lua` in `Redis` to manipulate `event streams`, with unit `testing` driven from `Python`.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'monitoring',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Sometimes to verify software quality, you need data and graphs to really understand a system. At `Meya`, I used monitoring in `Amazon Web Services` and `Google Cloud Platform` for our production systems to debug and fix production issues, and set up alerts to protect against future regressions.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'nginx',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('At `Meya`, we used nginx together with `Django`. I set up ngnix reverse proxies to `Git` and Pypi services, secured using developer auth tokens.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Node.js',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Along with `Python` `Django` and aiohttp back-ends, I’m familiar with using `JavaScript` and `TypeScript` to write Node.js services.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I set up a Node.js `REST` endpoint to fetch data from our Prismic CMS for homepage content'),
					$author$project$MarkedString$markedString('At `Meya`, I implemented a `Docker` Node.js `integration` service to provide persistent access to a customer service platform'),
					$author$project$MarkedString$markedString('In `Fertile Earth`, the app back-end runs Node.js to allow sharing `TypeScript` code between client and server')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'pair programming',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('When working on especially complex or high-risk tasks, pair programming can be great productivity and QC tool. At `Meya` and `Sonova`, I also found it especially effective for `teaching` and mentoring.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'PostgreSQL',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Recently my `SQL` server of choice has been PostgreSQL, especially for its JSON support and concurrent index updates.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I regularly used ad hoc queries for investigating and `debugging` customer issues'),
					$author$project$MarkedString$markedString('At `Meya`, I built a custom AST transformer from Lucene syntax to windowed, index-aware PostgreSQL syntax (including deep JSON filters) in `Python`'),
					$author$project$MarkedString$markedString('With `Fertile Earth`, I connected to the distributed, PostgreSQL-compatible CockroachDB cloud service from `Node.js`')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'profiling',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('When working on `improving` performance, I use benchamrking together with profiling:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I used SnakeViz source-level profiling for `Python` to target improvements and greatly reduce platform latency'),
					$author$project$MarkedString$markedString('I also have experience using the Chrome Dev Tools profiler for both browser `JavaScript` and `Node.js`')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Python',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('When it comes to `making` back-end software, Python is now one of my top languages. I’m a big fan of data classes, type annotations, and Black formatting.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I used Python on a daily basis, coding `Kubernetes` services and adding features to our `Django` / `GraphQL` backend'),
					$author$project$MarkedString$markedString('My latest iteration of `Pentagram` is written in Python, with type annotations checked using Mypy'),
					$author$project$MarkedString$markedString('With `bitfontmake`, I used Python with UFO to compile my TTF fonts from a custom pixel-based input format, deployed to Heroku as a Flask app')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 2]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'React',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('React has been a great tool for making interactive web apps, and I espcially like how functional components encourage `functional programming` best practices:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I used React together with a number of libraries to build our chat UI and developer console: Framer Motion, Apollo `GraphQL` client, Styled Components, and Ant Design'),
					$author$project$MarkedString$markedString('With `Forks in the Road`, I used React to create the front-end of my value estimation web app'),
					$author$project$MarkedString$markedString('(I’ve also used Vue.js and `Elm` for creating HTML front-ends)')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0, 1, 2]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Redis',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('The simplicity and power of Redis encouraged us to power `Meya`’s `event streams` with Redis Streams. I also leveraged built-in `Lua` scripting to implement new atomic operations.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'responsive design',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('The promise of HTML web apps is that they’ll run in any modern browser. I use responsive design to make sure that mobile devices are included too:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I implement responsive design by using `CSS` media queries to progressively enabling more advanced styling for larger screens'),
					$author$project$MarkedString$markedString('I’ve set up responsive design for `My Portfolio and Resume`')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[1]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'REST',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('With `integration` work at `Meya`, I regularly wrote REST API client code, setting up `testing` using mocked payloads. I also implemented REST endpoints for integration webhooks and for compatibility with a legacy chat client.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'Scala',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I’ve enjoyed using Scala as a `functional programming` language:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('For a previous generation of my `Pentagram` programming language, I took advantage of support for `functional programming` from  of Scala’s type system and standard library'),
					$author$project$MarkedString$markedString('I used Scala.js to create `Off-Grid Orcs` as an HTML game with a `functional programming` architecture')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'scale',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('In my time at `Meya`, I’ve had the chance to code and manage software at scale, serving a high number of concurrent sessions with low latency.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I partipated in desigining our new `Google Cloud Platform` architecture, and scaling it up as new customers came online'),
					$author$project$MarkedString$markedString('I set up and tuned `Kubernetes` scale-up using `Gatling` tests and horizontal pod autoscaling')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'security',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('For most software, and especially web software, following best security practices is very important. This includes the proper use hashes and encryption.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I helped design our isolation model for running untrusted code in our `Kubernetes` cluster, and set up our sensitive data system using rotating encryption keys')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'SQL',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('At `Sonova`, I used `SQL` for `analyzing` data and creating internal development/QA tools:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I used Excel together with ad hoc SQL queries to investigate bugs and communicate my findings'),
					$author$project$MarkedString$markedString('I optimized my ad hoc SQL queries to run on large datasets that were initially impossible'),
					$author$project$MarkedString$markedString('I created an SQL data warehouse with materialized views, for analyzing trends that spanned multiple upstream DBs'),
					$author$project$MarkedString$markedString('I used `C#` and SQL via `continuous integration & deployment` for populating and `monitoring` the data warehouse'),
					$author$project$MarkedString$markedString('I used the SQL materialized views in internal development and QA tools, with `C#` and WinForms')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'SVG',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I use SVG in my HTML applications, and I know its capabilities (and limitations).'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Sonova`, I created an interactive SVG document (via the D3.js `JavaScript` library) for `teaching` our network topology of production/test servers and databases'),
					$author$project$MarkedString$markedString('At `Sonova`, I designed and used SVG icons for a hybrid HTML desktop app'),
					$author$project$MarkedString$markedString('For `Forks in the Road`, I began my `visual design` by creating SVG mockup in Inkscape'),
					$author$project$MarkedString$markedString('For `My Portfolio and Resume`, I created SVG illustrations in `Elm`—animating them using `CSS`')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'system architecture',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('Good system architecture takes into account current best practices, along with a strong understanding of business and technical requirements. At `Meya`, only after deeply `learning` from our team and our work was I able to help design our new platform for extensibility, `scale`, and `security`.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'test-driven development',
			$elm$core$Maybe$Just('TDD'),
			$author$project$MarkedString$markedString('I’ve done TDD and experienced its benefits for both `testing` and `making` software. (I’m still working at using it more often.)'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya` with `Python`, I used TDD when developing new `integration` elements, mocking out payloads and `event streams`'),
					$author$project$MarkedString$markedString('At `Sonova` with `C#`, I followed test-driven development to build a test run comparison tool'),
					$author$project$MarkedString$markedString('In `Pentagram` with `Scala`, I wrote an initial parser using TDD'),
					$author$project$MarkedString$markedString('In `Forks in the Road` with Ruby, I used TDD to add back-end functionality')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'testing',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('In `making` software, you’re alternative between coding, `debugging`, and testing, so it’s worth it to hone your testing skills. That includes writing automated unit or integration tests, as well as manual testing. Good `bug reporting` is also key when a bug needs to be fixed later or by another team.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I prepared detailed plans for migrations and tested them first on dev and staging `Kubernetes` clusters'),
					$author$project$MarkedString$markedString('At `Meya`, I set up unit testing patterns to allow running our core `Python` code against mocked `event streams`'),
					$author$project$MarkedString$markedString('At `Sonova`, my team was responsible for writing software that tested hearing instrument functionality and performance')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'technical requirements',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I’m comfortable using technical requirements documents as a communication medium:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I’ve used official specs to write software for H.264 video encoding/decoding (at `LSI Logic`), ANSI hearing instrument testing (at `Sonova`), and XMPP messaging'),
					$author$project$MarkedString$markedString('At `Sonova`, I wrote clear technical requirements that included contextual information, discussed trade-offs of different solutions, and provided enough detail for correct implementation'),
					$author$project$MarkedString$markedString('At `Sonova`, I used the technical requirements I’d written negotiating features and implementation details, `making` the software, and introducing the changes to QA'),
					$author$project$MarkedString$markedString('For `bitfontmake`, I wrote a technical specification to document my custom image-based font format')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'threads',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I know how to write correct multithreading code, and how to debug threading issues. Threads, mutexes, semaphores, condition variables, and barriers are all familiar tools for me.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Sonova` with `C#` and WinForms, I used async/await to build Windows desktop applications that perform long-running tasks on background threads'),
					$author$project$MarkedString$markedString('At `Sonova` with `C#`, I used Parallel LINQ as well as the Task Parallel Library to automatically coordinate background threads'),
					$author$project$MarkedString$markedString('In `Yomikata` with C++ and Qt, I used threads and processes to unpack and decode images in the background while keeping the UI responsive')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'TypeScript',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('`JavaScript` with type annotations, this language has been great for writing front-end software with extra peace-of-mind that refactorings and changes aren’t breaking old code.'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('At `Meya`, I picked TypeScript for implementing our web chat SDK using `React` and `WebSockets`'),
					$author$project$MarkedString$markedString('In `Fertile Earth`, I used TypeScript for the full stack, with fast transpiling provided by esbuild')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[0]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'version control',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I track all of my code with version control:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I have experience using Git, SVN, Bazaar, ClearCase, and AccuRev'),
					$author$project$MarkedString$markedString('I use history annotations for `learning` where code came from and why'),
					$author$project$MarkedString$markedString('I use change bisection to pinpoint the source of tricky bugs'),
					$author$project$MarkedString$markedString('I write clear and descriptive commit messages, and use references to external issue tracking systems')
				]),
			$author$project$Data$Visibility$portfolioOnly),
			A5(
			$author$project$Data$Tech$TechItemData,
			'visual design',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('I use visual design to help my software communicate effectively:'),
			_List_fromArray(
				[
					$author$project$MarkedString$markedString('I draw my own UI mockups, colour/typography schemes, icons, and logos using Inkscape (`SVG` editing software)'),
					$author$project$MarkedString$markedString('With `My Portfolio and Resume`, I used `CSS` to create a printable and highly-readable resume that doesn’t follow the standard single column layout'),
					$author$project$MarkedString$markedString('With `Off-Grid Orcs`, I designed and implemented my first font, with a glyph size of 6x6 pixels')
				]),
			$author$project$Data$Visibility$portfolioAndResume(
				_List_fromArray(
					[1]))),
			A5(
			$author$project$Data$Tech$TechItemData,
			'WebSockets',
			$elm$core$Maybe$Nothing,
			$author$project$MarkedString$markedString('At `Meya`, I used WebSockets to to implement the `event streams` for our `React` and `Flutter` chat clients. This provided low-latency updates and worked without issues across all platforms.'),
			_List_Nil,
			$author$project$Data$Visibility$portfolioOnly)
		]),
	cD: 'Tech skills',
	eQ: _List_fromArray(
		['Node.js', 'nginx']),
	fd: function ($) {
		return $.dJ;
	},
	fe: 'I’m serious about learning new skills and improving my old ones. New skills bring new perspectives and open new doors. Through practice, old skills reveal the keys to mastery.',
	fh: $elm$core$Maybe$Nothing
};
var $author$project$Data$Work$WorkItemData = F8(
	function (name, portfolioDuration, resumeTitle, resumePeriod, portfolioSkills, resumePoints, detailsIntro, detailsPoints) {
		return {d3: detailsIntro, d5: detailsPoints, cD: name, fc: portfolioDuration, fi: portfolioSkills, fq: resumePeriod, fr: resumePoints, fs: resumeTitle};
	});
var $author$project$Data$Work$initWorkData = function () {
	var sonova = A8(
		$author$project$Data$Work$WorkItemData,
		'Sonova',
		'8 years',
		'Software Developer, Senior Software Developer',
		'December 2009 – January 2018',
		_List_fromArray(
			['C# / WinForms / HTML / SQL', 'data analysis / communication', 'coordination / leadership / mentoring']),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('Developed `C#` hearing instrument manufacturing software with `code reviews`, `integration/unit tests`, and `CI`'),
				$author$project$MarkedString$markedString('Collaborated on `requirements`, `integrations`, and `debugging` with dev teams and production staff worldwide'),
				$author$project$MarkedString$markedString('Created and optimized ad hoc data analysis `SQL` queries to investigate bugs and business concerns'),
				$author$project$MarkedString$markedString('Triaged tasks, coordinated iterations, prepared releases, built internal tools, and mentored team members')
			]),
		$author$project$MarkedString$markedString('I worked with my team at Sonova for 8 years, `making` hearing instrument manufacturing software.'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I used `C#` for software implementation and maintenance, and `SQL` + Excel for `analyzing` data'),
				$author$project$MarkedString$markedString('I mitigated bugs using integration `testing`, actively listening, and thoroughly `learning` business/software systems'),
				$author$project$MarkedString$markedString('I built a hybrid HTML and `C#` desktop application to replace a paper-based inspection process'),
				$author$project$MarkedString$markedString('I followed `test-driven development` to build a test run comparison tool that saved weeks of manual effort'),
				$author$project$MarkedString$markedString('Also: negotiating solutions, documenting `technical requirements`, `coordinating` development cycles, `improving` team processes, mentoring and `teaching` peers')
			]));
	var nexj = A8(
		$author$project$Data$Work$WorkItemData,
		'NexJ Systems',
		'8 months (internship)',
		'Developer, Application Developer',
		'internship, 2008',
		_List_fromArray(
			['Java / Scheme']),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('Wrote tests, fixed CRM bugs in Scheme'),
				$author$project$MarkedString$markedString('Pair programmed to find and fix bugs'),
				$author$project$MarkedString$markedString('Simplified WiX installer using Java'),
				$author$project$MarkedString$markedString('Tested Windows Installers')
			]),
		$author$project$MarkedString$markedString('My final internship was with teams at NexJ Systems, `making` customer relationship management software:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I used Java for `improving` an Ant + WiX installer build system'),
				$author$project$MarkedString$markedString('I investigated and fixed client-critical bugs in Scheme'),
				$author$project$MarkedString$markedString('I did business logic unit `testing` in Scheme')
			]));
	var meya = A8(
		$author$project$Data$Work$WorkItemData,
		'Meya',
		'4 years',
		'Software Engineer',
		'May 2018 – November 2022',
		_List_fromArray(
			['Python / Django / TypeScript / React', 'Kubernetes / PostgreSQL / Redis / GCP', 'system architecture / product thinking / shipping']),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('Collaboratively designed and implemented a new secure, scalable, `event-oriented`, multi-tenant architecture for our chatbot platform built on `Python`, `WebSockets`, `Redis Streams`, `PostgreSQL`, `Kubernetes`, and `GCP`'),
				$author$project$MarkedString$markedString('Enabled surge scale-up using `Gatling` tests, custom work-limiting metrics, and `Kubernetes` HPA'),
				$author$project$MarkedString$markedString('Created `React / TypeScript` and `Flutter` chat SDKs, including UX and API design for innovative new features'),
				$author$project$MarkedString$markedString('Drastically reduced end-to-end platform latency through benchmarking and `source-level profiling`'),
				$author$project$MarkedString$markedString('Upgraded the developer experience of our workflow language, adding aliases, `type checks`, and `tail calls`'),
				$author$project$MarkedString$markedString('Coded `integrations` using `REST APIs` and `webhooks` with mocked payload and event stream tests'),
				$author$project$MarkedString$markedString('Built a developer CLI (`Click`) and web console (`React`), connected to `nginx`, `Django`, `GraphQL`, and `Git`'),
				$author$project$MarkedString$markedString('Launched a `React / Rappid` visual flow editor with templates, inline docs, and full programmability'),
				$author$project$MarkedString$markedString('Boosted performance and unlocked key log searches by compiling `Lucene` to windowed, index-aware `SQL`'),
				$author$project$MarkedString$markedString('Improved QC processes: `code reviews`, `unit tests`, `CI/CD`, staging releases, checklists, monitoring, and alerts'),
				$author$project$MarkedString$markedString('Directly supported customers via Slack chat, async videos, `log tracing`, `debugging`, and `pair programming`'),
				$author$project$MarkedString$markedString('Self-managed solo projects from brainstorming, design, coding, documentation, to release and onboarding')
			]),
		$author$project$MarkedString$markedString('I was a member of the team at Meya for more than 4 years, working on a chatbot platform that customers used to build and launch great customer support.'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I co-designed a new architecture for our platform, with `scale`, `security`, and `event streams` at the core'),
				$author$project$MarkedString$markedString('I worked on implementing our back-end using `Python`, `WebSockets`, `Redis`, `PostgreSQL`, `Kubernetes`, and `Google Cloud Platform`'),
				$author$project$MarkedString$markedString('I created and maintained our chat UI SDKs for web (`React`, `TypeScript`) and mobile (`Flutter`)'),
				$author$project$MarkedString$markedString('Experience in `domain-specific languages`: I built the 2nd-generation parser, engine, and static checks for our custom workflow language'),
				$author$project$MarkedString$markedString('I helped improved our QC processes: `code review`, unit `testing`, `continuous integration & deployment`, staging releases, checklists, and `monitoring`'),
				$author$project$MarkedString$markedString('I directly supported customers via Slack chat, async video clips, `log tracing`, `debugging`, and `pair programming`')
			]));
	var portfolioLargeItems = _List_fromArray(
		[meya, sonova]);
	var lsi = A8(
		$author$project$Data$Work$WorkItemData,
		'LSI Logic',
		'8 months (internship)',
		'Software Engineer',
		'internship, 2005–2006',
		_List_fromArray(
			['C / C++']),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('Created a DSP log analysis tool in C++'),
				$author$project$MarkedString$markedString('Implemented \'video debugger\' features in C'),
				$author$project$MarkedString$markedString('Fixed H.264 video decoder bugs in C')
			]),
		$author$project$MarkedString$markedString('My first internship was with the team at LSI Logic, `making` H.264 video decoders and encoders:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I began by reading the H.264 spec, `learning` how video encoding works'),
				$author$project$MarkedString$markedString('I fixed video decoder bugs in C'),
				$author$project$MarkedString$markedString('I implemented video debugger features in C'),
				$author$project$MarkedString$markedString('I created an internal tool for analyzing the logs of a digital-signal-processor pipeline simulation in C++')
			]));
	var coreworx = A8(
		$author$project$Data$Work$WorkItemData,
		'Coreworx',
		'8 months (internship)',
		'Software Developer',
		'internship, 2006–2007',
		_List_fromArray(
			['C# / SQL']),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('Automated database migration via `SQL`'),
				$author$project$MarkedString$markedString('Tested an ASP.NET DMS application'),
				$author$project$MarkedString$markedString('Developed DMS personalization in `C#`'),
				$author$project$MarkedString$markedString('Learned the keys to effective bug reporting')
			]),
		$author$project$MarkedString$markedString('I interned with the team at Coreworx, `making` an ASP.NET document management system:'),
		_List_fromArray(
			[
				$author$project$MarkedString$markedString('I helped develop a personalization system in `C#`'),
				$author$project$MarkedString$markedString('I automated an Oracle database migration via `SQL`'),
				$author$project$MarkedString$markedString('I ran manual regression tests, `learning` the fundamentals of good `bug reporting`')
			]));
	var portfolioSmallItems = _List_fromArray(
		[nexj, coreworx, lsi]);
	return {
		d4: 'team',
		er: 'work',
		cD: 'Work history',
		fd: function ($) {
			return $.dN;
		},
		fe: 'These are the teams that I’ve contributed to and learned from:',
		ff: _Utils_ap(portfolioLargeItems, portfolioSmallItems),
		fg: portfolioLargeItems,
		fh: $elm$core$Maybe$Just('Want more details about my skills? Keep reading for my mindsets, tech skills, and side projects…'),
		fj: portfolioSmallItems,
		c5: _List_fromArray(
			[meya, sonova])
	};
}();
var $author$project$Data$initData = {bV: $author$project$Data$Basic$initBasicData, cc: $author$project$Data$Education$initEducationData, cy: $author$project$Data$Links$initLinksData, cA: $author$project$Data$Mindsets$initMindsetsData, cY: $author$project$Data$Projects$initProjectsData, df: $author$project$Data$Startup$initStartupData, dl: $author$project$Data$Tech$initTechData, du: $author$project$Data$Work$initWorkData};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Msg$HashChange = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $ohanhi$keyboard$Keyboard$ArrowLeft = {$: 19};
var $ohanhi$keyboard$Keyboard$ArrowRight = {$: 20};
var $author$project$Msg$DetailsClose = {$: 4};
var $author$project$Msg$DetailsNavigate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Display$Details$DetailsNavigateNext = 1;
var $author$project$Display$Details$DetailsNavigatePrevious = 0;
var $ohanhi$keyboard$Keyboard$Escape = {$: 62};
var $author$project$Msg$NoMsg = {$: 5};
var $ohanhi$keyboard$Keyboard$Backspace = {$: 26};
var $ohanhi$keyboard$Keyboard$Clear = {$: 27};
var $ohanhi$keyboard$Keyboard$Copy = {$: 28};
var $ohanhi$keyboard$Keyboard$CrSel = {$: 29};
var $ohanhi$keyboard$Keyboard$Cut = {$: 30};
var $ohanhi$keyboard$Keyboard$Delete = {$: 31};
var $ohanhi$keyboard$Keyboard$EraseEof = {$: 32};
var $ohanhi$keyboard$Keyboard$ExSel = {$: 33};
var $ohanhi$keyboard$Keyboard$Insert = {$: 34};
var $ohanhi$keyboard$Keyboard$Paste = {$: 35};
var $ohanhi$keyboard$Keyboard$Redo = {$: 36};
var $ohanhi$keyboard$Keyboard$Undo = {$: 37};
var $ohanhi$keyboard$Keyboard$editingKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Backspace':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Backspace);
		case 'Clear':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Clear);
		case 'Copy':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Copy);
		case 'CrSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CrSel);
		case 'Cut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cut);
		case 'Delete':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Delete);
		case 'EraseEof':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EraseEof);
		case 'ExSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ExSel);
		case 'Insert':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Insert);
		case 'Paste':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Paste);
		case 'Redo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Redo);
		case 'Undo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Undo);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$F1 = {$: 38};
var $ohanhi$keyboard$Keyboard$F10 = {$: 47};
var $ohanhi$keyboard$Keyboard$F11 = {$: 48};
var $ohanhi$keyboard$Keyboard$F12 = {$: 49};
var $ohanhi$keyboard$Keyboard$F13 = {$: 50};
var $ohanhi$keyboard$Keyboard$F14 = {$: 51};
var $ohanhi$keyboard$Keyboard$F15 = {$: 52};
var $ohanhi$keyboard$Keyboard$F16 = {$: 53};
var $ohanhi$keyboard$Keyboard$F17 = {$: 54};
var $ohanhi$keyboard$Keyboard$F18 = {$: 55};
var $ohanhi$keyboard$Keyboard$F19 = {$: 56};
var $ohanhi$keyboard$Keyboard$F2 = {$: 39};
var $ohanhi$keyboard$Keyboard$F20 = {$: 57};
var $ohanhi$keyboard$Keyboard$F3 = {$: 40};
var $ohanhi$keyboard$Keyboard$F4 = {$: 41};
var $ohanhi$keyboard$Keyboard$F5 = {$: 42};
var $ohanhi$keyboard$Keyboard$F6 = {$: 43};
var $ohanhi$keyboard$Keyboard$F7 = {$: 44};
var $ohanhi$keyboard$Keyboard$F8 = {$: 45};
var $ohanhi$keyboard$Keyboard$F9 = {$: 46};
var $ohanhi$keyboard$Keyboard$functionKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'F1':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F1);
		case 'F2':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F2);
		case 'F3':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F3);
		case 'F4':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F4);
		case 'F5':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F5);
		case 'F6':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F6);
		case 'F7':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F7);
		case 'F8':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F8);
		case 'F9':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F9);
		case 'F10':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F10);
		case 'F11':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F11);
		case 'F12':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F12);
		case 'F13':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F13);
		case 'F14':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F14);
		case 'F15':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F15);
		case 'F16':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F16);
		case 'F17':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F17);
		case 'F18':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F18);
		case 'F19':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F19);
		case 'F20':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F20);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ChannelDown = {$: 85};
var $ohanhi$keyboard$Keyboard$ChannelUp = {$: 86};
var $ohanhi$keyboard$Keyboard$MediaFastForward = {$: 87};
var $ohanhi$keyboard$Keyboard$MediaPause = {$: 88};
var $ohanhi$keyboard$Keyboard$MediaPlay = {$: 89};
var $ohanhi$keyboard$Keyboard$MediaPlayPause = {$: 90};
var $ohanhi$keyboard$Keyboard$MediaRecord = {$: 91};
var $ohanhi$keyboard$Keyboard$MediaRewind = {$: 92};
var $ohanhi$keyboard$Keyboard$MediaStop = {$: 93};
var $ohanhi$keyboard$Keyboard$MediaTrackNext = {$: 94};
var $ohanhi$keyboard$Keyboard$MediaTrackPrevious = {$: 95};
var $ohanhi$keyboard$Keyboard$mediaKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'ChannelDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelDown);
		case 'ChannelUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelUp);
		case 'MediaFastForward':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaFastForward);
		case 'MediaPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPause);
		case 'MediaPlay':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlay);
		case 'MediaPlayPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlayPause);
		case 'MediaRecord':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRecord);
		case 'MediaRewind':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRewind);
		case 'MediaStop':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaStop);
		case 'MediaTrackNext':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackNext);
		case 'MediaTrackPrevious':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackPrevious);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Alt = {$: 1};
var $ohanhi$keyboard$Keyboard$AltGraph = {$: 2};
var $ohanhi$keyboard$Keyboard$CapsLock = {$: 3};
var $ohanhi$keyboard$Keyboard$Control = {$: 4};
var $ohanhi$keyboard$Keyboard$Fn = {$: 5};
var $ohanhi$keyboard$Keyboard$FnLock = {$: 6};
var $ohanhi$keyboard$Keyboard$Hyper = {$: 7};
var $ohanhi$keyboard$Keyboard$Meta = {$: 8};
var $ohanhi$keyboard$Keyboard$NumLock = {$: 9};
var $ohanhi$keyboard$Keyboard$ScrollLock = {$: 10};
var $ohanhi$keyboard$Keyboard$Shift = {$: 11};
var $ohanhi$keyboard$Keyboard$Super = {$: 12};
var $ohanhi$keyboard$Keyboard$Symbol = {$: 13};
var $ohanhi$keyboard$Keyboard$SymbolLock = {$: 14};
var $ohanhi$keyboard$Keyboard$modifierKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Alt':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Alt);
		case 'AltGraph':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AltGraph);
		case 'CapsLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CapsLock);
		case 'Control':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Control);
		case 'Fn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Fn);
		case 'FnLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$FnLock);
		case 'Hyper':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Hyper);
		case 'Meta':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Meta);
		case 'NumLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$NumLock);
		case 'ScrollLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ScrollLock);
		case 'Shift':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Shift);
		case 'Super':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'OS':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'Symbol':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Symbol);
		case 'SymbolLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$SymbolLock);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ArrowDown = {$: 18};
var $ohanhi$keyboard$Keyboard$ArrowUp = {$: 21};
var $ohanhi$keyboard$Keyboard$End = {$: 22};
var $ohanhi$keyboard$Keyboard$Home = {$: 23};
var $ohanhi$keyboard$Keyboard$PageDown = {$: 24};
var $ohanhi$keyboard$Keyboard$PageUp = {$: 25};
var $ohanhi$keyboard$Keyboard$navigationKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'ArrowDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'ArrowLeft':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'ArrowRight':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'ArrowUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'Down':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'Left':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'Right':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'Up':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'End':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$End);
		case 'Home':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Home);
		case 'PageDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageDown);
		case 'PageUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageUp);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$oneOf = F2(
	function (fns, key) {
		oneOf:
		while (true) {
			if (!fns.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var fn = fns.a;
				var rest = fns.b;
				var _v1 = fn(key);
				if (!_v1.$) {
					var a = _v1.a;
					return $elm$core$Maybe$Just(a);
				} else {
					var $temp$fns = rest,
						$temp$key = key;
					fns = $temp$fns;
					key = $temp$key;
					continue oneOf;
				}
			}
		}
	});
var $ohanhi$keyboard$Keyboard$AppSwitch = {$: 73};
var $ohanhi$keyboard$Keyboard$Call = {$: 74};
var $ohanhi$keyboard$Keyboard$Camera = {$: 75};
var $ohanhi$keyboard$Keyboard$CameraFocus = {$: 76};
var $ohanhi$keyboard$Keyboard$EndCall = {$: 77};
var $ohanhi$keyboard$Keyboard$GoBack = {$: 78};
var $ohanhi$keyboard$Keyboard$GoHome = {$: 79};
var $ohanhi$keyboard$Keyboard$HeadsetHook = {$: 80};
var $ohanhi$keyboard$Keyboard$LastNumberRedial = {$: 81};
var $ohanhi$keyboard$Keyboard$MannerMode = {$: 83};
var $ohanhi$keyboard$Keyboard$Notification = {$: 82};
var $ohanhi$keyboard$Keyboard$VoiceDial = {$: 84};
var $ohanhi$keyboard$Keyboard$phoneKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'AppSwitch':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AppSwitch);
		case 'Call':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Call);
		case 'Camera':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Camera);
		case 'CameraFocus':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CameraFocus);
		case 'EndCall':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EndCall);
		case 'GoBack':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoBack);
		case 'GoHome':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoHome);
		case 'HeadsetHook':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$HeadsetHook);
		case 'LastNumberRedial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$LastNumberRedial);
		case 'Notification':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Notification);
		case 'MannerMode':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MannerMode);
		case 'VoiceDial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$VoiceDial);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Again = {$: 58};
var $ohanhi$keyboard$Keyboard$Attn = {$: 59};
var $ohanhi$keyboard$Keyboard$Cancel = {$: 60};
var $ohanhi$keyboard$Keyboard$ContextMenu = {$: 61};
var $ohanhi$keyboard$Keyboard$Execute = {$: 63};
var $ohanhi$keyboard$Keyboard$Find = {$: 64};
var $ohanhi$keyboard$Keyboard$Finish = {$: 65};
var $ohanhi$keyboard$Keyboard$Help = {$: 66};
var $ohanhi$keyboard$Keyboard$Pause = {$: 67};
var $ohanhi$keyboard$Keyboard$Play = {$: 68};
var $ohanhi$keyboard$Keyboard$Props = {$: 69};
var $ohanhi$keyboard$Keyboard$Select = {$: 70};
var $ohanhi$keyboard$Keyboard$ZoomIn = {$: 71};
var $ohanhi$keyboard$Keyboard$ZoomOut = {$: 72};
var $ohanhi$keyboard$Keyboard$uiKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Again':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Again);
		case 'Attn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Attn);
		case 'Cancel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cancel);
		case 'ContextMenu':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ContextMenu);
		case 'Escape':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape);
		case 'Execute':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Execute);
		case 'Find':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Find);
		case 'Finish':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Finish);
		case 'Help':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Help);
		case 'Pause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Pause);
		case 'Play':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Play);
		case 'Props':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Props);
		case 'Select':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Select);
		case 'ZoomIn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomIn);
		case 'ZoomOut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomOut);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Enter = {$: 15};
var $ohanhi$keyboard$Keyboard$Spacebar = {$: 17};
var $ohanhi$keyboard$Keyboard$Tab = {$: 16};
var $ohanhi$keyboard$Keyboard$whitespaceKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Enter':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Enter);
		case 'Tab':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Tab);
		case 'Spacebar':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		case ' ':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$anyKeyWith = function (charParser) {
	return $ohanhi$keyboard$Keyboard$oneOf(
		_List_fromArray(
			[$ohanhi$keyboard$Keyboard$whitespaceKey, charParser, $ohanhi$keyboard$Keyboard$modifierKey, $ohanhi$keyboard$Keyboard$navigationKey, $ohanhi$keyboard$Keyboard$editingKey, $ohanhi$keyboard$Keyboard$functionKey, $ohanhi$keyboard$Keyboard$uiKey, $ohanhi$keyboard$Keyboard$phoneKey, $ohanhi$keyboard$Keyboard$mediaKey]));
};
var $ohanhi$keyboard$Keyboard$Character = function (a) {
	return {$: 0, a: a};
};
var $ohanhi$keyboard$Keyboard$characterKeyOriginal = function (_v0) {
	var value = _v0;
	return ($elm$core$String$length(value) === 1) ? $elm$core$Maybe$Just(
		$ohanhi$keyboard$Keyboard$Character(value)) : $elm$core$Maybe$Nothing;
};
var $ohanhi$keyboard$Keyboard$anyKeyOriginal = $ohanhi$keyboard$Keyboard$anyKeyWith($ohanhi$keyboard$Keyboard$characterKeyOriginal);
var $ohanhi$keyboard$Keyboard$RawKey = $elm$core$Basics$identity;
var $ohanhi$keyboard$Keyboard$eventKeyDecoder = A2(
	$elm$json$Json$Decode$field,
	'key',
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string));
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {cR: pids, di: subs};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {cf: event, cu: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.cR,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.cu;
		var event = _v0.cf;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.di);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $ohanhi$keyboard$Keyboard$downs = function (toMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$View$Details$maybeSubscribeDetails = function (display) {
	var handleKey = F2(
		function (item, key) {
			return _Utils_eq(
				key,
				$elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape)) ? $elm$core$Maybe$Just($author$project$Msg$DetailsClose) : (_Utils_eq(
				key,
				$elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft)) ? A2(
				$elm$core$Maybe$map,
				$author$project$Msg$DetailsNavigate(0),
				item.cV) : (_Utils_eq(
				key,
				$elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight)) ? A2(
				$elm$core$Maybe$map,
				$author$project$Msg$DetailsNavigate(1),
				item.cI) : $elm$core$Maybe$Nothing));
		});
	var subscribe = function (details) {
		return $ohanhi$keyboard$Keyboard$downs(
			A2(
				$elm$core$Basics$composeR,
				$ohanhi$keyboard$Keyboard$anyKeyOriginal,
				A2(
					$elm$core$Basics$composeR,
					handleKey(details.ez),
					$elm$core$Maybe$withDefault($author$project$Msg$NoMsg))));
	};
	var maybeSubscribe = function (details) {
		var _v0 = details.dD;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				subscribe(details));
		}
	};
	return A2($elm$core$Maybe$andThen, maybeSubscribe, display.b6);
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Navigation$onHashChange = _Platform_incomingPort('onHashChange', $elm$json$Json$Decode$string);
var $author$project$View$subscribe = function (_v0) {
	var display = _v0.b8;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Navigation$onHashChange($author$project$Msg$HashChange),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				$author$project$View$Details$maybeSubscribeDetails(display))
			]));
};
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$cons = _String_cons;
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {al: charsProcessed, el: hash, c8: seed, fy: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Bitwise$or = _Bitwise_or;
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.el)) ? (data.c8 ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.el)))) : data.c8;
	var h0 = acc ^ data.al;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.el | ((255 & $elm$core$Char$toCode(c)) << data.fy);
		var _v0 = data.fy;
		if (_v0 === 24) {
			return {
				al: data.al + 1,
				el: 0,
				c8: A2($robinheghan$murmur3$Murmur3$mix, data.c8, res),
				fy: 0
			};
		} else {
			return {al: data.al + 1, el: res, c8: data.c8, fy: data.fy + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\n' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (!accumulatedStyles.$) {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\n' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Display$Details$DetailsAnimationClose = {$: 1};
var $author$project$Update$close = F2(
	function (details, _v0) {
		return $elm$core$Maybe$Just(
			_Utils_update(
				details,
				{dD: $author$project$Display$Details$DetailsAnimationClose}));
	});
var $author$project$Update$hashChange = F2(
	function (hash, model) {
		var newShowResumePreview = hash === 'resume';
		var setDisplay = function () {
			var display = model.b8;
			return _Utils_update(
				display,
				{b6: $elm$core$Maybe$Nothing, c9: newShowResumePreview});
		}();
		var setModel = _Utils_update(
			model,
			{b8: setDisplay});
		return (!_Utils_eq(newShowResumePreview, model.b8.c9)) ? $elm$core$Maybe$Just(setModel) : $elm$core$Maybe$Nothing;
	});
var $author$project$Update$maybeModel = F2(
	function (transform, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			transform(model));
	});
var $author$project$Update$maybeSetDetails = F2(
	function (transform, model) {
		var setDisplay = function (details) {
			var display = model.b8;
			return _Utils_update(
				display,
				{
					b6: $elm$core$Maybe$Just(details)
				});
		};
		var setModel = function (details) {
			return _Utils_update(
				model,
				{
					b8: setDisplay(details)
				});
		};
		return A2(
			$elm$core$Maybe$map,
			setModel,
			transform(model));
	});
var $author$project$Update$maybeUpdateDetails = function (transform) {
	return $author$project$Update$maybeSetDetails(
		function (model) {
			return A2(
				$elm$core$Maybe$andThen,
				function (details) {
					return A2(transform, details, model);
				},
				model.b8.b6);
		});
};
var $author$project$ListEx$findMap = F2(
	function (conditionTransform, list) {
		findMap:
		while (true) {
			if (list.b) {
				var head = list.a;
				var rest = list.b;
				var _v1 = conditionTransform(head);
				if (!_v1.$) {
					var result = _v1.a;
					return $elm$core$Maybe$Just(result);
				} else {
					var $temp$conditionTransform = conditionTransform,
						$temp$list = rest;
					conditionTransform = $temp$conditionTransform;
					list = $temp$list;
					continue findMap;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$ListEx$find = function (condition) {
	return $author$project$ListEx$findMap(
		function (item) {
			return condition(item) ? $elm$core$Maybe$Just(item) : $elm$core$Maybe$Nothing;
		});
};
var $author$project$Update$findDetailsItem = function (name) {
	return $author$project$ListEx$find(
		function (item) {
			return _Utils_eq(item.cD, name);
		});
};
var $author$project$Update$maybeWithDetailsItem = F3(
	function (name, transform, model) {
		return A2(
			$elm$core$Maybe$map,
			transform,
			A2($author$project$Update$findDetailsItem, name, model.b8.b7));
	});
var $author$project$Display$Details$DetailsAnimationNavigate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Display$Details$DetailsDoubleBufferFirstSlotNew = 0;
var $author$project$Display$Details$DetailsDoubleBufferFirstSlotOld = 1;
var $author$project$Display$Details$swapDoubleBuffer = function (details) {
	var _v0 = details.ca;
	if (!_v0) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Update$navigate = F3(
	function (details, direction, item) {
		return _Utils_update(
			details,
			{
				dD: $author$project$Display$Details$DetailsAnimationNavigate(
					{d6: direction, e$: details.ez}),
				ca: $author$project$Display$Details$swapDoubleBuffer(details),
				ez: item
			});
	});
var $author$project$Display$Details$DetailsAnimationOpen = {$: 0};
var $author$project$Display$Details$initDoubleBuffer = 0;
var $author$project$Update$open = F2(
	function (clickInfo, item) {
		return {dD: $author$project$Display$Details$DetailsAnimationOpen, ca: $author$project$Display$Details$initDoubleBuffer, ez: item, e3: clickInfo};
	});
var $author$project$Print$print = _Platform_outgoingPort(
	'print',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Update$sendCommand = F2(
	function (command, model) {
		return _Utils_Tuple2(model, command);
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Update$updateModel = F2(
	function (transform, model) {
		return _Utils_Tuple2(
			transform(model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Update$update = function (msg) {
	switch (msg.$) {
		case 0:
			var hash = msg.a;
			return $author$project$Update$updateModel(
				$author$project$Update$maybeModel(
					$author$project$Update$hashChange(hash)));
		case 1:
			return $author$project$Update$sendCommand(
				$author$project$Print$print(0));
		case 2:
			var name = msg.a;
			var clickInfo = msg.b;
			return $author$project$Update$updateModel(
				$author$project$Update$maybeModel(
					$author$project$Update$maybeSetDetails(
						A2(
							$author$project$Update$maybeWithDetailsItem,
							name,
							$author$project$Update$open(clickInfo)))));
		case 3:
			var direction = msg.a;
			var name = msg.b;
			return $author$project$Update$updateModel(
				$author$project$Update$maybeModel(
					$author$project$Update$maybeUpdateDetails(
						function (details) {
							return A2(
								$author$project$Update$maybeWithDetailsItem,
								name,
								A2($author$project$Update$navigate, details, direction));
						})));
		case 4:
			return $author$project$Update$updateModel(
				$author$project$Update$maybeModel(
					$author$project$Update$maybeUpdateDetails($author$project$Update$close)));
		default:
			return $author$project$Update$updateModel($elm$core$Basics$identity);
	}
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A2(fn, arg1, arg2));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A4($elm$virtual_dom$VirtualDom$lazy3, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2, fn, arg1, arg2));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy2 = $rtfeldman$elm_css$VirtualDom$Styled$lazy2;
var $author$project$LazyHtml$fromLazyHtml2 = $rtfeldman$elm_css$Html$Styled$Lazy$lazy2;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$hidden = {y: 0, av: 0, bL: 'hidden', fU: 0};
var $author$project$View$DetailsAnimation$Details = 1;
var $author$project$View$DetailsAnimation$Close = 1;
var $author$project$View$DetailsAnimation$New = 0;
var $author$project$View$DetailsAnimation$Old = 1;
var $author$project$View$DetailsAnimation$Open = 0;
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $author$project$CssShorthand$animation = $rtfeldman$elm_css$Css$property('animation');
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$View$DetailsAnimation$combineAnimations = F4(
	function (animationNames, duration, delay, easing) {
		return $author$project$CssShorthand$animation(
			A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (animationName) {
						return A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									animationName,
									$elm$core$String$fromFloat(duration) + 'ms',
									$elm$core$String$fromFloat(delay) + 'ms',
									'both',
									easing
								]));
					},
					animationNames)));
	});
var $author$project$CssShorthand$transformOrigin = $rtfeldman$elm_css$Css$property('transform-origin');
var $author$project$View$DetailsAnimation$animateProtfolioAndDetails = F2(
	function (portfolioOrDetails, details) {
		var overlap = 0.6;
		var originStyle = function (_v13) {
			var x = _v13.a;
			var y = _v13.b;
			return $author$project$CssShorthand$transformOrigin(
				$elm$core$String$fromFloat(x) + ('px ' + ($elm$core$String$fromFloat(y) + 'px')));
		};
		var origin = function () {
			if (!portfolioOrDetails) {
				return originStyle(details.e3.e5);
			} else {
				return originStyle(details.e3.dU);
			}
		}();
		var openOrClose = function () {
			var _v11 = details.dD;
			if (_v11.$ === 1) {
				return 1;
			} else {
				return 0;
			}
		}();
		var fullDuration = 250;
		var easing = function (newOrOld) {
			if (!newOrOld) {
				return 'ease-out';
			} else {
				return 'ease-in';
			}
		};
		var duration = (fullDuration * (1 + overlap)) / 2;
		var delay = function (newOrOld) {
			if (!newOrOld) {
				return fullDuration - duration;
			} else {
				return 0;
			}
		};
		var animate = F2(
			function (animationNames, newOrOld) {
				return A4(
					$author$project$View$DetailsAnimation$combineAnimations,
					animationNames,
					duration,
					delay(newOrOld),
					easing(newOrOld));
			});
		var _switch = function () {
			var _v0 = _Utils_Tuple2(openOrClose, portfolioOrDetails);
			if (!_v0.a) {
				if (!_v0.b) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return A2(
						animate,
						_List_fromArray(
							['fadeOut', 'zoomIn']),
						1);
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return A2(
						animate,
						_List_fromArray(
							['fadePartialIn', 'growIn']),
						0);
				}
			} else {
				if (!_v0.b) {
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					return A2(
						animate,
						_List_fromArray(
							['fadeIn', 'zoomOut']),
						0);
				} else {
					var _v7 = _v0.a;
					var _v8 = _v0.b;
					return A2(
						animate,
						_List_fromArray(
							['fadePartialOut', 'growOut']),
						1);
				}
			}
		}();
		return A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $rtfeldman$elm_css$Css$batch)(
			_List_fromArray(
				[_switch, origin]));
	});
var $author$project$CssShorthand$noStyle = $rtfeldman$elm_css$Css$batch(_List_Nil);
var $author$project$View$DetailsAnimation$animateDetails = function (details) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$CssShorthand$noStyle,
		A2($author$project$View$DetailsAnimation$animateProtfolioAndDetails, 1, details));
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.bL);
};
var $author$project$CssShorthand$batchMap = F2(
	function (partialStyles, styleParameter) {
		return $rtfeldman$elm_css$Css$batch(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$apR(styleParameter),
				partialStyles));
	});
var $author$project$View$Colors$blackLevel = 17;
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgb = F3(
	function (r, g, b) {
		return {
			aF: 1,
			aH: b,
			K: 0,
			aL: g,
			aQ: r,
			bL: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgb',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromInt,
					_List_fromArray(
						[r, g, b])))
		};
	});
var $author$project$View$Colors$black = A3($rtfeldman$elm_css$Css$rgb, $author$project$View$Colors$blackLevel, $author$project$View$Colors$blackLevel, $author$project$View$Colors$blackLevel);
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.bL);
	});
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$MaybeEx$toList = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$List$singleton),
	$elm$core$Maybe$withDefault(_List_Nil));
var $rtfeldman$elm_css$Css$Structure$CustomQuery = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$withMediaQuery = function (queries) {
	return $rtfeldman$elm_css$Css$Preprocess$WithMedia(
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$CustomQuery, queries));
};
var $author$project$CssShorthand$mediaCustomConditions = F2(
	function (positive, negative) {
		var convertExpression = function (expression) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'(',
						expression.cg,
						A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$append(': '),
							expression.bL)),
						')'
					]));
		};
		var prefix = F2(
			function (mode, expressions) {
				return $elm$core$List$isEmpty(expressions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						' and ',
						_Utils_ap(
							_List_fromArray(
								[mode]),
							A2($elm$core$List$map, convertExpression, expressions))));
			});
		return $rtfeldman$elm_css$Css$Media$withMediaQuery(
			A2(
				$elm$core$List$concatMap,
				$author$project$MaybeEx$toList,
				_List_fromArray(
					[
						A2(prefix, 'all', positive),
						A2(prefix, 'not all', negative)
					])));
	});
var $author$project$CssShorthand$mediaConditions = function (conditions) {
	return A2($author$project$CssShorthand$mediaCustomConditions, conditions, _List_Nil);
};
var $rtfeldman$elm_css$Css$Media$feature = F2(
	function (key, _v0) {
		var value = _v0.bL;
		return {
			cg: key,
			bL: $elm$core$Maybe$Just(value)
		};
	});
var $rtfeldman$elm_css$Css$Media$minHeight = function (value) {
	return A2($rtfeldman$elm_css$Css$Media$feature, 'min-height', value);
};
var $rtfeldman$elm_css$Css$Media$minWidth = function (value) {
	return A2($rtfeldman$elm_css$Css$Media$feature, 'min-width', value);
};
var $rtfeldman$elm_css$Css$RemUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			bM: 0,
			bZ: 0,
			ap: 0,
			v: 0,
			k: 0,
			ar: 0,
			R: 0,
			as: 0,
			at: 0,
			aa: 0,
			ab: 0,
			L: 0,
			au: 0,
			eZ: numericValue,
			ay: 0,
			fO: unitLabel,
			aV: units,
			bL: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var $author$project$CssShorthand$rem_ = $rtfeldman$elm_css$Css$rem;
var $author$project$View$Breakpoints$breakpointDetailsLarge = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_(78)),
			$rtfeldman$elm_css$Css$Media$minHeight(
			$author$project$CssShorthand$rem_(43))
		]));
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.bL);
};
var $rtfeldman$elm_css$Css$row = {bw: 0, aJ: 0, bL: 'row'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{bL: 'column'});
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $author$project$CssShorthand$displayFlexColumn = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]));
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$none = {aj: 0, bW: 0, y: 0, b: 0, b8: 0, ep: 0, cr: 0, bB: 0, at: 0, aa: 0, L: 0, d: 0, c: 0, bE: 0, ba: 0, e8: 0, H: 0, bb: 0, fw: 0, ax: 0, af: 0, B: 0, h: 0, fQ: 0, bL: 'none'};
var $author$project$CssShorthand$displayNone = $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none);
var $author$project$View$Colors$greenHue = 151;
var $elm$core$Basics$pi = _Basics_pi;
var $rtfeldman$elm_css$Css$degreesToRadians = function (degrees) {
	return (degrees * 180) / $elm$core$Basics$pi;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $rtfeldman$elm_css$Css$fmod = F2(
	function (f, n) {
		var integer = $elm$core$Basics$floor(f);
		return (A2($elm$core$Basics$modBy, n, integer) + f) - integer;
	});
var $rtfeldman$elm_css$Css$hslToRgb = F3(
	function (hueVal, saturationVal, lightness) {
		var normHue = hueVal / $elm$core$Basics$degrees(60);
		var chroma = (1 - $elm$core$Basics$abs((2 * lightness) - 1)) * saturationVal;
		var m = lightness - (chroma / 2);
		var x = chroma * (1 - $elm$core$Basics$abs(
			A2($rtfeldman$elm_css$Css$fmod, normHue, 2) - 1));
		var _v0 = (normHue < 0) ? _Utils_Tuple3(0, 0, 0) : ((normHue < 1) ? _Utils_Tuple3(chroma, x, 0) : ((normHue < 2) ? _Utils_Tuple3(x, chroma, 0) : ((normHue < 3) ? _Utils_Tuple3(0, chroma, x) : ((normHue < 4) ? _Utils_Tuple3(0, x, chroma) : ((normHue < 5) ? _Utils_Tuple3(x, 0, chroma) : ((normHue < 6) ? _Utils_Tuple3(chroma, 0, x) : _Utils_Tuple3(0, 0, 0)))))));
		var r = _v0.a;
		var g = _v0.b;
		var b = _v0.c;
		return _Utils_Tuple3(r + m, g + m, b + m);
	});
var $rtfeldman$elm_css$Css$hslaToRgba = F5(
	function (value, hueVal, saturationVal, lightness, hslAlpha) {
		var _v0 = A3(
			$rtfeldman$elm_css$Css$hslToRgb,
			$rtfeldman$elm_css$Css$degreesToRadians(hueVal),
			saturationVal,
			lightness);
		var red = _v0.a;
		var green = _v0.b;
		var blue = _v0.c;
		return {
			aF: hslAlpha,
			aH: $elm$core$Basics$floor(blue),
			K: 0,
			aL: $elm$core$Basics$floor(green),
			aQ: $elm$core$Basics$floor(red),
			bL: value
		};
	});
var $rtfeldman$elm_css$Css$numericalPercentageToString = function (value) {
	return $elm$core$String$fromFloat(value * 100) + '%';
};
var $rtfeldman$elm_css$Css$hsl = F3(
	function (hueVal, saturationVal, lightnessVal) {
		var valuesList = _List_fromArray(
			[
				$elm$core$String$fromFloat(hueVal),
				$rtfeldman$elm_css$Css$numericalPercentageToString(saturationVal),
				$rtfeldman$elm_css$Css$numericalPercentageToString(lightnessVal)
			]);
		var value = A2($rtfeldman$elm_css$Css$cssFunction, 'hsl', valuesList);
		return A5($rtfeldman$elm_css$Css$hslaToRgba, value, hueVal, saturationVal, lightnessVal, 1);
	});
var $author$project$View$Colors$extraPaleGreen = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 0.89, 0.99);
var $rtfeldman$elm_css$Css$fixed = {aG: 0, aP: 0, bk: 0, bL: 'fixed'};
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$View$Breakpoints$breakpointDetailsMediumWidth = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_(69))
		]));
var $author$project$View$DetailsAnimation$animateDetailsItem = F2(
	function (isNew, details) {
		var newOrOld = isNew ? 0 : 1;
		var maybeDirection = function () {
			var _v13 = details.dD;
			if (_v13.$ === 2) {
				var direction = _v13.a.d6;
				return $elm$core$Maybe$Just(direction);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var animate = F2(
			function (duration, animationNames) {
				return A4($author$project$View$DetailsAnimation$combineAnimations, animationNames, duration, 0, 'ease');
			});
		var animateFast = animate(275);
		var animateSlow = animate(325);
		var animateResponsive = F2(
			function (defaultAnimationNames, mediumWidthAnimationNames) {
				return $rtfeldman$elm_css$Css$batch(
					_List_fromArray(
						[
							animateSlow(defaultAnimationNames),
							$author$project$View$Breakpoints$breakpointDetailsMediumWidth(
							_List_fromArray(
								[
									animateFast(mediumWidthAnimationNames)
								]))
						]));
			});
		var _switch = function (direction) {
			var _v0 = _Utils_Tuple2(direction, newOrOld);
			if (_v0.b === 1) {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return A2(
							animateResponsive,
							_List_fromArray(
								['fadePartialOut', 'toFarRight']),
							_List_fromArray(
								['fadePartialOut', 'toRight']));
					case 1:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return A2(
							animateResponsive,
							_List_fromArray(
								['fadePartialOut', 'toFarLeft']),
							_List_fromArray(
								['fadePartialOut', 'toLeft']));
					default:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return animateFast(
							_List_fromArray(
								['fadePartialOut', 'growOut']));
				}
			} else {
				switch (_v0.a) {
					case 0:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return A2(
							animateResponsive,
							_List_fromArray(
								['fadePartialIn', 'fromFarLeft']),
							_List_fromArray(
								['fadePartialIn', 'fromLeft']));
					case 1:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return A2(
							animateResponsive,
							_List_fromArray(
								['fadePartialIn', 'fromFarRight']),
							_List_fromArray(
								['fadePartialIn', 'fromRight']));
					default:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return animateFast(
							_List_fromArray(
								['fadePartialIn', 'fromBottom']));
				}
			}
		};
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$CssShorthand$noStyle,
			A2($elm$core$Maybe$map, _switch, maybeDirection));
	});
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $author$project$CssShorthand$displayFlexRow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]));
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.dZ) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.cD, record.dZ, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{dZ: decl, cD: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.b0;
	var imports = _v0.cp;
	var namespaces = _v0.cE;
	var declarations = _v0.d_;
	return {
		b0: charset,
		d_: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		cp: imports,
		cE: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.cg + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.bL)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.cD;
			var declaration = decl.a.dZ;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.b0;
	var imports = _v0.cp;
	var namespaces = _v0.cE;
	var declarations = _v0.d_;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{dZ: str, cD: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.b0;
	var imports = _v0.cp;
	var namespaces = _v0.cE;
	var snippets = _v0.db;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {b0: charset, d_: declarations, cp: imports, cE: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {b0: $elm$core$Maybe$Nothing, cp: _List_Nil, cE: _List_Nil, db: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$styled = F4(
	function (fn, styles, attrs, children) {
		return A2(
			fn,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Internal$css(styles),
				attrs),
			children);
	});
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $author$project$HtmlShorthand$ariaLabel = $rtfeldman$elm_css$Html$Styled$Attributes$attribute('aria-label');
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute = function (prop) {
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, prop, false, '');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event = F6(
	function (keys, button, clientPos, offsetPos, pagePos, screenPos) {
		return {dL: button, dU: clientPos, eB: keys, e_: offsetPos, e5: pagePos, fv: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$BackButton = 4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ErrorButton = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ForwardButton = 5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MainButton = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MiddleButton = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$SecondButton = 3;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId = function (id) {
	switch (id) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 0;
	}
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder = A2(
	$elm$json$Json$Decode$map,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId,
	A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F3(
	function (alt, ctrl, shift) {
		return {dA: alt, dX: ctrl, fy: shift};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A4(
	$elm$json$Json$Decode$map3,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder = A7($elm$json$Json$Decode$map6, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event, $mpizenberg$elm_pointer_events$Internal$Decode$keys, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder, $mpizenberg$elm_pointer_events$Internal$Decode$clientPos, $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos, $mpizenberg$elm_pointer_events$Internal$Decode$pagePos, $mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onWithOptions = F3(
	function (event, options, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						T: tag(ev),
						fl: options.fl,
						fB: options.fB
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder));
	});
var $author$project$HtmlShorthand$onClickPreventDefault = function (handler) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(
		A3(
			$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onWithOptions,
			'click',
			{fl: true, fB: false},
			handler));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
var $author$project$View$Details$viewCloseLink = F2(
	function (caption, style) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$title(caption),
					$author$project$HtmlShorthand$ariaLabel(caption),
					$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
					$author$project$HtmlShorthand$onClickPreventDefault(
					$elm$core$Basics$always($author$project$Msg$DetailsClose))
				]));
	});
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		Y: 0,
		a1: 0,
		ab: 0,
		L: 0,
		eY: 0,
		a4: 0,
		eZ: val,
		fO: '',
		aV: 0,
		bL: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$CssShorthand$zIndexBackground = $rtfeldman$elm_css$Css$zIndex(
	$rtfeldman$elm_css$Css$int(-1));
var $rtfeldman$elm_css$Css$zero = {k: 0, ar: 0, R: 0, as: 0, at: 0, aa: 0, ab: 0, eY: 0, eZ: 0, ba: 0, fO: '', aV: 0, bL: '0'};
var $author$project$View$Details$viewCloseBackground = A3(
	$author$project$View$Details$viewCloseLink,
	'',
	_List_fromArray(
		[
			$author$project$CssShorthand$zIndexBackground,
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			A2(
			$author$project$CssShorthand$batchMap,
			_List_fromArray(
				[$rtfeldman$elm_css$Css$top, $rtfeldman$elm_css$Css$right, $rtfeldman$elm_css$Css$bottom, $rtfeldman$elm_css$Css$left]),
			$rtfeldman$elm_css$Css$zero)
		]),
	_List_Nil);
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$borderBox = {bs: 0, aW: 0, bL: 'border-box'};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$prop5 = F6(
	function (key, argA, argB, argC, argD, argE) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.bL + (' ' + (argB.bL + (' ' + (argC.bL + (' ' + (argD.bL + (' ' + argE.bL))))))));
	});
var $rtfeldman$elm_css$Css$boxShadow5 = $rtfeldman$elm_css$Css$prop5('box-shadow');
var $author$project$View$Colors$paleGreen = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 0.62, 0.79);
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$View$Button$borderShadow = A5(
	$rtfeldman$elm_css$Css$boxShadow5,
	$rtfeldman$elm_css$Css$px(5),
	$rtfeldman$elm_css$Css$px(5),
	$rtfeldman$elm_css$Css$zero,
	$rtfeldman$elm_css$Css$px(-1),
	$author$project$View$Colors$paleGreen);
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.bL);
};
var $rtfeldman$elm_css$Css$solid = {y: 0, ae: 0, bL: 'solid'};
var $author$project$CssShorthand$borderSidesSolidColor = F2(
	function (sides, color) {
		return $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					A2($author$project$CssShorthand$batchMap, sides, $rtfeldman$elm_css$Css$solid),
					$rtfeldman$elm_css$Css$borderColor(color)
				]));
	});
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $author$project$CssShorthand$borderSolidColor = $author$project$CssShorthand$borderSidesSolidColor(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$borderStyle]));
var $rtfeldman$elm_css$Css$borderWidth = $rtfeldman$elm_css$Css$prop1('border-width');
var $rtfeldman$elm_css$Css$boxSizing = $rtfeldman$elm_css$Css$prop1('box-sizing');
var $author$project$View$Breakpoints$breakpointDetailsMediumHeight = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minHeight(
			$author$project$CssShorthand$rem_(37))
		]));
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $rtfeldman$elm_css$Css$flexBasis = $rtfeldman$elm_css$Css$prop1('flex-basis');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $author$project$CssShorthand$marginTopBottom = $author$project$CssShorthand$batchMap(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$marginTop, $rtfeldman$elm_css$Css$marginBottom]));
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $author$project$CssShorthand$paddingRightLeft = $author$project$CssShorthand$batchMap(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$paddingRight, $rtfeldman$elm_css$Css$paddingLeft]));
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $author$project$CssShorthand$paddingTopBottom = $author$project$CssShorthand$batchMap(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$paddingTop, $rtfeldman$elm_css$Css$paddingBottom]));
var $author$project$View$Metrics$standardBorderRadius = $rtfeldman$elm_css$Css$px(14);
var $author$project$View$Metrics$standardBorderWidth = $rtfeldman$elm_css$Css$px(2);
var $rtfeldman$elm_css$Css$stretch = $rtfeldman$elm_css$Css$prop1('stretch');
var $rtfeldman$elm_css$Css$capitalize = {af: 0, bL: 'capitalize'};
var $rtfeldman$elm_css$Css$flexShrink = $rtfeldman$elm_css$Css$prop1('flex-shrink');
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		ab: 0,
		L: 0,
		au: 0,
		eY: 0,
		a4: 0,
		eZ: val,
		fO: '',
		aV: 0,
		bL: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$Css$textTransform = $rtfeldman$elm_css$Css$prop1('text-transform');
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $rtfeldman$elm_css$Css$backgroundOrigin = $rtfeldman$elm_css$Css$prop1('background-origin');
var $rtfeldman$elm_css$Css$backgroundPosition = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'backgroundPosition',
		'background-position',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$backgroundRepeat = $rtfeldman$elm_css$Css$prop1('background-repeat');
var $rtfeldman$elm_css$Css$backgroundSize = $rtfeldman$elm_css$Css$prop1('background-size');
var $rtfeldman$elm_css$Css$contain = {R: 0, bL: 'contain'};
var $rtfeldman$elm_css$Css$contentBox = {bs: 0, aW: 0, bL: 'content-box'};
var $rtfeldman$elm_css$Css$noRepeat = {ak: 0, O: 0, bL: 'no-repeat'};
var $rtfeldman$elm_css$Css$url = function (urlValue) {
	return {aj: 0, bL: 'url(' + (urlValue + ')')};
};
var $author$project$Icon$iconBackgroundImage = F2(
	function (iconSource, iconBackground) {
		return $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundImage(
					$rtfeldman$elm_css$Css$url(
						iconBackground(iconSource))),
					$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
					$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$contain),
					$rtfeldman$elm_css$Css$backgroundOrigin($rtfeldman$elm_css$Css$contentBox)
				]));
	});
var $rtfeldman$elm_css$Css$inlineBlock = {b8: 0, bL: 'inline-block'};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Icon$iconSpan = F3(
	function (customStyle, iconSource, iconBackground) {
		var style = _List_fromArray(
			[
				A2($author$project$Icon$iconBackgroundImage, iconSource, iconBackground),
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
				A2(
				$author$project$CssShorthand$batchMap,
				_List_fromArray(
					[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
				$rtfeldman$elm_css$Css$px(24)),
				$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(1 - ($author$project$View$Colors$blackLevel / 255))),
				$rtfeldman$elm_css$Css$batch(customStyle)
			]);
		return A4($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$span, style, _List_Nil, _List_Nil);
	});
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $author$project$View$Details$viewCloseButton = function (iconSource) {
	return A3(
		$author$project$View$Details$viewCloseLink,
		'Close',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(-0.1)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$em(1.0))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Icon$iconSpan,
				_List_Nil,
				iconSource,
				function ($) {
					return $.fW;
				})
			]));
};
var $author$project$View$Details$viewHeader = F3(
	function (iconSource, headerText, capitalizeName) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$top),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(1.6)),
				capitalizeName ? $rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$capitalize) : $author$project$CssShorthand$noStyle,
				$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.2)),
				$author$project$View$Breakpoints$breakpointDetailsMediumHeight(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$em(0.4))
					])),
				$rtfeldman$elm_css$Css$flexShrink(
				$rtfeldman$elm_css$Css$num(0))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$h1,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(headerText),
					$author$project$View$Details$viewCloseButton(iconSource)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $author$project$MarkedString$transform = F2(
	function (normal, special) {
		var loop = function (substring) {
			if (!substring.$) {
				var substring2 = substring.a;
				return normal(substring2);
			} else {
				var substring2 = substring.a;
				return special(substring2);
			}
		};
		return $elm$core$List$map(loop);
	});
var $author$project$Display$Details$DetailsNavigateLink = 2;
var $rtfeldman$elm_css$Css$bold = {Y: 0, bL: 'bold'};
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.bL;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $author$project$View$Colors$green = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 1.0, 0.37);
var $author$project$CssShorthand$textDecorationSkipInk = A2($rtfeldman$elm_css$Css$property, 'text-decoration-skip', 'ink');
var $author$project$View$Details$viewNavigateLink = function (name) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$green),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$author$project$CssShorthand$textDecorationSkipInk
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$a,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
				$author$project$HtmlShorthand$onClickPreventDefault(
				$elm$core$Basics$always(
					A2($author$project$Msg$DetailsNavigate, 2, name)))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(name)
			]));
};
var $author$project$View$Details$viewMarkedString = A2($author$project$MarkedString$transform, $rtfeldman$elm_css$Html$Styled$text, $author$project$View$Details$viewNavigateLink);
var $author$project$View$Details$viewIntro = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$flexShrink(
			$rtfeldman$elm_css$Css$num(0))
		]);
	return A2(
		$elm$core$Basics$composeR,
		$author$project$View$Details$viewMarkedString,
		A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$p, style, _List_Nil));
}();
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$empty = $rtfeldman$elm_css$Css$pseudoClass('empty');
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $author$project$CssShorthand$marginRightLeft = $author$project$CssShorthand$batchMap(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$marginRight, $rtfeldman$elm_css$Css$marginLeft]));
var $rtfeldman$elm_css$Css$lastChild = $rtfeldman$elm_css$Css$pseudoClass('last-child');
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $author$project$HtmlShorthand$targetBlank = $rtfeldman$elm_css$Html$Styled$Attributes$target('_blank');
var $rtfeldman$elm_css$Css$textDecoration = $rtfeldman$elm_css$Css$prop1('text-decoration');
var $author$project$View$Details$viewLinkIcon = $author$project$Icon$iconSpan(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$em(0.3))
		]));
var $author$project$View$Details$viewLink = F4(
	function (iconSource, linkText, iconBackground, url) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$em(1.0)),
				$rtfeldman$elm_css$Css$lastChild(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero)
					])),
				$author$project$CssShorthand$paddingTopBottom(
				$rtfeldman$elm_css$Css$em(0.3)),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(0.7)),
				$author$project$CssShorthand$borderSolidColor($author$project$View$Colors$paleGreen),
				$rtfeldman$elm_css$Css$borderWidth(
				$rtfeldman$elm_css$Css$px(1)),
				$rtfeldman$elm_css$Css$borderRadius($author$project$View$Metrics$standardBorderRadius),
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$black),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(url),
					$author$project$HtmlShorthand$targetBlank
				]),
			_List_fromArray(
				[
					A2($author$project$View$Details$viewLinkIcon, iconSource, iconBackground),
					$rtfeldman$elm_css$Html$Styled$text(linkText)
				]));
	});
var $author$project$View$Details$viewLinks = F2(
	function (iconSource, item) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$empty(
				_List_fromArray(
					[$author$project$CssShorthand$displayNone])),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(-0.2)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.5)),
				$author$project$View$Breakpoints$breakpointDetailsMediumHeight(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$em(-0.3)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$em(0.6))
					])),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(0.2)),
				$rtfeldman$elm_css$Css$flexShrink(
				$rtfeldman$elm_css$Css$num(0))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$p,
			style,
			_List_Nil,
			A2(
				$elm$core$List$concatMap,
				$author$project$MaybeEx$toList,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						A3(
							$author$project$View$Details$viewLink,
							iconSource,
							'Homepage',
							function ($) {
								return $.eo;
							}),
						item.cn),
						A2(
						$elm$core$Maybe$map,
						A3(
							$author$project$View$Details$viewLink,
							iconSource,
							'Source code',
							function ($) {
								return $.ek;
							}),
						item.dd)
					])));
	});
var $rtfeldman$elm_css$Css$flexWrap = $rtfeldman$elm_css$Css$prop1('flex-wrap');
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	if (!expression) {
		return '+';
	} else {
		return '-';
	}
};
var $rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2($elm$core$String$startsWith, 'calc(', l.bL) ? A2($elm$core$String$dropLeft, 4, l.bL) : l.bL;
		};
		var calcs = withoutCalcStr(firstExpr) + (' ' + ($rtfeldman$elm_css$Css$calcExpressionToString(expression) + (' ' + withoutCalcStr(secondExpr))));
		var value = A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'calc',
			_List_fromArray(
				[calcs]));
		return {bZ: 0, ap: 0, v: 0, k: 0, ar: 0, R: 0, as: 0, at: 0, aa: 0, ab: 0, L: 0, au: 0, ay: 0, bL: value};
	});
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $rtfeldman$elm_css$Css$Subtraction = 1;
var $rtfeldman$elm_css$Css$minus = 1;
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $author$project$View$Details$viewPoint = function () {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.6)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$em(1.6)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$em(1.6))),
			$author$project$View$Breakpoints$breakpointDetailsMediumHeight(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$em(1.8)),
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$pct(100),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$em(1.8)))
				]))
		]);
	return A2(
		$elm$core$Basics$composeR,
		$author$project$View$Details$viewMarkedString,
		A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$li, style, _List_Nil));
}();
var $rtfeldman$elm_css$Css$wrap = {aJ: 0, a_: 0, bL: 'wrap'};
var $author$project$View$Details$viewPoints = function (points) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(0.6)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$paddingLeft($rtfeldman$elm_css$Css$zero)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$ul,
		style,
		_List_Nil,
		A2($elm$core$List$map, $author$project$View$Details$viewPoint, points));
};
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		aF: 1,
		aH: 0,
		K: 0,
		aL: 0,
		aQ: 0,
		bL: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$String$toLower = _String_toLower;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				aF: alpha / 255,
				aH: blue,
				K: 0,
				aL: green,
				aQ: red,
				bL: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$View$Colors$white = $rtfeldman$elm_css$Css$hex('#ffffff');
var $author$project$View$Details$viewContent = F2(
	function (assets, item) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$borderSolidColor($author$project$View$Colors$black),
				$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$standardBorderWidth),
				$rtfeldman$elm_css$Css$borderRadius($author$project$View$Metrics$standardBorderRadius),
				$author$project$View$Button$borderShadow,
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$stretch),
				$author$project$View$Breakpoints$breakpointDetailsMediumHeight(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
						$author$project$CssShorthand$marginTopBottom(
						$rtfeldman$elm_css$Css$em(1))
					])),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$white),
				$author$project$CssShorthand$paddingTopBottom(
				$rtfeldman$elm_css$Css$em(0.9)),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(1.5)),
				$rtfeldman$elm_css$Css$flexBasis(
				$rtfeldman$elm_css$Css$em(30)),
				$rtfeldman$elm_css$Css$maxHeight(
				$rtfeldman$elm_css$Css$vh(100)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.8))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$View$Details$viewHeader, assets.by, item.cD, item.b_),
					A2($author$project$View$Details$viewLinks, assets.by, item),
					$author$project$View$Details$viewIntro(item.cs),
					$author$project$View$Details$viewPoints(item.cS)
				]));
	});
var $rtfeldman$elm_css$Css$rowReverse = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{bL: 'row-reverse'});
var $author$project$CssShorthand$displayFlexRowReverse = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse)
		]));
var $rtfeldman$elm_css$Css$Transitions$BorderColor = 10;
var $rtfeldman$elm_css$Css$Transitions$Transition = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Transitions$fullTransition = F4(
	function (animation, duration, delay, timing) {
		return {
			dD: animation,
			aX: $elm$core$Maybe$Just(delay),
			cb: duration,
			bm: $elm$core$Maybe$Just(timing)
		};
	});
var $rtfeldman$elm_css$Css$Transitions$borderColor3 = $rtfeldman$elm_css$Css$Transitions$fullTransition(10);
var $rtfeldman$elm_css$Css$Transitions$Color = 29;
var $rtfeldman$elm_css$Css$Transitions$color3 = $rtfeldman$elm_css$Css$Transitions$fullTransition(29);
var $author$project$View$Colors$darkGreen = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 0.82, 0.28);
var $rtfeldman$elm_css$Css$Transitions$EaseInOut = {$: 4};
var $rtfeldman$elm_css$Css$Transitions$easeInOut = $rtfeldman$elm_css$Css$Transitions$EaseInOut;
var $author$project$View$Colors$extraDarkGreen = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 0.62, 0.15);
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
	switch (prop) {
		case 0:
			return 'background';
		case 1:
			return 'background-color';
		case 2:
			return 'background-position';
		case 3:
			return 'background-size';
		case 4:
			return 'border';
		case 5:
			return 'border-bottom';
		case 6:
			return 'border-bottom-color';
		case 7:
			return 'border-bottom-left-radius';
		case 8:
			return 'border-bottom-right-radius';
		case 9:
			return 'border-bottom-width';
		case 10:
			return 'border-color';
		case 11:
			return 'border-left';
		case 12:
			return 'border-left-color';
		case 13:
			return 'border-left-width';
		case 14:
			return 'border-radius';
		case 15:
			return 'border-right';
		case 16:
			return 'border-right-color';
		case 17:
			return 'border-right-width';
		case 18:
			return 'border-top';
		case 19:
			return 'border-top-color';
		case 20:
			return 'border-top-left-radius';
		case 21:
			return 'border-top-right-radius';
		case 22:
			return 'border-top-width';
		case 23:
			return 'border-width';
		case 24:
			return 'bottom';
		case 25:
			return 'box-shadow';
		case 26:
			return 'caret-color';
		case 27:
			return 'clip';
		case 28:
			return 'clip-path';
		case 29:
			return 'color';
		case 30:
			return 'column-count';
		case 31:
			return 'column-gap';
		case 32:
			return 'column-rule';
		case 33:
			return 'column-rule-color';
		case 34:
			return 'column-rule-width';
		case 35:
			return 'column-width';
		case 36:
			return 'columns';
		case 37:
			return 'filter';
		case 38:
			return 'flex';
		case 39:
			return 'flex-basis';
		case 40:
			return 'flex-grow';
		case 41:
			return 'flex-shrink';
		case 42:
			return 'font';
		case 43:
			return 'font-size';
		case 44:
			return 'font-size-adjust';
		case 45:
			return 'font-stretch';
		case 46:
			return 'font-variation-settings';
		case 47:
			return 'font-weight';
		case 48:
			return 'grid-column-gap';
		case 49:
			return 'grid-gap';
		case 50:
			return 'grid-row-gap';
		case 51:
			return 'height';
		case 52:
			return 'left';
		case 53:
			return 'letter-spacing';
		case 54:
			return 'line-height';
		case 55:
			return 'margin';
		case 56:
			return 'margin-bottom';
		case 57:
			return 'margin-left';
		case 58:
			return 'margin-right';
		case 59:
			return 'margin-top';
		case 60:
			return 'mask';
		case 61:
			return 'mask-position';
		case 62:
			return 'mask-size';
		case 63:
			return 'max-height';
		case 64:
			return 'max-width';
		case 65:
			return 'min-height';
		case 66:
			return 'min-width';
		case 67:
			return 'object-position';
		case 68:
			return 'offset';
		case 69:
			return 'offset-anchor';
		case 70:
			return 'offset-distance';
		case 71:
			return 'offset-path';
		case 72:
			return 'offset-rotate';
		case 73:
			return 'opacity';
		case 74:
			return 'order';
		case 75:
			return 'outline';
		case 76:
			return 'outline-color';
		case 77:
			return 'outline-offset';
		case 78:
			return 'outline-width';
		case 79:
			return 'padding';
		case 80:
			return 'padding-bottom';
		case 81:
			return 'padding-left';
		case 82:
			return 'padding-right';
		case 83:
			return 'padding-top';
		case 84:
			return 'right';
		case 85:
			return 'tab-size';
		case 86:
			return 'text-indent';
		case 87:
			return 'text-shadow';
		case 88:
			return 'top';
		case 89:
			return 'transform';
		case 90:
			return 'transform-origin';
		case 91:
			return 'vertical-align';
		case 92:
			return 'visibility';
		case 93:
			return 'width';
		case 94:
			return 'word-spacing';
		default:
			return 'z-index';
	}
};
var $rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
	return $elm$core$String$fromFloat(time) + 'ms';
};
var $rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
	switch (tf.$) {
		case 0:
			return 'ease';
		case 1:
			return 'linear';
		case 2:
			return 'ease-in';
		case 3:
			return 'ease-out';
		case 4:
			return 'ease-in-out';
		case 5:
			return 'step-start';
		case 6:
			return 'step-end';
		default:
			var _float = tf.a;
			var float2 = tf.b;
			var float3 = tf.c;
			var float4 = tf.d;
			return 'cubic-bezier(' + ($elm$core$String$fromFloat(_float) + (' , ' + ($elm$core$String$fromFloat(float2) + (' , ' + ($elm$core$String$fromFloat(float3) + (' , ' + ($elm$core$String$fromFloat(float4) + ')')))))));
	}
};
var $rtfeldman$elm_css$Css$Transitions$transition = function (options) {
	var v = A3(
		$elm$core$String$slice,
		0,
		-1,
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, s) {
					var animation = _v0.dD;
					var duration = _v0.cb;
					var delay = _v0.aX;
					var timing = _v0.bm;
					return s + ($rtfeldman$elm_css$Css$Transitions$propToString(animation) + (' ' + ($rtfeldman$elm_css$Css$Transitions$timeToString(duration) + (' ' + (A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timeToString, delay)) + (' ' + (A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing)) + ',')))))));
				}),
			'',
			options));
	return A2($rtfeldman$elm_css$Css$property, 'transition', v);
};
var $author$project$View$Button$border = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$CssShorthand$borderSolidColor($author$project$View$Colors$black),
			$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$standardBorderWidth),
			$rtfeldman$elm_css$Css$borderRadius($author$project$View$Metrics$standardBorderRadius),
			$author$project$View$Button$borderShadow,
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Transitions$borderColor3, 200, 0, $rtfeldman$elm_css$Css$Transitions$easeInOut),
					A3($rtfeldman$elm_css$Css$Transitions$color3, 400, 0, $rtfeldman$elm_css$Css$Transitions$easeInOut)
				])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$author$project$CssShorthand$borderSolidColor($author$project$View$Colors$darkGreen),
					$rtfeldman$elm_css$Css$color($author$project$View$Colors$extraDarkGreen)
				]))
		]));
var $author$project$View$Breakpoints$breakpointDetailsSmallWidth = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_(33))
		]));
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$flexGrow = $rtfeldman$elm_css$Css$prop1('flex-grow');
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $author$project$HtmlShorthand$styledSpanText = F2(
	function (styles, string) {
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$span,
			styles,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(string)
				]));
	});
var $rtfeldman$elm_css$Css$underline = {ax: 0, bL: 'underline'};
var $author$project$View$Details$viewNavigateButton = F7(
	function (displayStyle, direction, directionName, linkNameSelector, iconBackground, assets, item) {
		var iconSource = assets.by;
		var descriptionStyle = _List_fromArray(
			[
				$author$project$CssShorthand$displayNone,
				$author$project$View$Breakpoints$breakpointDetailsMediumWidth(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexColumn])),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.7)),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(1)),
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$em(11))
			]);
		var descriptionLinkStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$green),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
			]);
		var containerStyle = _List_fromArray(
			[
				$author$project$CssShorthand$displayNone,
				$author$project$View$Breakpoints$breakpointDetailsSmallWidth(
				_List_fromArray(
					[displayStyle])),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
				$rtfeldman$elm_css$Css$flexBasis(
				$rtfeldman$elm_css$Css$em(0)),
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(1))
			]);
		var buttonStyle = _List_fromArray(
			[
				$author$project$View$Button$border,
				displayStyle,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(0.9)),
				$author$project$View$Breakpoints$breakpointDetailsMediumWidth(
				_List_fromArray(
					[
						$author$project$CssShorthand$marginRightLeft(
						$rtfeldman$elm_css$Css$em(1.4))
					])),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$white),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$em(0.6)),
				$author$project$View$Breakpoints$breakpointDetailsMediumWidth(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$em(0.5))
					])),
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$black),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
			]);
		var viewButton = function (linkName) {
			return A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$a,
				buttonStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
						$author$project$HtmlShorthand$onClickPreventDefault(
						$elm$core$Basics$always(
							A2($author$project$Msg$DetailsNavigate, direction, linkName)))
					]),
				_List_fromArray(
					[
						A3($author$project$Icon$iconSpan, _List_Nil, iconSource, iconBackground),
						A4(
						$rtfeldman$elm_css$Html$Styled$styled,
						$rtfeldman$elm_css$Html$Styled$div,
						descriptionStyle,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$HtmlShorthand$styledSpanText,
								_List_Nil,
								$elm$core$String$concat(
									_List_fromArray(
										[directionName, ' ', item.cK, ':']))),
								A2($author$project$HtmlShorthand$styledSpanText, descriptionLinkStyle, linkName)
							]))
					]));
		};
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$span,
			containerStyle,
			_List_Nil,
			$author$project$MaybeEx$toList(
				A2(
					$elm$core$Maybe$map,
					viewButton,
					linkNameSelector(item))));
	});
var $author$project$View$Details$viewNext = A5(
	$author$project$View$Details$viewNavigateButton,
	$author$project$CssShorthand$displayFlexRowReverse,
	1,
	'Next',
	function ($) {
		return $.cI;
	},
	function ($) {
		return $.dS;
	});
var $author$project$View$Details$viewPrevious = A5(
	$author$project$View$Details$viewNavigateButton,
	$author$project$CssShorthand$displayFlexRow,
	0,
	'Previous',
	function ($) {
		return $.cV;
	},
	function ($) {
		return $.dR;
	});
var $author$project$CssShorthand$willChangeTransform = A2($rtfeldman$elm_css$Css$property, 'will-change', 'transform');
var $author$project$CssShorthand$zIndexNormal = $rtfeldman$elm_css$Css$zIndex(
	$rtfeldman$elm_css$Css$int(0));
var $author$project$CssShorthand$zIndexOverlay = $rtfeldman$elm_css$Css$zIndex(
	$rtfeldman$elm_css$Css$int(1));
var $author$project$View$Details$viewDetailsItem = F4(
	function (isNew, assets, details, item) {
		var style = _List_fromArray(
			[
				isNew ? $author$project$CssShorthand$zIndexOverlay : $author$project$CssShorthand$zIndexNormal,
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$vh(-100)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$vh(100)),
				$author$project$CssShorthand$willChangeTransform,
				A2($author$project$View$DetailsAnimation$animateDetailsItem, isNew, details)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Details$viewCloseBackground,
					A2($author$project$View$Details$viewPrevious, assets, item),
					A2($author$project$View$Details$viewContent, assets, item),
					A2($author$project$View$Details$viewNext, assets, item)
				]));
	});
var $author$project$View$Details$maybeViewDetailsBuffer = F3(
	function (isFirstBuffer, assets, details) {
		var viewOld = A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$Just,
			A3($author$project$View$Details$viewDetailsItem, false, assets, details));
		var viewNew = $elm$core$Maybe$Just(
			A4($author$project$View$Details$viewDetailsItem, true, assets, details, details.ez));
		var _v0 = _Utils_Tuple3(isFirstBuffer, details.ca, details.dD);
		_v0$4:
		while (true) {
			if (_v0.a) {
				if (!_v0.b) {
					var _v1 = _v0.b;
					return viewNew;
				} else {
					if (_v0.c.$ === 2) {
						var _v3 = _v0.b;
						var oldItemData = _v0.c.a.e$;
						return viewOld(oldItemData);
					} else {
						break _v0$4;
					}
				}
			} else {
				if (_v0.b === 1) {
					var _v2 = _v0.b;
					return viewNew;
				} else {
					if (_v0.c.$ === 2) {
						var _v4 = _v0.b;
						var oldItemData = _v0.c.a.e$;
						return viewOld(oldItemData);
					} else {
						break _v0$4;
					}
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $rtfeldman$elm_css$Css$Structure$NotQuery = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$not = $rtfeldman$elm_css$Css$Structure$NotQuery;
var $rtfeldman$elm_css$Css$Structure$Print = 0;
var $rtfeldman$elm_css$Css$Media$print = 0;
var $rtfeldman$elm_css$Css$Media$withMedia = $rtfeldman$elm_css$Css$Preprocess$WithMedia;
var $author$project$CssShorthand$mediaNotPrint = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$Media$not, $rtfeldman$elm_css$Css$Media$print, _List_Nil)
		]));
var $author$project$View$Metrics$standardLineHeight = 1.7;
var $author$project$View$Metrics$standardScreenFontSizeLarge = $rtfeldman$elm_css$Css$pct(145);
var $author$project$View$Metrics$standardScreenFontSizeSmall = $rtfeldman$elm_css$Css$pct(125);
var $author$project$View$Details$viewDetails = F2(
	function (assets, details) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayNone,
				$author$project$CssShorthand$mediaNotPrint(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexColumn])),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
				A2(
				$author$project$CssShorthand$batchMap,
				_List_fromArray(
					[$rtfeldman$elm_css$Css$top, $rtfeldman$elm_css$Css$right, $rtfeldman$elm_css$Css$bottom, $rtfeldman$elm_css$Css$left]),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$extraPaleGreen),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardScreenFontSizeSmall),
				$author$project$View$Breakpoints$breakpointDetailsLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardScreenFontSizeLarge)
					])),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num($author$project$View$Metrics$standardLineHeight)),
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$black),
				$author$project$CssShorthand$willChangeTransform,
				$author$project$View$DetailsAnimation$animateDetails(details)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			A2(
				$elm$core$List$concatMap,
				$author$project$MaybeEx$toList,
				_List_fromArray(
					[
						A3($author$project$View$Details$maybeViewDetailsBuffer, true, assets, details),
						A3($author$project$View$Details$maybeViewDetailsBuffer, false, assets, details)
					])));
	});
var $author$project$View$Details$maybeViewDetails = F2(
	function (assets, display) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$View$Details$viewDetails(assets),
			display.b6);
	});
var $author$project$View$DetailsAnimation$Portfolio = 0;
var $author$project$View$DetailsAnimation$animatePortfolio = function (display) {
	var _v0 = display.b6;
	if (!_v0.$) {
		var details = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$CssShorthand$noStyle,
			A2($author$project$View$DetailsAnimation$animateProtfolioAndDetails, 0, details));
	} else {
		return $author$project$CssShorthand$animation(
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['fadeIn', '300ms', 'ease-out'])));
	}
};
var $author$project$View$Breakpoints$breakpointPortfolioMedium = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_(46))
		]));
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$LazyHtml$toLazyHtml = function (html) {
	return html;
};
var $rtfeldman$elm_css$Css$borderBottomStyle = $rtfeldman$elm_css$Css$prop1('border-bottom-style');
var $rtfeldman$elm_css$Css$borderTopStyle = $rtfeldman$elm_css$Css$prop1('border-top-style');
var $author$project$CssShorthand$borderTopBottomSolidColor = $author$project$CssShorthand$borderSidesSolidColor(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$borderTopStyle, $rtfeldman$elm_css$Css$borderBottomStyle]));
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node('nav');
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $author$project$View$Contents$viewHeader = function () {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.5))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$h2,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Portfolio contents')
			]));
}();
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $rtfeldman$elm_css$Css$noWrap = {aJ: 0, a_: 0, bL: 'nowrap', ai: 0};
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $author$project$View$Button$sizeMedium = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$CssShorthand$paddingRightLeft(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(2.1)),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
		]));
var $author$project$View$Button$text = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$black),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]));
var $author$project$View$Contents$viewLinkButton = F2(
	function (fragmentID, linkText) {
		var style = _List_fromArray(
			[
				$author$project$View$Button$border,
				$author$project$View$Button$sizeMedium,
				$author$project$View$Button$text,
				$author$project$CssShorthand$marginTopBottom(
				$rtfeldman$elm_css$Css$px(10)),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$px(18)),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$em(6.2))
					]))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('#' + fragmentID)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(linkText)
				]));
	});
var $author$project$View$Contents$viewLinkIcon = $author$project$Icon$iconSpan(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(-24)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero)
				]))
		]));
var $author$project$View$Contents$viewLink = F4(
	function (assets, data, reverse, sectionDataSelector) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRowReverse,
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						reverse ? $author$project$CssShorthand$displayFlexRowReverse : $author$project$CssShorthand$displayFlexRow
					])),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
			]);
		var sectionData = sectionDataSelector(data);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$span,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$Contents$viewLinkIcon, assets.by, sectionData.fd),
					A2($author$project$View$Contents$viewLinkButton, sectionData.er, sectionData.cD)
				]));
	});
var $author$project$View$Contents$viewLinksColumn = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]);
	return A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, style, _List_Nil);
}();
var $author$project$View$Contents$viewLinks = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexRow])),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(12))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Contents$viewLinksColumn(
					_List_fromArray(
						[
							A4(
							$author$project$View$Contents$viewLink,
							assets,
							data,
							false,
							function ($) {
								return $.du;
							}),
							A4(
							$author$project$View$Contents$viewLink,
							assets,
							data,
							false,
							function ($) {
								return $.cA;
							})
						])),
					$author$project$View$Contents$viewLinksColumn(
					_List_fromArray(
						[
							A4(
							$author$project$View$Contents$viewLink,
							assets,
							data,
							true,
							function ($) {
								return $.dl;
							}),
							A4(
							$author$project$View$Contents$viewLink,
							assets,
							data,
							true,
							function ($) {
								return $.cY;
							})
						]))
				]));
	});
var $author$project$View$Contents$viewContents = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$author$project$CssShorthand$borderTopBottomSolidColor($author$project$View$Colors$black),
				$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$standardBorderWidth),
				A5(
				$rtfeldman$elm_css$Css$boxShadow5,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(1),
				$author$project$View$Colors$paleGreen),
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$em(1.3)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$em(1.0)),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$paddingTop(
						$rtfeldman$elm_css$Css$em(1.8)),
						$rtfeldman$elm_css$Css$paddingBottom(
						$rtfeldman$elm_css$Css$em(1.5))
					]))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$nav,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('contents')
				]),
			_List_fromArray(
				[
					$author$project$View$Contents$viewHeader,
					A2($author$project$View$Contents$viewLinks, assets, data)
				]));
	});
var $author$project$CssShorthand$borderBottomSolidColor = $author$project$CssShorthand$borderSidesSolidColor(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$borderBottomStyle]));
var $rtfeldman$elm_css$Html$Styled$footer = $rtfeldman$elm_css$Html$Styled$node('footer');
var $rtfeldman$elm_css$Css$initial = {bP: 0, p: 0, aG: 0, bT: 0, aj: 0, bU: 0, ak: 0, O: 0, y: 0, aW: 0, K: 0, b: 0, b8: 0, ap: 0, bw: 0, aJ: 0, a_: 0, X: 0, v: 0, aK: 0, f: 0, Y: 0, a1: 0, ct: 0, bB: 0, k: 0, ar: 0, R: 0, as: 0, at: 0, aa: 0, ab: 0, L: 0, au: 0, a2: 0, d: 0, c: 0, bE: 0, eY: 0, eZ: 0, ba: 0, av: 0, H: 0, bk: 0, ax: 0, ae: 0, ay: 0, az: 0, af: 0, B: 0, fO: '', aV: 0, bL: 'initial', fU: 0, ai: 0};
var $author$project$CssShorthand$displayInitial = $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$initial);
var $author$project$View$Button$sizeLarge = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$CssShorthand$paddingRightLeft(
			$rtfeldman$elm_css$Css$em(1.1)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(2.4)),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
		]));
var $author$project$View$Footer$viewButton = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Button$border,
			$author$project$View$Button$sizeLarge,
			$author$project$View$Button$text,
			$author$project$CssShorthand$displayNone,
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[$author$project$CssShorthand$displayInitial])),
			$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.5))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$a,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href('#top')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Go back to the top')
			]));
}();
var $rtfeldman$elm_css$Css$firstOfType = $rtfeldman$elm_css$Css$pseudoClass('first-of-type');
var $author$project$View$CallsToAction$viewCallToActionButton = A2(
	$rtfeldman$elm_css$Html$Styled$styled,
	$rtfeldman$elm_css$Html$Styled$a,
	_List_fromArray(
		[
			$author$project$View$Button$border,
			$author$project$View$Button$sizeLarge,
			$author$project$View$Button$text,
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$px(18))
		]));
var $author$project$View$CallsToAction$viewCallToActionIcon = $author$project$Icon$iconSpan(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(-32)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(8))
				]))
		]));
var $author$project$View$CallsToAction$viewCallToAction = F5(
	function (iconSource, displayStyle, iconBackground, attributes, elements) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRowReverse,
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[displayStyle])),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(1.1)),
				$rtfeldman$elm_css$Css$firstOfType(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero)
					])),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$num(1))
					]))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$CallsToAction$viewCallToActionIcon, iconSource, iconBackground),
					A2($author$project$View$CallsToAction$viewCallToActionButton, attributes, elements)
				]));
	});
var $author$project$View$CallsToAction$viewCallToActionExtra = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexRow])),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(1.4))
			]);
		var iconSource = assets.by;
		var emailAddress = data.bV.cd;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A5(
					$author$project$View$CallsToAction$viewCallToAction,
					iconSource,
					$author$project$CssShorthand$displayFlexRow,
					function ($) {
						return $.eG;
					},
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:' + (emailAddress + '?subject=Hi')),
							$author$project$HtmlShorthand$targetBlank
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Send me an email')
						])),
					A5(
					$author$project$View$CallsToAction$viewCallToAction,
					iconSource,
					$author$project$CssShorthand$displayFlexRowReverse,
					function ($) {
						return $.fS;
					},
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('#resume')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('View my resume')
						]))
				]));
	});
var $author$project$View$Links$viewLink = F2(
	function (iconSource, linksItem) {
		var style = _List_fromArray(
			[
				$author$project$View$Button$border,
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(0.8)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num(2.4)),
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$author$project$CssShorthand$marginTopBottom(
				$rtfeldman$elm_css$Css$em(0.5)),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(0.7)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.85)),
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$black),
				$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
			]);
		var iconStyle = _List_fromArray(
			[
				A2(
				$author$project$CssShorthand$batchMap,
				_List_fromArray(
					[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
				$rtfeldman$elm_css$Css$em(1.5)),
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$em(0.5))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$author$project$HtmlShorthand$ariaLabel(linksItem.cD),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(linksItem.fR),
					$author$project$HtmlShorthand$targetBlank
				]),
			_List_fromArray(
				[
					A3($author$project$Icon$iconSpan, iconStyle, iconSource, linksItem.eq),
					$rtfeldman$elm_css$Html$Styled$text(linksItem.cD)
				]));
	});
var $author$project$View$Links$viewLinks = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(1.2)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(2.0))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$View$Links$viewLink(assets.by),
				data.cy.ff));
	});
var $author$project$View$GroupBox$border = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$CssShorthand$borderSolidColor($author$project$View$Colors$paleGreen),
			$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$standardBorderWidth),
			$rtfeldman$elm_css$Css$borderRadius($author$project$View$Metrics$standardBorderRadius)
		]));
var $author$project$View$CallsToAction$viewMeetingButton = function (data) {
	var meetingURL = data.bV.cz;
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$author$project$View$Button$border,
				$author$project$View$Button$sizeLarge,
				$author$project$View$Button$text,
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(0.8)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$white)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href(meetingURL),
				$author$project$HtmlShorthand$targetBlank
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Book a virtual meeting')
			]));
};
var $rtfeldman$elm_css$Css$normal = {ch: 0, aK: 0, Y: 0, au: 0, cP: 0, bL: 'normal', ai: 0};
var $author$project$View$CallsToAction$viewMeetingDescription = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$h2,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Let’s chat.')
			]));
}();
var $author$project$View$CallsToAction$viewMeeting = function (data) {
	var style = _List_fromArray(
		[
			$author$project$View$GroupBox$border,
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1.2)),
			$author$project$CssShorthand$paddingTopBottom(
			$rtfeldman$elm_css$Css$em(1.2)),
			$author$project$CssShorthand$paddingRightLeft(
			$rtfeldman$elm_css$Css$em(1.4)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$extraPaleGreen)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$CallsToAction$viewMeetingDescription,
				$author$project$View$CallsToAction$viewMeetingButton(data)
			]));
};
var $author$project$View$CallsToAction$viewCallsToAction = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[$author$project$CssShorthand$displayFlexColumn]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$CallsToAction$viewMeeting(data),
					A2($author$project$View$CallsToAction$viewCallToActionExtra, assets, data),
					A2($author$project$View$Links$viewLinks, assets, data)
				]));
	});
var $author$project$View$Footer$viewDescription = function () {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(3.0)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(1.0))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$p,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Thanks so much for taking the time to view my portfolio. Want to learn more?')
			]));
}();
var $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node('br');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fill = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill');
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$g = $rtfeldman$elm_css$Svg$Styled$node('g');
var $rtfeldman$elm_css$Svg$Styled$Attributes$points = $rtfeldman$elm_css$VirtualDom$Styled$attribute('points');
var $rtfeldman$elm_css$Svg$Styled$polygon = $rtfeldman$elm_css$Svg$Styled$node('polygon');
var $rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classAttribute = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classAttribute, true, cssTemplate);
};
var $rtfeldman$elm_css$Svg$Styled$styled = F2(
	function (fn, styles) {
		var stylesAttribute = $rtfeldman$elm_css$Svg$Styled$Internal$css(styles);
		return F2(
			function (attrs, children) {
				return A2(
					fn,
					A2($elm$core$List$cons, stylesAttribute, attrs),
					children);
			});
	});
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $rtfeldman$elm_css$Svg$Styled$Attributes$transform = $rtfeldman$elm_css$VirtualDom$Styled$attribute('transform');
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $author$project$View$ElmLogo$viewElmLogo = function () {
	var style = _List_fromArray(
		[
			A2(
			$author$project$CssShorthand$batchMap,
			_List_fromArray(
				[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
			$rtfeldman$elm_css$Css$em(0.9)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(-0.1)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$em(0.1))
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$svg,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('-300 -300 600 600')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$g,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$transform('scale(1 -1)')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 1)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-280,-90 0,190 280,-90'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(0 -210) rotate(0)')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 1)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-280,-90 0,190 280,-90'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-210 0) rotate(-90)')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 0.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-198,-66 0,132 198,-66'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(207 207) rotate(-45)')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 1)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-130,0 0,-130 130,0 0,130'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(150 0) rotate(0)')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 0.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-191,61 69,61 191,-61 -69,-61'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-89 239) rotate(0)')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 0.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-130,-44 0,86  130,-44'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(0 106) rotate(-180)')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('rgba(18, 147, 216, 0.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('-130,-44 0,86  130,-44'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(256 -150) rotate(-270)')
							]),
						_List_Nil)
					]))
			]));
}();
var $author$project$View$Footer$viewInfo = function (sourceURL) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(0.5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(1.5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.85)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5))
		]);
	var linkStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$black)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$p,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('This website was made with '),
				A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$a,
				linkStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href('http://elm-lang.org/'),
						$author$project$HtmlShorthand$targetBlank
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Elm')
					])),
				$rtfeldman$elm_css$Html$Styled$text(' '),
				$author$project$View$ElmLogo$viewElmLogo,
				A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
				A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$a,
				linkStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(sourceURL),
						$author$project$HtmlShorthand$targetBlank
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('(view source)')
					]))
			]));
};
var $rtfeldman$elm_css$Html$Styled$blockquote = $rtfeldman$elm_css$Html$Styled$node('blockquote');
var $rtfeldman$elm_css$Html$Styled$cite = $rtfeldman$elm_css$Html$Styled$node('cite');
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$italic = {aK: 0, bL: 'italic'};
var $author$project$View$Footer$viewQuote = function (quote) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1.4)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(1.0)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.85)),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$green)
		]);
	var citeStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$em(0.6))
		]);
	var _v0 = quote;
	var quoteText = _v0.a;
	var quoteCite = _v0.b;
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$blockquote,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(quoteText),
				A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$cite,
				citeStyle,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('— ' + quoteCite)
					]))
			]));
};
var $author$project$View$Footer$viewFooter = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$author$project$CssShorthand$borderBottomSolidColor($author$project$View$Colors$paleGreen),
				$rtfeldman$elm_css$Css$borderWidth(
				$rtfeldman$elm_css$Css$px(6))
			]);
		var basicData = data.bV;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$footer,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('fin')
				]),
			_List_fromArray(
				[
					$author$project$View$Footer$viewDescription,
					A2($author$project$View$CallsToAction$viewCallsToAction, assets, data),
					$author$project$View$Footer$viewButton,
					$author$project$View$Footer$viewQuote(basicData.c0),
					$author$project$View$Footer$viewInfo(basicData.dd)
				]));
	});
var $rtfeldman$elm_css$Css$relative = {aP: 0, bL: 'relative'};
var $rtfeldman$elm_css$Css$absolute = {aP: 0, bL: 'absolute'};
var $author$project$View$Frame$viewFrameRow = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]);
	return A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, style, _List_Nil);
}();
var $author$project$View$Leaf$leafSizeMaxSizeRem = 10;
var $author$project$View$Leaf$leafSizeVw = 17;
var $author$project$View$Leaf$breakpointMaxSizeRem = $author$project$View$Leaf$leafSizeMaxSizeRem / ($author$project$View$Leaf$leafSizeVw / 100);
var $rtfeldman$elm_css$Css$Media$maxWidth = function (value) {
	return A2($rtfeldman$elm_css$Css$Media$feature, 'max-width', value);
};
var $author$project$CssShorthand$mediaInverseConditions = function (conditions) {
	return A2($author$project$CssShorthand$mediaCustomConditions, _List_Nil, conditions);
};
var $author$project$View$Leaf$breakpointMaxSize = $author$project$CssShorthand$mediaInverseConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$maxWidth(
			$author$project$CssShorthand$rem_($author$project$View$Leaf$breakpointMaxSizeRem))
		]));
var $author$project$View$Leaf$leafSizeMinSizeRem = 4;
var $author$project$View$Leaf$breakpointMinSizeRem = $author$project$View$Leaf$leafSizeMinSizeRem / ($author$project$View$Leaf$leafSizeVw / 100);
var $author$project$View$Leaf$breakpointMinSize = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_($author$project$View$Leaf$breakpointMinSizeRem)),
			$rtfeldman$elm_css$Css$Media$maxWidth(
			$author$project$CssShorthand$rem_($author$project$View$Leaf$breakpointMaxSizeRem))
		]));
var $author$project$View$Breakpoints$breakpointPortfolioLarge = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_(73))
		]));
var $author$project$SvgShorthand$valueProperty = function (name) {
	return A2(
		$elm$core$Basics$composeL,
		$rtfeldman$elm_css$Css$property(name),
		function ($) {
			return $.bL;
		});
};
var $author$project$SvgShorthand$fill = $author$project$SvgShorthand$valueProperty('fill');
var $author$project$SvgShorthand$Transform = F2(
	function (name, values) {
		return {cD: name, dq: values};
	});
var $author$project$SvgShorthand$flipAxes = F2(
	function (flipX, flipY) {
		return A2(
			$author$project$SvgShorthand$Transform,
			'scale',
			_List_fromArray(
				[
					flipX ? (-1) : 1,
					flipY ? (-1) : 1
				]));
	});
var $author$project$View$Leaf$leafViewBox = 100;
var $author$project$View$Leaf$leafCenter = $author$project$View$Leaf$leafViewBox / 2;
var $author$project$View$Leaf$leafCycle = 2500;
var $author$project$View$Leaf$leafDelayOffset = $author$project$View$Leaf$leafCycle * 0.08;
var $author$project$View$Leaf$leafOpacity = 0.4;
var $author$project$SvgShorthand$scale = function (size) {
	return A2(
		$author$project$SvgShorthand$Transform,
		'scale',
		_List_fromArray(
			[size]));
};
var $author$project$SvgShorthand$stroke = $author$project$SvgShorthand$valueProperty('stroke');
var $author$project$SvgShorthand$transformToString = function (_v0) {
	var name = _v0.cD;
	var values = _v0.dq;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				name,
				'(',
				A2(
				$elm$core$String$join,
				',',
				A2($elm$core$List$map, $elm$core$String$fromFloat, values)),
				')'
			]));
};
var $author$project$SvgShorthand$transform = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$SvgShorthand$transformToString),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(' '),
		$rtfeldman$elm_css$Html$Styled$Attributes$attribute('transform')));
var $author$project$SvgShorthand$translate = F2(
	function (x, y) {
		return A2(
			$author$project$SvgShorthand$Transform,
			'translate',
			_List_fromArray(
				[x, y]));
	});
var $author$project$SvgShorthand$viewBox = F2(
	function (_v0, _v1) {
		var minX = _v0.a;
		var minY = _v0.b;
		var width = _v1.a;
		var height = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, width, height]))));
	});
var $author$project$SvgShorthand$viewBoxRect = F2(
	function (width, height) {
		return A2(
			$author$project$SvgShorthand$viewBox,
			_Utils_Tuple2(0, 0),
			_Utils_Tuple2(width, height));
	});
var $author$project$SvgShorthand$viewBoxSquare = function (size) {
	return A2($author$project$SvgShorthand$viewBoxRect, size, size);
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var $author$project$View$Leaf$leafPathData = 'M 4,15 C 22,59 43,93 96,79 C 74,39 57,-9 4,15 Z';
var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node('path');
var $author$project$SvgShorthand$rotate = F2(
	function (degrees, _v0) {
		var centerX = _v0.a;
		var centerY = _v0.b;
		return A2(
			$author$project$SvgShorthand$Transform,
			'rotate',
			_List_fromArray(
				[degrees, centerX, centerY]));
	});
var $author$project$SvgShorthand$strokeWidth = $author$project$SvgShorthand$valueProperty('stroke-width');
var $author$project$SvgShorthand$strokeWidthUnscaled = F2(
	function (length, scaleBy) {
		return $author$project$SvgShorthand$strokeWidth(
			_Utils_update(
				length,
				{
					bL: _Utils_ap(
						$elm$core$String$fromFloat(length.eZ / scaleBy),
						length.fO)
				}));
	});
var $author$project$View$Leaf$viewLeafPath = F6(
	function (reverseAnimation, delay, parentSize, size, degrees, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		var style = _List_fromArray(
			[
				A2(
				$author$project$SvgShorthand$strokeWidthUnscaled,
				$rtfeldman$elm_css$Css$px(2),
				parentSize * size),
				$author$project$CssShorthand$animation(
				A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'leafCycle',
							$elm$core$String$fromFloat($author$project$View$Leaf$leafCycle) + 'ms',
							$elm$core$String$fromFloat(delay) + 'ms',
							'infinite',
							reverseAnimation ? 'alternate-reverse' : 'alternate',
							'both'
						])))
			]);
		return A2(
			$rtfeldman$elm_css$Svg$Styled$g,
			_List_fromArray(
				[
					$author$project$SvgShorthand$transform(
					_List_fromArray(
						[
							A2($author$project$SvgShorthand$translate, x, y),
							$author$project$SvgShorthand$scale(size),
							A2(
							$author$project$SvgShorthand$rotate,
							degrees,
							_Utils_Tuple2($author$project$View$Leaf$leafCenter, $author$project$View$Leaf$leafCenter))
						]))
				]),
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Svg$Styled$styled,
					$rtfeldman$elm_css$Svg$Styled$path,
					style,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$View$Leaf$leafPathData)
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$visibility = $rtfeldman$elm_css$Css$prop1('visibility');
var $rtfeldman$elm_css$Css$VwUnits = 0;
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var $elm$core$Basics$xor = _Basics_xor;
var $author$project$View$Leaf$viewLeaf = function (config) {
	var style = _List_fromArray(
		[
			config.bi ? $rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$initial) : $rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
			$author$project$View$Breakpoints$breakpointPortfolioLarge(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$initial)
				])),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					config.bh ? $rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$initial) : $rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden)
				])),
			A2(
			$author$project$CssShorthand$batchMap,
			_List_fromArray(
				[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
			$author$project$CssShorthand$rem_($author$project$View$Leaf$leafSizeMinSizeRem)),
			$author$project$View$Leaf$breakpointMinSize(
			_List_fromArray(
				[
					A2(
					$author$project$CssShorthand$batchMap,
					_List_fromArray(
						[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
					$rtfeldman$elm_css$Css$vw($author$project$View$Leaf$leafSizeVw))
				])),
			$author$project$View$Leaf$breakpointMaxSize(
			_List_fromArray(
				[
					A2(
					$author$project$CssShorthand$batchMap,
					_List_fromArray(
						[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
					$author$project$CssShorthand$rem_($author$project$View$Leaf$leafSizeMaxSizeRem))
				])),
			$author$project$SvgShorthand$fill($author$project$View$Colors$extraPaleGreen),
			$author$project$SvgShorthand$stroke($author$project$View$Colors$paleGreen),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num($author$project$View$Leaf$leafOpacity))
		]);
	var reverseAnimation = config.a$ !== config.a0;
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$svg,
		style,
		_List_fromArray(
			[
				$author$project$SvgShorthand$viewBoxSquare($author$project$View$Leaf$leafViewBox)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$g,
				_List_fromArray(
					[
						$author$project$SvgShorthand$transform(
						_List_fromArray(
							[
								A2($author$project$SvgShorthand$translate, $author$project$View$Leaf$leafCenter, $author$project$View$Leaf$leafCenter),
								A2($author$project$SvgShorthand$flipAxes, config.a$, config.a0),
								A2($author$project$SvgShorthand$translate, -$author$project$View$Leaf$leafCenter, -$author$project$View$Leaf$leafCenter),
								$author$project$SvgShorthand$scale(config.bj)
							]))
					]),
				_List_fromArray(
					[
						A6(
						$author$project$View$Leaf$viewLeafPath,
						reverseAnimation,
						reverseAnimation ? $author$project$View$Leaf$leafDelayOffset : 0,
						config.bj,
						0.5,
						-5,
						_Utils_Tuple2(30, 5)),
						A6(
						$author$project$View$Leaf$viewLeafPath,
						reverseAnimation,
						(!reverseAnimation) ? $author$project$View$Leaf$leafDelayOffset : 0,
						config.bj,
						0.4,
						20,
						_Utils_Tuple2(0, 30))
					]))
			]));
};
var $author$project$View$Frame$viewFrame = function () {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$right(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(4)),
			$author$project$CssShorthand$zIndexBackground,
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Frame$viewFrameRow(
				_List_fromArray(
					[
						$author$project$View$Leaf$viewLeaf(
						{a$: false, a0: false, bh: false, bi: false, bj: 1}),
						$author$project$View$Leaf$viewLeaf(
						{a$: true, a0: false, bh: true, bi: true, bj: 0.8})
					])),
				$author$project$View$Frame$viewFrameRow(
				_List_fromArray(
					[
						$author$project$View$Leaf$viewLeaf(
						{a$: false, a0: true, bh: true, bi: false, bj: 0.8}),
						$author$project$View$Leaf$viewLeaf(
						{a$: true, a0: true, bh: true, bi: false, bj: 1})
					]))
			]));
}();
var $rtfeldman$elm_css$Html$Styled$header = $rtfeldman$elm_css$Html$Styled$node('header');
var $author$project$View$Intro$viewName = F2(
	function (name, pronouns) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(2.2)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num(1.4))
			]);
		var pronounsStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(0.5)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.7))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$h1,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(name),
					$rtfeldman$elm_css$Html$Styled$text(' '),
					A4(
					$rtfeldman$elm_css$Html$Styled$styled,
					$rtfeldman$elm_css$Html$Styled$span,
					pronounsStyle,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(pronouns)
						]))
				]));
	});
var $author$project$View$Intro$viewTagline = function (tagline) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$green)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$p,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(tagline)
			]));
};
var $author$project$View$Intro$viewHeader = F3(
	function (name, pronouns, tagline) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(2.2)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(1.2))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$header,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$Intro$viewName, name, pronouns),
					$author$project$View$Intro$viewTagline(tagline)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$main_ = $rtfeldman$elm_css$Html$Styled$node('main');
var $author$project$View$Intro$viewPoint = function (introPoint) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.85))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$p,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(introPoint)
			]));
};
var $author$project$View$Intro$viewMain = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$em(35))
			]);
		var basicData = data.bV;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$main_,
			style,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2($elm$core$List$map, $author$project$View$Intro$viewPoint, basicData.cU),
						$elm$core$List$singleton(
						A2($author$project$View$CallsToAction$viewCallsToAction, assets, data))
					])));
	});
var $author$project$View$Intro$viewIntroContent = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$maxWidth(
				$rtfeldman$elm_css$Css$em(35)),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(2))
			]);
		var basicData = data.bV;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$View$Intro$viewHeader, basicData.cD, basicData.cZ, basicData.dk),
					A2($author$project$View$Intro$viewMain, assets, data)
				]));
	});
var $author$project$View$Intro$viewIntro = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Frame$viewFrame,
					A2($author$project$View$Intro$viewIntroContent, assets, data)
				]));
	});
var $author$project$CssShorthand$animationCycle = F2(
	function (durationMilliseconds, name) {
		return $author$project$CssShorthand$animation(
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						name,
						$elm$core$String$fromFloat(durationMilliseconds) + 'ms',
						'infinite',
						'both'
					])));
	});
var $author$project$View$Castle$castleAnimation = $author$project$CssShorthand$animationCycle(4000);
var $author$project$View$Castle$viewBuildingCenter = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Castle$castleAnimation('castleBuildingCenterCycle')
		]);
	var pathData = 'm 57.152344,29.974609 -1.6875,0.222657 0.160156,0.746093 -0.970703,0.414063 -0.07031,-1.044922 -1.585937,0.3125 0.166015,0.767578 -1.214843,0.310547 -0.195313,-1.019531 -1.33789,0.201172 0.197265,0.853515 -1.091797,0.01758 -0.255859,-0.74414 -1.722656,0.36914 0.228515,0.910157 -1.076172,0.154296 -0.199218,-1.109374 -2.103516,0.314453 0.275391,1.226562 h -1.041016 l -0.169922,-1.103515 -1.564453,0.205078 0.138672,10.849609 6.935547,-0.414063 c 0,0 -1.510491,-6.976884 1.160156,-7.105468 2.670646,-0.128592 2.863281,6.27539 2.863281,6.27539 l 5.826172,-0.138672 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Castle$viewBuildingLeft = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Castle$castleAnimation('castleBuildingLeftCycle')
		]);
	var pathData = 'm 38.523438,22.701172 -3.417969,0.470703 0.05469,2.115234 -1.392578,0.296875 -0.07617,-2.177734 -4.126953,0.939453 0.998047,2.125 -1.296875,0.46875 -1.234375,-2.123047 -3.417969,2.351563 2.947266,5.996093 4.480469,-0.58789 3.300781,12.929687 6.011719,-2.115234 -1.060547,-11.755859 2.474609,-1.292969 1.296875,-7.523438 -3.888672,-0.117187 -0.6875,2.517578 -1.296875,0.117188 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Castle$viewBuildingRight = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Castle$castleAnimation('castleBuildingRightCycle')
		]);
	var pathData = 'M 59.191406,21.023438 59.136719,23.875 h -1.248047 l -0.361328,-2.021484 -3.46875,0.966796 1.25,6.080079 3.605468,0.96875 0.833985,12.023437 5.130859,1.38086 0.832032,-11.19336 2.914062,-0.138672 3.189453,-8.291015 -3.050781,-1.521485 -0.960938,2.160156 -1.664062,-0.138671 0.958984,-2.574219 -3.189453,-0.414063 -0.332031,2.435547 -1.386719,-0.27539 -0.222656,-2.298828 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Castle$viewBuilding = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0))
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[$author$project$View$Castle$viewBuildingLeft, $author$project$View$Castle$viewBuildingCenter, $author$project$View$Castle$viewBuildingRight]));
}();
var $rtfeldman$elm_css$Svg$Styled$circle = $rtfeldman$elm_css$Svg$Styled$node('circle');
var $rtfeldman$elm_css$Svg$Styled$Attributes$cx = $rtfeldman$elm_css$VirtualDom$Styled$attribute('cx');
var $rtfeldman$elm_css$Svg$Styled$Attributes$cy = $rtfeldman$elm_css$VirtualDom$Styled$attribute('cy');
var $rtfeldman$elm_css$Svg$Styled$Attributes$r = $rtfeldman$elm_css$VirtualDom$Styled$attribute('r');
var $author$project$View$Castle$viewCircle = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0)),
			$author$project$View$Castle$castleAnimation('castleCircleCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$circle,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$cx('50'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$cy('35'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$r('4')
			]),
		_List_Nil);
}();
var $author$project$View$Castle$viewCloud = function () {
	var pathData = 'm 49.669689,51.130694 c -0.55827,0.0068 -2.017539,-0.348242 -2.251636,-1.965832 -0.234098,-1.617593 1.368633,-3.272122 3.569874,-4.571364 2.201242,-1.299243 5.796936,-1.359869 8.211455,-0.948025 1.357128,0.231486 4.181632,1.651179 4.608378,4.201258 m -2.409329,1.370795 c 2.850469,-1.018848 5.13341,-0.269543 5.745242,1.157238 0.611833,1.426779 0.795948,4.378647 -0.63823,5.889104 -1.434181,1.510459 -5.491523,2.847759 -6.700428,0.04289 -1.208907,-2.804867 2.69035,-3.089137 2.602086,-1.746583 m -3.845951,2.185829 c -0.301058,1.699772 -3.934925,-0.655973 -5.842399,-0.808203 -1.907476,-0.152226 -3.575831,1.401278 -5.802422,1.547641 -2.226592,0.146348 -4.013997,-0.07104 -5.75479,-1.443346 -1.740793,-1.372295 -1.561415,-4.591625 0.862353,-4.71347 m -2.584259,4.473038 c 0,0 -2.216326,-1.324063 -5.39127,-1.485908 -3.174945,-0.161853 -4.961824,-0.248501 -8.017864,-1.911727 4.001964,0.48945 9.665824,0.452843 11.636802,-2.149931 1.970979,-2.602772 5.451496,-4.607786 9.018158,-3.32378';
	return A2(
		$rtfeldman$elm_css$Svg$Styled$path,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Castle$viewCastle = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Castle$castleAnimation('castleCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[$author$project$View$Castle$viewCloud, $author$project$View$Castle$viewCircle, $author$project$View$Castle$viewBuilding]));
}();
var $author$project$View$Chart$chartAnimation = $author$project$CssShorthand$animationCycle(4000);
var $author$project$View$Chart$chartCenterPoint = _Utils_Tuple2(50, 100);
var $author$project$View$Chart$viewItem = F3(
	function (customStyle, pathData, degrees) {
		return A4(
			$rtfeldman$elm_css$Svg$Styled$styled,
			$rtfeldman$elm_css$Svg$Styled$path,
			customStyle,
			_List_fromArray(
				[
					$author$project$SvgShorthand$transform(
					_List_fromArray(
						[
							A2($author$project$SvgShorthand$rotate, degrees, $author$project$View$Chart$chartCenterPoint)
						])),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
				]),
			_List_Nil);
	});
var $author$project$View$Chart$viewDiagram = function () {
	var pathData = 'm 70.322896,27.382593 h 7.954951 M 25.970503,47.76925 h -5.018811 m -8.003519,1.205353 h 5.779238 m -8.256055,-3.661802 h 10.73287 v 7.323605 H 10.471356 Z M 32.06337,53.015216 H 26.002454 V 41.019655 m 30.304578,7.702414 h -6.313454 m 20.455588,4.066467 h 4.545687 V 31.196525 m -15.783634,7.297748 v 3.535534 M 42.669971,31.802013 h 4.671956 m 22.980969,-4.41942 h 7.954951 m -27.084715,6.881665 h 7.576144 m -7.576144,-3.914341 h 5.934646 m 2.714786,25.885156 h 5.42957 m -5.42957,-3.619712 h 4.545687 m -4.545687,-3.619713 h 7.197337 m -7.197337,-3.619713 h 5.934647 M 35.977712,52.69954 h 6.313454 M 35.977712,49.164006 H 46.205506 M 26.823203,35.590081 H 38.06115 M 26.823203,30.602456 h 9.722718 m -9.722718,-4.987625 h 12.12183 m 27.968595,-1.89404 h 14.77348 v 7.323604 H 66.913628 Z M 56.4333,42.029804 H 70.449165 V 59.581203 H 56.4333 Z M 32.18964,45.565338 H 49.993578 V 56.298207 H 32.18964 Z M 47.720734,26.751249 H 62.241676 V 37.862926 H 47.720734 Z M 22.971996,20.564066 H 42.79624 v 20.07678 H 22.971996 Z';
	return A3($author$project$View$Chart$viewItem, _List_Nil, pathData, 270);
}();
var $author$project$View$Chart$viewLine = function () {
	var pathData = 'm 25.941228,44.490073 h -3.661803 m 3.661803,-5.450615 h -3.661803 m 3.661803,-5.450615 h -3.661803 m 3.661803,-5.450614 h -3.661803 m 3.661803,21.802459 h -3.661803 m 30.836424,5.556581 v 3.661803 M 31.34145,55.497269 v 3.661803 m 38.105205,-3.661803 v 3.661803 m -5.443603,-3.661803 v 3.661803 m -5.443604,-3.661803 v 3.661803 M 47.672249,55.497269 v 3.661803 m -5.4436,-3.661803 v 3.661803 m -5.4436,-3.661803 v 3.661803 m -6.84659,-20.770266 9.722719,10.4064 6.313453,-1.443729 3.156727,-9.036058 6.944798,9.290485 9.217642,-10.257737 6.81853,4.608548 m -43.31029,11.149714 4.293148,-7.730468 2.77792,4.608548 4.671955,-11.44704 1.767767,5.946514 3.409265,-3.121919 3.282996,3.71657 2.65165,5.500526 3.156727,-12.933668 2.525381,1.635292 6.439723,-10.703725 2.904188,5.203199 5.303301,-6.689828 M 25.89785,22.035966 v 33.461303 h 49.497474';
	return A3($author$project$View$Chart$viewItem, _List_Nil, pathData, 180);
}();
var $author$project$View$Chart$viewPie = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0))
		]);
	var pathData = 'm 18.236507,28.515299 h 10.589588 c 0.643036,0 1.160715,0.517678 1.160715,1.160714 v 4.307699 c 0,0.643036 -0.517679,1.160714 -1.160715,1.160714 H 18.236507 c -0.643036,0 -1.160715,-0.517678 -1.160715,-1.160714 v -4.307699 c 0,-0.643036 0.517679,-1.160714 1.160715,-1.160714 z M 70.479803,40.76276 h 4.592731 c 0.791429,0 1.428572,0.637143 1.428572,1.428572 v 4.087653 c 0,0.791428 -0.637143,1.428571 -1.428572,1.428571 h -4.592731 c -0.791429,0 -1.428572,-0.637143 -1.428572,-1.428571 v -4.087653 c 0,-0.791429 0.637143,-1.428572 1.428572,-1.428572 z M 68.155289,19.356945 h 6.465107 c 0.6925,0 1.25,0.5575 1.25,1.25 v 1.919416 c 0,0.6925 -0.5575,1.25 -1.25,1.25 h -6.465107 c -0.6925,0 -1.25,-0.5575 -1.25,-1.25 v -1.919416 c 0,-0.6925 0.5575,-1.25 1.25,-1.25 z m -8.017342,-0.552402 a 17.946428,17.946428 0 0 1 7.652122,8.285896 l -16.342458,7.416089 z m 4.696019,28.267868 A 17.946428,17.946428 0 0 1 49.922918,55.126165 17.946428,17.946428 0 0 1 34.956008,47.176704 L 49.860273,37.179846 Z M 67.182992,29.08501 A 17.946428,17.946428 0 0 1 65.851044,45.812459 L 50.702683,36.189495 Z M 33.645037,45.852716 a 17.946428,17.946428 0 0 1 2.074672,-21.631617 17.946428,17.946428 0 0 1 21.400679,-3.773866 l -8.219824,15.95333 z m -3.276186,6.508215 h 7.466284 c 0.939822,0 1.696429,0.756608 1.696429,1.696429 v 3.173135 c 0,0.939822 -0.756607,1.696429 -1.696429,1.696429 h -7.466284 c -0.939821,0 -1.696429,-0.756607 -1.696429,-1.696429 V 54.05736 c 0,-0.939821 0.756608,-1.696429 1.696429,-1.696429 z';
	return A3($author$project$View$Chart$viewItem, style, pathData, 90);
}();
var $author$project$View$Chart$viewTable = function () {
	var pathData = 'm 27.339145,53.4235 a 1.0891428,1.0891428 0 0 1 -1.089143,1.089143 1.0891428,1.0891428 0 0 1 -1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,1.089143 z m 35.250142,-5e-6 h 8.392857 m -8.392857,-8.839286 h 8.392857 m -8.392857,0 h 8.392857 m -8.392857,-8.839286 h 8.392857 M 67.874856,25.571428 a 1.0891428,1.0891428 0 0 1 -1.089143,1.089143 1.0891428,1.0891428 0 0 1 -1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,1.089143 z M 49.553574,53.423495 h 8.392857 m -8.392857,-8.839286 h 8.392857 m -8.392857,0 h 8.392857 m -8.392857,-8.839286 h 8.392857 M 54.839147,25.571428 a 1.0891428,1.0891428 0 0 1 -1.089143,1.089143 1.0891428,1.0891428 0 0 1 -1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,1.089143 z m -18.32129,27.852067 h 8.392857 m -8.392857,-8.839286 h 8.392857 m -8.392857,0 h 8.392857 m -8.392857,-8.839286 h 8.392857 M 41.80343,25.571428 a 1.0891428,1.0891428 0 0 1 -1.089143,1.089143 1.0891428,1.0891428 0 0 1 -1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,1.089143 z M 27.339145,44.584213 a 1.0891428,1.0891428 0 0 1 -1.089143,1.089143 1.0891428,1.0891428 0 0 1 -1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,1.089143 z m 0,-8.839287 a 1.0891428,1.0891428 0 0 1 -1.089143,1.089143 1.0891428,1.0891428 0 0 1 -1.089143,-1.089143 1.0891428,1.0891428 0 0 1 1.089143,-1.089142 1.0891428,1.0891428 0 0 1 1.089143,1.089142 z M 21.428571,29.821429 H 77.142857 M 31.964287,58.214288 V 20.535715';
	return A3($author$project$View$Chart$viewItem, _List_Nil, pathData, 0);
}();
var $author$project$View$Chart$viewChart = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Chart$chartAnimation('chartCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[$author$project$View$Chart$viewTable, $author$project$View$Chart$viewPie, $author$project$View$Chart$viewLine, $author$project$View$Chart$viewDiagram]));
}();
var $author$project$View$Diamond$diamondAnimation = $author$project$CssShorthand$animationCycle(4000);
var $author$project$View$Diamond$viewBlur = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0)),
			$author$project$View$Diamond$diamondAnimation('diamondBlurCycle')
		]);
	var pathData = 'm 64.174778,53.047069 c -10.026606,5.546649 -16.000882,-6.086646 -18.01537,-6.139545 -2.014488,-0.0529 5.590051,16.45568 -5.504907,9.864791 -11.094958,-6.590889 2.356723,-16.038456 0.298947,-18.133236 -2.057776,-2.09478 -16.163265,7.369588 -11.110031,-3.084712 5.053234,-10.4543 16.606755,-4.476669 18.13341,-6.38261 1.526655,-1.905941 -16.985432,-9.635875 -1.651894,-10.00962 15.333538,-0.373745 9.489778,12.983066 11.402831,14.244011 1.913053,1.260945 7.050227,-16.623153 10.172259,-3.879356 3.122032,12.743797 -10.796134,13.389431 -11.268423,15.38219 -0.472289,1.992759 17.569784,2.591438 7.543178,8.138087 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Diamond$viewGemShine = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Diamond$diamondAnimation('diamondGemShineCycle')
		]);
	var pathData = 'm 29.505731,28.713072 -7.828682,-7.071068 m 6.905187,21.730971 -11.364216,1.010152 m 16.833397,7.310916 -8.333758,5.808377 m 38.154001,-4.723575 6.338501,6.360673 m 0.431118,-14.789994 8.112176,2.43722 m -8.040679,-18.499525 7.323606,-3.030457 m -20.42495,-5.29061 4.545686,-7.323606 m -18.891776,8.469 C 38.719656,12.52525 38.719656,12.52525 38.719656,12.52525';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Diamond$viewGem = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0))
		]);
	var pathData = 'M 70.067622,36.306789 50.9375,56.607143 59.989167,38.462337 Z m -27.929251,2.53567 8.575915,17.496827 8.223259,-17.743021 z m -10.081627,-2.156863 18.47897,20.100118 -9.1531,-18.118655 z M 59.066987,37.715554 50.491072,26.696428 41.77674,37.994243 Z m 4.32587,-11.019125 6.875,9.285714 -9.955357,1.383928 z m -12.589286,-0.04464 8.754487,10.748097 3.686866,-10.901831 z M 38.125,26.428571 41.383928,37.5 50.179886,26.647299 Z m -0.267857,0.08929 -5.923496,9.810596 8.911394,1.454723 z';
	var groupStyle = _List_fromArray(
		[
			$author$project$View$Diamond$diamondAnimation('diamondGemCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		groupStyle,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Svg$Styled$styled,
				$rtfeldman$elm_css$Svg$Styled$path,
				style,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
					]),
				_List_Nil),
				$author$project$View$Diamond$viewGemShine
			]));
}();
var $author$project$View$Diamond$viewRock = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0)),
			$author$project$View$Diamond$diamondAnimation('diamondRockCycle')
		]);
	var pathData = 'm 65.919069,47.015577 1.767767,5.682108 5.177031,-11.111678 -0.252537,-3.788072 z m -18.339652,1.641498 0.04596,5.059737 3.015139,4.91552 16.414979,-5.682109 -1.641498,-6.187184 z m -12.911942,-3.598668 0.189403,5.492705 7.696068,6.988127 7.203682,1.4719 -3.254986,-4.576324 -3.327798,-2.009633 z m -0.315673,-6.029347 0.315672,5.08233 8.734071,7.566081 3.198356,2.030367 -0.133929,-5.525201 -3.22768,-1.425173 z m -5.2086,-3.933763 0.789183,9.96311 3.977475,5.366436 -0.120856,-11.633003 z m 26.361842,-12.702188 -7.54682,24.859688 17.960845,-1.752448 6.313454,-8.333759 -1.136422,-4.545686 -4.671955,-7.449875 z m -7.009771,0.45335 -16.377704,6.76917 -2.223878,2.419147 -0.971357,1.974153 14.482701,11.592215 3.321986,1.413644 8.585254,-24.68403 z m -5.931333,0.812514 -7.406746,2.807572 -2.723141,2.655665 15.768136,-6.355747 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Diamond$viewDiamond = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Diamond$diamondAnimation('diamondCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[$author$project$View$Diamond$viewRock, $author$project$View$Diamond$viewBlur, $author$project$View$Diamond$viewGem]));
}();
var $author$project$View$Fire$fireAnimation = $author$project$CssShorthand$animationCycle(4000);
var $author$project$View$Fire$viewSpinnerFins = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Fire$fireAnimation('fireSpinnerFinsCycle')
		]);
	var pathData = 'M 55.265625 38.111328 L 54.490234 42.931641 L 56.921875 41.041016 L 55.265625 38.111328 z M 52.707031 39.777344 A 0.95717001 0.95717001 0 0 0 51.769531 40.544922 A 0.95717001 0.95717001 0 0 0 52.519531 41.671875 A 0.95717001 0.95717001 0 0 0 53.646484 40.921875 A 0.95717001 0.95717001 0 0 0 52.896484 39.794922 A 0.95717001 0.95717001 0 0 0 52.707031 39.777344 z M 50.447266 40.878906 A 0.57829818 0.57829818 0 0 0 49.880859 41.34375 A 0.57829818 0.57829818 0 0 0 50.333984 42.023438 A 0.57829818 0.57829818 0 0 0 51.013672 41.572266 A 0.57829818 0.57829818 0 0 0 50.560547 40.890625 A 0.57829818 0.57829818 0 0 0 50.447266 40.878906 z M 52.974609 50.822266 L 50.228516 52.716797 L 52.107422 55.541016 L 52.974609 50.822266 z M 57.138672 51.800781 A 0.57829818 0.57829818 0 0 0 56.572266 52.265625 A 0.57829818 0.57829818 0 0 0 57.025391 52.947266 A 0.57829818 0.57829818 0 0 0 57.707031 52.494141 A 0.57829818 0.57829818 0 0 0 57.253906 51.8125 A 0.57829818 0.57829818 0 0 0 57.138672 51.800781 z M 54.832031 52.318359 A 0.95717001 0.95717001 0 0 0 53.894531 53.085938 A 0.95717001 0.95717001 0 0 0 54.644531 54.214844 A 0.95717001 0.95717001 0 0 0 55.771484 53.462891 A 0.95717001 0.95717001 0 0 0 55.021484 52.335938 A 0.95717001 0.95717001 0 0 0 54.832031 52.318359 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Fire$viewSpinner = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Fire$fireAnimation('fireSpinnerCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$circle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$cx('53.814999'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$cy('47.021843'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$r('2')
					]),
				_List_Nil),
				$author$project$View$Fire$viewSpinnerFins
			]));
}();
var $author$project$View$Fire$fireShimmerAnimation = $author$project$CssShorthand$animationCycle(800);
var $author$project$View$Fire$viewStudent = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Fire$fireAnimation('fireStudentCycle')
		]);
	var shimmerStyle = _List_fromArray(
		[
			$author$project$View$Fire$fireShimmerAnimation('fireStudentShimmerCycle')
		]);
	var pathData = 'M 70.949219 28.814453 C 71.031729 28.962971 70.7763 30.505407 70.099609 31.371094 C 69.259275 32.446129 68.73152 32.779871 68.898438 34.443359 C 69.232269 37.770334 69.960835 37.772888 69.208984 38.234375 C 67.901348 39.037 66.792035 36.214492 64.902344 36.900391 C 66.368107 38.881547 66.303676 41.32883 65.878906 43.251953 C 65.454148 45.175079 64.679397 45.985549 64.675781 47.478516 C 64.675313 51.956454 68.30722 55.586406 72.785156 55.585938 C 77.26263 55.585751 80.891092 51.955991 80.890625 47.478516 C 80.887225 45.846615 79.776213 45.015892 79.46875 42.908203 C 79.161286 40.800516 81.238296 37.303027 78.785156 35.017578 C 77.849111 37.779213 76.553764 37.961577 75.591797 37.589844 C 74.62983 37.218111 75.666997 36.275131 75.857422 34.763672 C 75.782402 33.295168 75.054103 32.476967 76.630859 30.939453 C 74.623447 30.761385 74.075361 32.424763 73.855469 33.333984 C 73.582905 34.460944 72.707715 34.841264 72.015625 34.669922 C 71.323534 34.498579 71.041763 33.153972 71.572266 31.494141 C 72.222139 29.46083 70.987674 28.775998 70.949219 28.814453 z M 76.158203 42.890625 C 75.568943 43.454531 75.229627 44.50817 75.716797 44.880859 C 75.998047 45.096022 77.673611 46.419176 77.212891 48.033203 C 76.703151 49.818939 76.353098 49.789353 75.648438 49.955078 C 74.667587 50.185755 73.673651 49.691864 73.332031 48.841797 C 75.021531 49.129856 75.429256 48.149132 75.410156 47.460938 C 75.385676 46.581374 73.280233 45.911511 72.283203 46.451172 C 71.352713 46.954816 70.661462 48.827893 70.945312 49.613281 C 71.229167 50.398667 71.667396 51.349732 72.691406 51.589844 C 73.715426 51.829954 74.480227 51.794264 75.367188 51.320312 C 74.554537 52.480205 73.842385 52.9112 72.203125 52.763672 C 70.389775 52.600476 68.615656 51.5558 68.208984 49.667969 C 67.90846 48.272888 68.590302 46.580091 69.353516 45.667969 C 69.855763 45.067732 70.040106 43.722779 69.671875 43 C 70.516267 43.127803 71.340816 44.475239 72.628906 44.236328 C 73.916996 43.997418 75.145463 42.890625 76.158203 42.890625 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Svg$Styled$styled,
				$rtfeldman$elm_css$Svg$Styled$path,
				shimmerStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
					]),
				_List_Nil)
			]));
}();
var $author$project$View$Fire$viewTeacher = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Fire$fireAnimation('fireTeacherCycle')
		]);
	var shimmerStyle = _List_fromArray(
		[
			$author$project$View$Fire$fireShimmerAnimation('fireTeacherShimmerCycle')
		]);
	var pathData = 'M 27.771484 16.166016 C 26.043657 19.032629 27.299227 19.860851 26.658203 21.742188 C 26.017179 23.623522 24.665072 23.793748 24.908203 26.216797 C 25.394465 31.062895 27.040468 32.825843 25.945312 33.498047 C 24.040601 34.667158 23.357971 29.831397 21.175781 30.052734 C 22.429374 36.827253 21.712462 38.005402 21.09375 40.806641 C 20.475043 43.607881 19.349016 44.790176 19.34375 46.964844 C 19.343068 53.487444 24.631698 58.774117 31.154297 58.773438 C 37.676222 58.773165 42.96162 53.486769 42.960938 46.964844 C 42.956136 44.587805 41.338478 43.376716 40.890625 40.306641 C 40.442771 37.236566 42.440928 32.656832 40.994141 30.427734 C 40.994141 30.427734 39.00663 35.737216 36.992188 34.050781 C 36.314174 32.527076 37.175474 29.732996 38.322266 28.566406 C 37.628426 28.087289 36.740336 28.853336 35.882812 29.617188 C 35.025289 30.381038 34.19775 31.143369 33.628906 30.654297 C 32.561575 29.736644 33.960899 28.150822 34.238281 25.949219 C 34.128999 23.810185 32.188588 22.546195 31.992188 20.306641 C 30.681369 22.027091 32.447266 23.277185 32.126953 24.601562 C 31.729933 26.243102 30.45537 26.796454 29.447266 26.546875 C 28.43916 26.297294 28.640558 24.453069 28.800781 21.919922 C 28.936845 19.768728 27.689496 18.543674 27.771484 16.166016 z M 34.972656 39.285156 C 34.565168 39.919023 34.583399 42.589948 34.867188 42.908203 C 35.150977 43.226459 38.296054 45.545537 37.601562 47.978516 C 36.833189 50.670327 35.666008 51.037492 34.216797 51.492188 C 32.767586 51.946882 30.376386 50.549076 30.658203 48.015625 C 33.000068 50.908439 34.911682 48.152619 34.882812 47.115234 C 34.845923 45.789384 31.670892 44.782219 30.167969 45.595703 C 28.765354 46.354894 27.724469 49.177437 28.152344 50.361328 C 28.580219 51.545219 29.788432 52.682979 31.332031 53.044922 C 32.875632 53.406866 35.2337 53.330038 36.980469 51.636719 C 36.438421 53.93149 33.837944 55.698473 31.09375 55.658203 C 28.349556 55.617942 24.640361 53.28907 24.027344 50.443359 C 23.574333 48.340418 24.605392 45.787038 25.755859 44.412109 C 26.512944 43.507312 26.789445 41.484044 26.234375 40.394531 C 27.507208 40.58718 28.134124 42.802215 28.726562 42.646484 C 29.319003 42.490755 30.636719 39.320312 30.636719 39.320312 C 30.636719 41.019469 31.44087 42.24978 32.007812 42.1875 C 32.574752 42.125225 34.340979 39.355726 34.972656 39.285156 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$rtfeldman$elm_css$Svg$Styled$styled,
				$rtfeldman$elm_css$Svg$Styled$path,
				shimmerStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
					]),
				_List_Nil)
			]));
}();
var $author$project$View$Fire$viewFire = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0))
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[$author$project$View$Fire$viewSpinner, $author$project$View$Fire$viewTeacher, $author$project$View$Fire$viewStudent]));
}();
var $author$project$Msg$DetailsOpen = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Msg$clickDetailsOpen = F2(
	function (item, event) {
		return A2(
			$author$project$Msg$DetailsOpen,
			item.cD,
			{dU: event.dU, e5: event.e5});
	});
var $author$project$View$Mindsets$itemSizeLarge = $rtfeldman$elm_css$Css$em(11.0);
var $author$project$View$Mindsets$itemSizeSmall = $rtfeldman$elm_css$Css$em(9.0);
var $author$project$View$Mindsets$itemButtonOffset = $rtfeldman$elm_css$Css$em(-3.4);
var $rtfeldman$elm_css$Svg$Styled$clipPath = $rtfeldman$elm_css$Svg$Styled$node('clipPath');
var $rtfeldman$elm_css$Svg$Styled$Attributes$clipPath = $rtfeldman$elm_css$VirtualDom$Styled$attribute('clip-path');
var $rtfeldman$elm_css$Svg$Styled$Attributes$id = $rtfeldman$elm_css$VirtualDom$Styled$attribute('id');
var $rtfeldman$elm_css$Css$transparent = {K: 0, bL: 'transparent'};
var $author$project$View$MindsetsCircle$viewMindsetsCircle = F2(
	function (customStyle, illustration) {
		var style = _List_fromArray(
			[
				$author$project$SvgShorthand$stroke($author$project$View$Colors$paleGreen),
				$author$project$SvgShorthand$fill($rtfeldman$elm_css$Css$transparent),
				$author$project$SvgShorthand$strokeWidth(
				$rtfeldman$elm_css$Css$px(1)),
				$rtfeldman$elm_css$Css$batch(customStyle)
			]);
		return A4(
			$rtfeldman$elm_css$Svg$Styled$styled,
			$rtfeldman$elm_css$Svg$Styled$svg,
			style,
			_List_fromArray(
				[
					$author$project$SvgShorthand$viewBoxSquare(100)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$circle,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$cx('50'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$cy('50'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$r('45')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$clipPath,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$id('clip')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$circle,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$cx('50'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$cy('50'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$r('42')
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Svg$Styled$g,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$clipPath('url(#clip)')
						]),
					_List_fromArray(
						[illustration]))
				]));
	});
var $author$project$View$Mindsets$viewItemBackground = function (illustration) {
	var style = _List_fromArray(
		[
			A2(
			$author$project$CssShorthand$batchMap,
			_List_fromArray(
				[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
			$author$project$View$Mindsets$itemSizeLarge),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					A2(
					$author$project$CssShorthand$batchMap,
					_List_fromArray(
						[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
					$author$project$View$Mindsets$itemSizeSmall)
				])),
			$rtfeldman$elm_css$Css$marginBottom($author$project$View$Mindsets$itemButtonOffset)
		]);
	return A2($author$project$View$MindsetsCircle$viewMindsetsCircle, style, illustration);
};
var $author$project$View$Button$borderCenter = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$View$Button$border,
			A5(
			$rtfeldman$elm_css$Css$boxShadow5,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(-6),
			$author$project$View$Colors$paleGreen)
		]));
var $author$project$View$Mindsets$itemButtonWidthLarge = $rtfeldman$elm_css$Css$em(6.1);
var $author$project$View$Mindsets$itemButtonWidthSmall = $rtfeldman$elm_css$Css$em(5.3);
var $author$project$View$Mindsets$viewItemLink = function (name) {
	var style = _List_fromArray(
		[
			$author$project$View$Button$borderCenter,
			$author$project$View$Button$sizeMedium,
			$rtfeldman$elm_css$Css$minWidth($author$project$View$Mindsets$itemButtonWidthLarge),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$minWidth($author$project$View$Mindsets$itemButtonWidthSmall)
				])),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$white),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$capitalize)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$span,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(name)
			]));
};
var $author$project$View$Mindsets$viewItem = F2(
	function (item, illustration) {
		var style = _List_fromArray(
			[
				$author$project$View$Button$text,
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				A2(
				$author$project$CssShorthand$batchMap,
				_List_fromArray(
					[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
				$author$project$View$Mindsets$itemSizeLarge),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						A2(
						$author$project$CssShorthand$batchMap,
						_List_fromArray(
							[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
						$author$project$View$Mindsets$itemSizeSmall)
					])),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.8)),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(0.8))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
					$author$project$HtmlShorthand$onClickPreventDefault(
					$author$project$Msg$clickDetailsOpen(item))
				]),
			_List_fromArray(
				[
					$author$project$View$Mindsets$viewItemBackground(illustration),
					$author$project$View$Mindsets$viewItemLink(item.cD)
				]));
	});
var $author$project$View$Seedling$seedlingAnimation = $author$project$CssShorthand$animationCycle(4000);
var $author$project$View$Leaf$leafStalkPoint = _Utils_Tuple2(4, 15);
var $author$project$View$Seedling$viewPlantLeaf = F5(
	function (flipX, _v0, leafScale, degrees, growFast) {
		var attachX = _v0.a;
		var attachY = _v0.b;
		var style = _List_fromArray(
			[
				$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
				$author$project$SvgShorthand$strokeWidth(
				$rtfeldman$elm_css$Css$px(0)),
				$author$project$View$Seedling$seedlingAnimation(
				$elm$core$String$concat(
					_List_fromArray(
						[
							'seedlingPlantLeaf',
							growFast ? 'Fast' : 'Slow',
							'Cycle'
						])))
			]);
		var _v1 = $author$project$View$Leaf$leafStalkPoint;
		var leafStalkX = _v1.a;
		var leafStalkY = _v1.b;
		return A2(
			$rtfeldman$elm_css$Svg$Styled$g,
			_List_fromArray(
				[
					$author$project$SvgShorthand$transform(
					_List_fromArray(
						[
							A2($author$project$SvgShorthand$translate, attachX, attachY),
							A2($author$project$SvgShorthand$flipAxes, flipX, false),
							A2(
							$author$project$SvgShorthand$rotate,
							degrees,
							_Utils_Tuple2(0, 0))
						]))
				]),
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Svg$Styled$styled,
					$rtfeldman$elm_css$Svg$Styled$g,
					style,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$path,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$View$Leaf$leafPathData),
									$author$project$SvgShorthand$transform(
									_List_fromArray(
										[
											$author$project$SvgShorthand$scale(leafScale),
											A2($author$project$SvgShorthand$translate, -leafStalkX, -leafStalkY)
										]))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$View$Seedling$viewPlant = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Seedling$seedlingAnimation('seedlingPlantCycle')
		]);
	var pathData = 'm 60.628791,63.558752 c 0.759716,0.814851 -8.176942,-12.378923 -1.963956,-19.967403 4.1186,-5.030418 3.674327,-10.940739 0.791048,-12.5847';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
					]),
				_List_Nil),
				A5(
				$author$project$View$Seedling$viewPlantLeaf,
				true,
				_Utils_Tuple2(59.5, 31),
				0.12,
				-60,
				true),
				A5(
				$author$project$View$Seedling$viewPlantLeaf,
				false,
				_Utils_Tuple2(59.5, 31),
				0.13,
				-85,
				true),
				A5(
				$author$project$View$Seedling$viewPlantLeaf,
				true,
				_Utils_Tuple2(57, 47),
				0.14,
				-70,
				false),
				A5(
				$author$project$View$Seedling$viewPlantLeaf,
				false,
				_Utils_Tuple2(59, 59),
				0.15,
				-80,
				false)
			]));
}();
var $author$project$View$Seedling$viewSunHalo = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Seedling$seedlingAnimation('seedlingSunHaloCycle')
		]);
	var pathData = 'M 30.052734 11.990234 L 28.03125 15.779297 L 31.566406 16.03125 L 30.052734 11.990234 z M 23.890625 14.779297 A 1.3398552 1.3398552 0 0 0 22.550781 16.119141 A 1.3398552 1.3398552 0 0 0 23.890625 17.458984 A 1.3398552 1.3398552 0 0 0 25.230469 16.119141 A 1.3398552 1.3398552 0 0 0 23.890625 14.779297 z M 36.275391 14.976562 A 1.3398552 1.3398552 0 0 0 34.935547 16.316406 A 1.3398552 1.3398552 0 0 0 36.275391 17.65625 A 1.3398552 1.3398552 0 0 0 37.615234 16.316406 A 1.3398552 1.3398552 0 0 0 36.275391 14.976562 z M 16.541016 17.798828 L 18.5625 21.082031 L 20.455078 18.556641 L 16.541016 17.798828 z M 39.142578 20.703125 L 40.154297 24.238281 L 43.5625 20.830078 L 39.142578 20.703125 z M 18.455078 23.203125 A 1.3398552 1.3398552 0 0 0 17.115234 24.542969 A 1.3398552 1.3398552 0 0 0 18.455078 25.882812 A 1.3398552 1.3398552 0 0 0 19.794922 24.542969 A 1.3398552 1.3398552 0 0 0 18.455078 23.203125 z M 40.15625 26.876953 A 1.3398552 1.3398552 0 0 0 38.816406 28.216797 A 1.3398552 1.3398552 0 0 0 40.15625 29.556641 A 1.3398552 1.3398552 0 0 0 41.496094 28.216797 A 1.3398552 1.3398552 0 0 0 40.15625 26.876953 z M 18.435547 28.40625 L 15.783203 31.941406 L 20.582031 31.056641 L 18.435547 28.40625 z M 38.763672 31.814453 L 36.365234 33.960938 L 40.912109 36.613281 L 38.763672 31.814453 z M 22.230469 33.21875 A 1.3398552 1.3398552 0 0 0 20.890625 34.558594 A 1.3398552 1.3398552 0 0 0 22.230469 35.898438 A 1.3398552 1.3398552 0 0 0 23.570312 34.558594 A 1.3398552 1.3398552 0 0 0 22.230469 33.21875 z M 33.480469 35 A 1.3398552 1.3398552 0 0 0 32.140625 36.339844 A 1.3398552 1.3398552 0 0 0 33.480469 37.679688 A 1.3398552 1.3398552 0 0 0 34.820312 36.339844 A 1.3398552 1.3398552 0 0 0 33.480469 35 z M 25.884766 35.603516 L 26.894531 39.517578 L 29.546875 35.728516 L 25.884766 35.603516 z';
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$path,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
			]),
		_List_Nil);
}();
var $author$project$View$Seedling$viewSun = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0)),
			$author$project$View$Seedling$seedlingAnimation('seedlingSunCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$circle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$cx('29.420692'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$cy('25.374981'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$r('7.323606')
					]),
				_List_Nil),
				$author$project$View$Seedling$viewSunHalo
			]));
}();
var $author$project$View$Seedling$viewSeedling = A2(
	$rtfeldman$elm_css$Svg$Styled$g,
	_List_Nil,
	_List_fromArray(
		[$author$project$View$Seedling$viewSun, $author$project$View$Seedling$viewPlant]));
var $author$project$View$Wheel$wheelAnimation = $author$project$CssShorthand$animationCycle(4000);
var $author$project$View$Wheel$wheelCenter = _Utils_Tuple2(50, 36);
var $author$project$View$Wheel$wheelRadius = 20;
var $author$project$View$Wheel$viewItem = F4(
	function (rotateAnimationName, translateAnimationName, item, degrees) {
		var translateStyle = _List_fromArray(
			[
				$author$project$View$Wheel$wheelAnimation(translateAnimationName)
			]);
		var rotateStyle = _List_fromArray(
			[
				$author$project$View$Wheel$wheelAnimation(rotateAnimationName)
			]);
		var endTransform = _List_fromArray(
			[
				$author$project$SvgShorthand$transform(
				_List_fromArray(
					[
						function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return A2($author$project$SvgShorthand$translate, a, b);
					}($author$project$View$Wheel$wheelCenter),
						A2(
						$author$project$SvgShorthand$rotate,
						degrees,
						_Utils_Tuple2(0, 0))
					]))
			]);
		var beginTransform = _List_fromArray(
			[
				$author$project$SvgShorthand$transform(
				_List_fromArray(
					[
						A2($author$project$SvgShorthand$translate, 0, $author$project$View$Wheel$wheelRadius),
						$author$project$SvgShorthand$scale(0.1)
					]))
			]);
		return A3(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Svg$Styled$g(endTransform),
						$elm$core$List$singleton),
					A2(
						$elm$core$Basics$composeL,
						A3($rtfeldman$elm_css$Svg$Styled$styled, $rtfeldman$elm_css$Svg$Styled$g, rotateStyle, _List_Nil),
						$elm$core$List$singleton)),
				A2(
					$elm$core$Basics$composeL,
					A3($rtfeldman$elm_css$Svg$Styled$styled, $rtfeldman$elm_css$Svg$Styled$g, translateStyle, _List_Nil),
					$elm$core$List$singleton)),
			A2(
				$elm$core$Basics$composeL,
				$rtfeldman$elm_css$Svg$Styled$g(beginTransform),
				$elm$core$List$singleton),
			item);
	});
var $author$project$View$Wheel$wheelScale = 0.1;
var $author$project$View$Wheel$viewSpoke = function (pathData) {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(1 / $author$project$View$Wheel$wheelScale)),
			$author$project$View$Wheel$wheelAnimation('wheelSpokeLocalCycle')
		]);
	return A3(
		$author$project$View$Wheel$viewItem,
		'wheelSpokeRotateCycle',
		'wheelSpokeTranslateCycle',
		A4(
			$rtfeldman$elm_css$Svg$Styled$styled,
			$rtfeldman$elm_css$Svg$Styled$path,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d(pathData)
				]),
			_List_Nil));
};
var $author$project$View$Wheel$viewCrescent = $author$project$View$Wheel$viewSpoke('M 0 -43.181641 A 43.181469 43.181469 0 0 0 -13.806641 -40.857422 A 23.107239 23.107239 0 0 1 -9.0917969 -26.900391 A 23.107239 23.107239 0 0 1 -32.199219 -3.7929688 A 23.107239 23.107239 0 0 1 -42.660156 -6.3242188 A 43.181469 43.181469 0 0 0 -43.181641 0 A 43.181469 43.181469 0 0 0 0 43.181641 A 43.181469 43.181469 0 0 0 43.181641 0 A 43.181469 43.181469 0 0 0 0 -43.181641 z');
var $author$project$View$Wheel$viewHub = function () {
	var style = _List_fromArray(
		[
			$author$project$SvgShorthand$fill($author$project$View$Colors$paleGreen),
			$author$project$SvgShorthand$strokeWidth(
			$rtfeldman$elm_css$Css$px(0))
		]);
	return A3(
		$author$project$View$Wheel$viewItem,
		'wheelHubRotateCycle',
		'wheelHubTranslateCycle',
		A4(
			$rtfeldman$elm_css$Svg$Styled$styled,
			$rtfeldman$elm_css$Svg$Styled$circle,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$cx('0'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$cy('0'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$r('50')
				]),
			_List_Nil));
}();
var $author$project$View$Wheel$viewSquare = $author$project$View$Wheel$viewSpoke('m -37.485101,-37.540707 c 21.499012,-3.704767 43.0318149,-7.373868 75.026748,0 8.110137,25.008032 6.167118,50.016063 0,75.024095 -25.008916,4.08878 -50.017832,5.98674 -75.026748,0 -7.940743,-23.925242 -5.059775,-49.326118 0,-75.024095 z');
var $author$project$View$Wheel$viewStar = $author$project$View$Wheel$viewSpoke('M 8.234375 -53.931641 L 0.03125 -37.876953 A 37.87817 37.87817 0 0 0 0 -37.878906 A 37.87817 37.87817 0 0 0 -30.53125 -22.347656 L -47.847656 -24.783203 L -35.677734 -12.585938 A 37.87817 37.87817 0 0 0 -37.878906 0 A 37.87817 37.87817 0 0 0 -30.234375 22.757812 L -37.457031 37.560547 L -22.859375 30.142578 A 37.87817 37.87817 0 0 0 0 37.878906 A 37.87817 37.87817 0 0 0 13.185547 35.484375 L 25.046875 46.943359 L 22.453125 30.451172 A 37.87817 37.87817 0 0 0 37.878906 0 A 37.87817 37.87817 0 0 0 37.830078 -1.3867188 L 53.285156 -9.6015625 L 35.744141 -12.400391 A 37.87817 37.87817 0 0 0 11.373047 -36.121094 L 8.234375 -53.931641 z');
var $author$project$View$Wheel$viewTriangle = $author$project$View$Wheel$viewSpoke('M 45.46875 -45.726562 L 15.720703 -37.755859 A 40.908627 40.908627 0 0 0 0 -40.908203 A 40.908627 40.908627 0 0 0 -32.429688 -24.853516 L -63.304688 -16.580078 L -40.386719 6.3378906 A 40.908627 40.908627 0 0 0 -6.3652344 40.359375 L 16.322266 63.046875 L 24.439453 32.753906 A 40.908627 40.908627 0 0 0 40.908203 0 A 40.908627 40.908627 0 0 0 37.541016 -16.138672 L 45.46875 -45.726562 z');
var $author$project$View$Wheel$viewX = $author$project$View$Wheel$viewSpoke('m -41.785591,-28.215218 5.268774,5.268774 a 43.181469,43.181469 0 0 0 -0.0097,45.902555 l -5.259106,5.259107 13.570373,13.570373 5.268774,-5.268774 a 43.181469,43.181469 0 0 0 45.902555,0.0097 l 5.259107,5.259106 13.570373,-13.570373 -5.268774,-5.268774 a 43.181469,43.181469 0 0 0 0.0097,-45.902555 l 5.259106,-5.259107 -13.570373,-13.570373 -5.268774,5.268774 a 43.181469,43.181469 0 0 0 -45.902555,-0.0097 l -5.259107,-5.259106 z');
var $author$project$View$Wheel$viewWheel = function () {
	var style = _List_fromArray(
		[
			$author$project$View$Wheel$wheelAnimation('wheelCycle')
		]);
	return A4(
		$rtfeldman$elm_css$Svg$Styled$styled,
		$rtfeldman$elm_css$Svg$Styled$g,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Wheel$viewHub(30),
				$author$project$View$Wheel$viewX(90),
				$author$project$View$Wheel$viewCrescent(150),
				$author$project$View$Wheel$viewStar(210),
				$author$project$View$Wheel$viewSquare(270),
				$author$project$View$Wheel$viewTriangle(330)
			]));
}();
var $author$project$View$Mindsets$viewItems = function (data) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.8))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var itemSelector = _v0.a;
				var illustration = _v0.b;
				return A2(
					$author$project$View$Mindsets$viewItem,
					itemSelector(data),
					illustration);
			},
			_List_fromArray(
				[
					_Utils_Tuple2(
					function ($) {
						return $.eH;
					},
					$author$project$View$Castle$viewCastle),
					_Utils_Tuple2(
					function ($) {
						return $.eC;
					},
					$author$project$View$Seedling$viewSeedling),
					_Utils_Tuple2(
					function ($) {
						return $.fH;
					},
					$author$project$View$Fire$viewFire),
					_Utils_Tuple2(
					function ($) {
						return $.dB;
					},
					$author$project$View$Chart$viewChart),
					_Utils_Tuple2(
					function ($) {
						return $.dW;
					},
					$author$project$View$Wheel$viewWheel),
					_Utils_Tuple2(
					function ($) {
						return $.eu;
					},
					$author$project$View$Diamond$viewDiamond)
				])));
};
var $rtfeldman$elm_css$Html$Styled$section = $rtfeldman$elm_css$Html$Styled$node('section');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.bL + (' ' + argB.bL));
	});
var $rtfeldman$elm_css$Css$backgroundPosition2 = $rtfeldman$elm_css$Css$prop2('background-position');
var $author$project$View$Section$viewBackgroundIcon = F2(
	function (iconSource, iconBackground) {
		var iconSize = $rtfeldman$elm_css$Css$em(10);
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$zIndexBackground,
				A2($author$project$Icon$iconBackgroundImage, iconSource, iconBackground),
				A2($rtfeldman$elm_css$Css$backgroundPosition2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$height(iconSize),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(0.8)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(-iconSize.eZ)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$em(-2.6)),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$em(-2.0))
					])),
				$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(0.025))
			]);
		return A4($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, style, _List_Nil, _List_Nil);
	});
var $author$project$View$Section$viewContent = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$em(33))
		]);
	return A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, style, _List_Nil);
}();
var $author$project$View$Section$viewHeader = function (headerText) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1.2)),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(0.7)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$marginRightLeft(
					$rtfeldman$elm_css$Css$em(1.3))
				])),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.4))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$h2,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(headerText)
			]));
};
var $author$project$View$Section$viewParagraph = function (paragraphText) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(1.6)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$marginRightLeft(
					$rtfeldman$elm_css$Css$em(3.5))
				])),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(1.5)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$p,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(paragraphText)
			]));
};
var $author$project$View$Section$viewSection = F3(
	function (iconSource, sectionData, nodes) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$author$project$CssShorthand$borderBottomSolidColor($author$project$View$Colors$black),
				$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$standardBorderWidth),
				A5(
				$rtfeldman$elm_css$Css$boxShadow5,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$zero,
				$author$project$View$Colors$paleGreen),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$em(1.5))
			]);
		var requiredNodesBefore = _List_fromArray(
			[
				A2($author$project$View$Section$viewBackgroundIcon, iconSource, sectionData.fd),
				$author$project$View$Section$viewHeader(sectionData.cD),
				$author$project$View$Section$viewParagraph(sectionData.fe)
			]);
		var requiredNodesAfter = $author$project$MaybeEx$toList(
			A2($elm$core$Maybe$map, $author$project$View$Section$viewParagraph, sectionData.fh));
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$section,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id(sectionData.er)
				]),
			_List_fromArray(
				[
					$author$project$View$Section$viewContent(
					_Utils_ap(
						requiredNodesBefore,
						_Utils_ap(nodes, requiredNodesAfter)))
				]));
	});
var $author$project$View$Mindsets$viewMindsets = F2(
	function (assets, data) {
		var sectionData = data.cA;
		return A3(
			$author$project$View$Section$viewSection,
			assets.by,
			sectionData,
			_List_fromArray(
				[
					$author$project$View$Mindsets$viewItems(sectionData)
				]));
	});
var $author$project$View$Projects$viewDescription = function (description) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.1)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$em(0.2))
				]))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(description)
			]));
};
var $author$project$View$Projects$viewName = function (name) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.1)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$em(0.3))
				]))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(name)
			]));
};
var $author$project$View$Projects$viewTech = function (tech) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$green),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.1)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$em(0.3))
				]))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(tech)
			]));
};
var $author$project$View$Projects$viewItem = function (item) {
	var style = _List_fromArray(
		[
			$author$project$View$Button$border,
			$author$project$View$Button$text,
			$author$project$CssShorthand$displayFlexColumn,
			$author$project$CssShorthand$marginTopBottom(
			$rtfeldman$elm_css$Css$px(8)),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$px(8)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$marginTopBottom(
					$rtfeldman$elm_css$Css$px(16)),
					$author$project$CssShorthand$marginRightLeft(
					$rtfeldman$elm_css$Css$px(14))
				])),
			$author$project$CssShorthand$paddingTopBottom(
			$rtfeldman$elm_css$Css$em(0.7)),
			$author$project$CssShorthand$paddingRightLeft(
			$rtfeldman$elm_css$Css$em(0.5)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$paddingTopBottom(
					$rtfeldman$elm_css$Css$em(0.8)),
					$author$project$CssShorthand$paddingRightLeft(
					$rtfeldman$elm_css$Css$em(1.0))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$em(8.0)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left)
				])),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.85))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$a,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
				$author$project$HtmlShorthand$onClickPreventDefault(
				$author$project$Msg$clickDetailsOpen(item))
			]),
		_List_fromArray(
			[
				$author$project$View$Projects$viewName(
				A2($elm$core$Maybe$withDefault, item.cD, item.fz)),
				$author$project$View$Projects$viewTech(item.dl),
				$author$project$View$Projects$viewDescription(item.d2)
			]));
};
var $author$project$View$Projects$viewItems = function (items) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-8)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$marginRightLeft(
					$rtfeldman$elm_css$Css$em(0.5))
				])),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(1.0))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		A2($elm$core$List$map, $author$project$View$Projects$viewItem, items));
};
var $author$project$View$Projects$viewProjects = F2(
	function (assets, data) {
		var sectionData = data.cY;
		return A3(
			$author$project$View$Section$viewSection,
			assets.by,
			sectionData,
			_List_fromArray(
				[
					$author$project$View$Projects$viewItems(sectionData.bA)
				]));
	});
var $rtfeldman$elm_css$Css$baseline = $rtfeldman$elm_css$Css$prop1('baseline');
var $author$project$View$Tech$getShortName = function (item) {
	return A2($elm$core$Maybe$withDefault, item.cD, item.fz);
};
var $elm$core$String$toUpper = _String_toUpper;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $author$project$View$Tech$toGroup = function (items) {
	var update = F2(
		function (item, maybeGroup) {
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$List$cons,
					item,
					A2($elm$core$Maybe$withDefault, _List_Nil, maybeGroup)));
		});
	var key = A2(
		$elm$core$Basics$composeR,
		$author$project$View$Tech$getShortName,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$left(1),
			$elm$core$String$toUpper));
	var loop = function (item) {
		return A2(
			$elm$core$Dict$update,
			key(item),
			update(item));
	};
	return $elm$core$Dict$toList(
		A3($elm$core$List$foldr, loop, $elm$core$Dict$empty, items));
};
var $author$project$View$Button$sizeSmall = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$CssShorthand$paddingRightLeft(
			$rtfeldman$elm_css$Css$em(0.5)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1.7)),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
		]));
var $author$project$View$Tech$viewItem = function (item) {
	var style = _List_fromArray(
		[
			$author$project$View$Button$border,
			$author$project$View$Button$sizeSmall,
			$author$project$View$Button$text,
			$author$project$CssShorthand$marginTopBottom(
			$rtfeldman$elm_css$Css$px(11)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$marginTopBottom(
					$rtfeldman$elm_css$Css$px(17))
				])),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$px(7))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$a,
		style,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
				$author$project$HtmlShorthand$onClickPreventDefault(
				$author$project$Msg$clickDetailsOpen(item))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$View$Tech$getShortName(item))
			]));
};
var $author$project$View$Tech$viewKey = function (key) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$paleGreen),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$span,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(key)
			]));
};
var $author$project$View$Tech$viewGroup = F2(
	function (key, items) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$baseline),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$px(8))
			]);
		var itemsStyle = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$span,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Tech$viewKey(key),
					A4(
					$rtfeldman$elm_css$Html$Styled$styled,
					$rtfeldman$elm_css$Html$Styled$span,
					itemsStyle,
					_List_Nil,
					A2($elm$core$List$map, $author$project$View$Tech$viewItem, items))
				]));
	});
var $author$project$View$Tech$viewItems = function (items) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$baseline),
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(0.4)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$author$project$CssShorthand$marginRightLeft(
					$rtfeldman$elm_css$Css$em(1.6))
				])),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(1.5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.92)),
			$author$project$View$Breakpoints$breakpointPortfolioMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$em(1.0))
				]))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2($author$project$View$Tech$viewGroup, a, b);
			},
			$author$project$View$Tech$toGroup(items)));
};
var $author$project$View$Tech$viewTech = F2(
	function (assets, data) {
		var sectionData = data.dl;
		return A3(
			$author$project$View$Section$viewSection,
			assets.by,
			sectionData,
			_List_fromArray(
				[
					$author$project$View$Tech$viewItems(sectionData.bA)
				]));
	});
var $author$project$CssShorthand$gap = function (arg) {
	return A2($rtfeldman$elm_css$Css$property, 'gap', arg.bL);
};
var $author$project$View$Work$viewItemLine = F2(
	function (customStyle, lineText) {
		var style = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.3)),
				$rtfeldman$elm_css$Css$batch(customStyle)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(lineText)
				]));
	});
var $author$project$View$Work$viewDuration = $author$project$View$Work$viewItemLine(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
		]));
var $author$project$View$Work$viewName = $author$project$View$Work$viewItemLine(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]));
var $author$project$View$Work$viewSkills = $author$project$View$Work$viewItemLine(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$green)
		]));
var $author$project$View$Work$viewItem = F2(
	function (isLarge, item) {
		var baseStyle = _List_fromArray(
			[
				$author$project$View$Button$border,
				$author$project$View$Button$text,
				$author$project$CssShorthand$displayFlexColumn,
				$author$project$CssShorthand$paddingTopBottom(
				$rtfeldman$elm_css$Css$em(0.8)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.85))
			]);
		var largeStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$batch(baseStyle),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(1.2)),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$author$project$CssShorthand$paddingTopBottom(
						$rtfeldman$elm_css$Css$em(1.0)),
						$author$project$CssShorthand$paddingRightLeft(
						$rtfeldman$elm_css$Css$em(1.4))
					]))
			]);
		var smallStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$batch(baseStyle),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$px(8)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(16)),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(1.5)),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$author$project$CssShorthand$paddingRightLeft(
						$rtfeldman$elm_css$Css$em(1.0))
					]))
			]);
		var style = isLarge ? largeStyle : smallStyle;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
					$author$project$HtmlShorthand$onClickPreventDefault(
					$author$project$Msg$clickDetailsOpen(item))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						$elm$core$List$singleton(
						$author$project$View$Work$viewName(item.cD)),
						A2($elm$core$List$map, $author$project$View$Work$viewSkills, item.fi),
						$elm$core$List$singleton(
						$author$project$View$Work$viewDuration(item.fc))
					])));
	});
var $author$project$View$Work$viewItems = F2(
	function (isLarge, items) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$author$project$CssShorthand$displayFlexRow,
						$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
					])),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(0.5)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(1.2)),
				$author$project$CssShorthand$gap(
				$rtfeldman$elm_css$Css$em(1.2))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$View$Work$viewItem(isLarge),
				items));
	});
var $author$project$View$Work$viewWork = F2(
	function (assets, data) {
		var sectionData = data.du;
		return A3(
			$author$project$View$Section$viewSection,
			assets.by,
			sectionData,
			_List_fromArray(
				[
					A2($author$project$View$Work$viewItems, true, sectionData.fg),
					A2($author$project$View$Work$viewItems, false, sectionData.fj)
				]));
	});
var $author$project$View$Portfolio$viewPortfolioStatic = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardScreenFontSizeSmall),
				$author$project$View$Breakpoints$breakpointPortfolioMedium(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardScreenFontSizeLarge)
					])),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num($author$project$View$Metrics$standardLineHeight)),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$stretch),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$black)
			]);
		return $author$project$LazyHtml$toLazyHtml(
			A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$div,
				style,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$View$Intro$viewIntro, assets, data),
						A2($author$project$View$Contents$viewContents, assets, data),
						A2($author$project$View$Work$viewWork, assets, data),
						A2($author$project$View$Mindsets$viewMindsets, assets, data),
						A2($author$project$View$Tech$viewTech, assets, data),
						A2($author$project$View$Projects$viewProjects, assets, data),
						A2($author$project$View$Footer$viewFooter, assets, data)
					])));
	});
var $author$project$View$Portfolio$viewPortfolio = F3(
	function (assets, data, display) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$willChangeTransform,
				$author$project$CssShorthand$displayNone,
				display.c9 ? $author$project$CssShorthand$noStyle : $author$project$CssShorthand$mediaNotPrint(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexColumn])),
				$author$project$View$DetailsAnimation$animatePortfolio(display)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$LazyHtml$fromLazyHtml2, $author$project$View$Portfolio$viewPortfolioStatic, assets, data)
				]));
	});
var $author$project$View$Breakpoints$breakpointResumePreviewLargeRemLength = 77;
var $author$project$View$Breakpoints$breakpointResumePreviewLarge = $author$project$CssShorthand$mediaInverseConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$maxWidth(
			$author$project$CssShorthand$rem_($author$project$View$Breakpoints$breakpointResumePreviewLargeRemLength))
		]));
var $author$project$View$Breakpoints$breakpointResumePreviewMediumRemLength = 45;
var $author$project$View$Breakpoints$breakpointResumePreviewMedium = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_($author$project$View$Breakpoints$breakpointResumePreviewMediumRemLength)),
			$rtfeldman$elm_css$Css$Media$maxWidth(
			$author$project$CssShorthand$rem_($author$project$View$Breakpoints$breakpointResumePreviewLargeRemLength))
		]));
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $author$project$Msg$Print = {$: 1};
var $author$project$View$Breakpoints$breakpointResumePreviewMediumLarge = $author$project$CssShorthand$mediaConditions(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Media$minWidth(
			$author$project$CssShorthand$rem_($author$project$View$Breakpoints$breakpointResumePreviewMediumRemLength))
		]));
var $rtfeldman$elm_css$Html$Styled$Attributes$download = function (fileName) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'download', fileName);
};
var $author$project$HtmlShorthand$hrefHash = $rtfeldman$elm_css$Html$Styled$Attributes$href('#');
var $author$project$View$ResumePreview$viewButton = A2(
	$rtfeldman$elm_css$Html$Styled$styled,
	$rtfeldman$elm_css$Html$Styled$a,
	_List_fromArray(
		[
			$author$project$View$Button$border,
			$author$project$View$Button$sizeMedium,
			$author$project$View$Breakpoints$breakpointResumePreviewMediumLarge(
			_List_fromArray(
				[$author$project$View$Button$sizeLarge])),
			$author$project$View$Button$text,
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(0.7)),
			$author$project$View$Breakpoints$breakpointResumePreviewMedium(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$em(0.6)),
					$author$project$CssShorthand$marginRightLeft($rtfeldman$elm_css$Css$zero)
				])),
			$author$project$View$Breakpoints$breakpointResumePreviewLarge(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$em(0.7))
				])),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$white)
		]));
var $author$project$View$ResumePreview$viewAction = F4(
	function (iconSource, iconBackground, attributes, elements) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$author$project$View$Breakpoints$breakpointResumePreviewMedium(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexColumn])),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexRow])),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$em(1.5)),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero)
					])),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.8)),
				$author$project$View$Breakpoints$breakpointResumePreviewMedium(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$em(1.9))
					])),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$em(1.2))
					]))
			]);
		var iconStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(-24)),
				$author$project$View$Breakpoints$breakpointResumePreviewMediumLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero)
					]))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Icon$iconSpan, iconStyle, iconSource, iconBackground),
					A2($author$project$View$ResumePreview$viewButton, attributes, elements)
				]));
	});
var $author$project$View$Resume$viewResumePrintName = function (data) {
	return A3($elm$core$String$replace, ' ', '_', data.bV.cD) + '_resume';
};
var $author$project$View$ResumePreview$viewActions = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$author$project$View$Breakpoints$breakpointResumePreviewMedium(
				_List_fromArray(
					[
						$author$project$CssShorthand$displayFlexRow,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
					])),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$author$project$CssShorthand$displayFlexColumn,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexEnd)
					])),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardScreenFontSizeSmall),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardScreenFontSizeLarge)
					])),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$em(-1.5)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.5)),
				$author$project$View$Breakpoints$breakpointResumePreviewMediumLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
					])),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$em(1.8)),
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$em(2.2)),
						$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero)
					])),
				$author$project$CssShorthand$animation(
				A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						['fromTop', '500ms', 'ease-out']))),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$author$project$CssShorthand$animation(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['fromLeft', '500ms', 'ease-out'])))
					]))
			]);
		var iconSource = assets.by;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$View$ResumePreview$viewAction,
					iconSource,
					function ($) {
						return $.d9;
					},
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('/resume.pdf'),
							$rtfeldman$elm_css$Html$Styled$Attributes$download(
							$author$project$View$Resume$viewResumePrintName(data))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Download')
						])),
					A4(
					$author$project$View$ResumePreview$viewAction,
					iconSource,
					function ($) {
						return $.fm;
					},
					_List_fromArray(
						[
							$author$project$HtmlShorthand$hrefHash,
							$author$project$HtmlShorthand$onClickPreventDefault(
							$elm$core$Basics$always($author$project$Msg$Print))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Print')
						])),
					A4(
					$author$project$View$ResumePreview$viewAction,
					iconSource,
					function ($) {
						return $.eo;
					},
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('#top')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('View my portfolio')
						]))
				]));
	});
var $author$project$View$ResumePreview$pageHeightPt = 11 * 72;
var $author$project$View$ResumePreview$pageWidthPt = 8.5 * 72;
var $rtfeldman$elm_css$Css$PtUnits = 0;
var $rtfeldman$elm_css$Css$pt = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'pt');
var $author$project$View$Metrics$standardPrintFontSize = $rtfeldman$elm_css$Css$pt(11);
var $author$project$View$ResumePreview$ptToEm = function (length) {
	return $rtfeldman$elm_css$Css$em(length / $author$project$View$Metrics$standardPrintFontSize.eZ);
};
var $author$project$View$Colors$printBlack = $rtfeldman$elm_css$Css$hex('#000000');
var $author$project$View$Metrics$printLineHeight = 1.7;
var $author$project$View$Colors$printGreen = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 0.86, 0.34);
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ev: index, eJ: match, eY: number, fC: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{dO: false, eO: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $author$project$Icon$iconImage = F2(
	function (iconSource, iconBackground) {
		return $rtfeldman$elm_css$Html$Styled$Attributes$src(
			iconBackground(iconSource));
	});
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $author$project$View$Resume$viewIcon = F2(
	function (iconSource, iconBackground) {
		var style = _List_fromArray(
			[
				A2(
				$author$project$CssShorthand$batchMap,
				_List_fromArray(
					[$rtfeldman$elm_css$Css$width, $rtfeldman$elm_css$Css$height]),
				$rtfeldman$elm_css$Css$em(0.9)),
				$author$project$CssShorthand$marginRightLeft(
				$rtfeldman$elm_css$Css$em(0.3)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(-0.1))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$img,
			style,
			_List_fromArray(
				[
					A2($author$project$Icon$iconImage, iconSource, iconBackground)
				]),
			_List_Nil);
	});
var $author$project$View$Resume$viewLink = F5(
	function (customStyle, iconSource, url, shortURL, iconBackground) {
		var trimProtocol = A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^(?:https://|mailto:)')),
			$elm$core$Basics$always(''));
		var urlText = trimProtocol(
			A2($elm$core$Maybe$withDefault, url, shortURL));
		var style = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$printBlack),
				$author$project$CssShorthand$textDecorationSkipInk,
				$rtfeldman$elm_css$Css$batch(customStyle)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$a,
			style,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(url)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(urlText),
					A2($author$project$View$Resume$viewIcon, iconSource, iconBackground)
				]));
	});
var $author$project$View$Resume$viewSource = F3(
	function (iconSource, sourceURL, sourceShortURL) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.8)),
				$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(0.5))
			]);
		var linkStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal)
			]);
		var highlightStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$printGreen)
			]);
		return A2(
			$elm$core$Basics$composeL,
			A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$p, style, _List_Nil),
			$elm$core$List$concat)(
			_List_fromArray(
				[
					A3(
					$author$project$MarkedString$transform,
					$rtfeldman$elm_css$Html$Styled$text,
					$author$project$HtmlShorthand$styledSpanText(highlightStyle),
					$author$project$MarkedString$markedString('This resume was created with `Elm` and `CSS` — view source at ')),
					$elm$core$List$singleton(
					A5(
						$author$project$View$Resume$viewLink,
						linkStyle,
						iconSource,
						sourceURL,
						sourceShortURL,
						function ($) {
							return $.ee;
						}))
				]));
	});
var $author$project$View$Resume$viewFooter = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(1))
			]);
		var basicData = data.bV;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$footer,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$View$Resume$viewSource, assets.by, basicData.dd, basicData.dc)
				]));
	});
var $author$project$View$Resume$viewContactEmail = F2(
	function (iconSource, emailAddress) {
		return A5(
			$author$project$View$Resume$viewLink,
			_List_Nil,
			iconSource,
			'mailto:' + emailAddress,
			$elm$core$Maybe$Nothing,
			function ($) {
				return $.eG;
			});
	});
var $author$project$View$Resume$viewContactLink = F2(
	function (iconSource, link) {
		return A5($author$project$View$Resume$viewLink, _List_Nil, iconSource, link.fR, link.fA, link.eq);
	});
var $author$project$View$Resume$viewContactLocation = F2(
	function (iconSource, location) {
		var style = _List_Nil;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$span,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(location),
					A2(
					$author$project$View$Resume$viewIcon,
					iconSource,
					function ($) {
						return $.eI;
					})
				]));
	});
var $author$project$View$Resume$viewContact = F4(
	function (iconSource, emailAddress, links, currentLocation) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$marginTop(
				$rtfeldman$elm_css$Css$em(0.3)),
				$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.9)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num(1.6))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$nav,
			style,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						$elm$core$List$singleton(
						A2($author$project$View$Resume$viewContactEmail, iconSource, emailAddress)),
						A2(
						$elm$core$List$map,
						$author$project$View$Resume$viewContactLink(iconSource),
						links),
						$elm$core$List$singleton(
						A2($author$project$View$Resume$viewContactLocation, iconSource, currentLocation))
					])));
	});
var $author$project$View$Resume$viewHomepage = F2(
	function (iconSource, homepageURL) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.9)),
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
			]);
		var linkStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$p,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('View my portfolio website at '),
					A5(
					$author$project$View$Resume$viewLink,
					linkStyle,
					iconSource,
					homepageURL,
					$elm$core$Maybe$Nothing,
					function ($) {
						return $.ee;
					})
				]));
	});
var $author$project$View$Resume$viewName = F2(
	function (name, pronouns) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num(1.0)),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(2.4)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
			]);
		var pronounsStyle = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$em(0.6)),
				$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
				$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(0.5))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$h1,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(name),
					$rtfeldman$elm_css$Html$Styled$text(' '),
					A4(
					$rtfeldman$elm_css$Html$Styled$styled,
					$rtfeldman$elm_css$Html$Styled$span,
					pronounsStyle,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(pronouns)
						]))
				]));
	});
var $author$project$View$Resume$viewTagline = function (tagline) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(0.6)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.1)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.1)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$printGreen)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$p,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(tagline)
			]));
};
var $author$project$View$Resume$viewPrimary = F5(
	function (iconSource, name, pronouns, homepageURL, tagline) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(1))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$Resume$viewName, name, pronouns),
					$author$project$View$Resume$viewTagline(tagline),
					A2($author$project$View$Resume$viewHomepage, iconSource, homepageURL)
				]));
	});
var $author$project$View$Resume$viewHeader = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexRow,
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(0.3))
			]);
		var linksData = data.cy;
		var basicData = data.bV;
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$header,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$View$Resume$viewPrimary, assets.by, basicData.cD, basicData.cZ, basicData.cn, basicData.dk),
					A4($author$project$View$Resume$viewContact, assets.by, basicData.cd, linksData.c5, basicData.b3)
				]));
	});
var $author$project$View$Metrics$printBorderWidth = $rtfeldman$elm_css$Css$em(0.06);
var $author$project$View$Colors$printPaleGreen = A3($rtfeldman$elm_css$Css$hsl, $author$project$View$Colors$greenHue, 0.5, 0.82);
var $author$project$View$Resume$viewHorizontalRule = function (spacing) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$marginRightLeft(
			$rtfeldman$elm_css$Css$em(0.6)),
			A2(
			$author$project$CssShorthand$batchMap,
			_List_fromArray(
				[$rtfeldman$elm_css$Css$marginBottom, $rtfeldman$elm_css$Css$paddingBottom]),
			spacing),
			$author$project$CssShorthand$borderBottomSolidColor($author$project$View$Colors$printPaleGreen),
			$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$printBorderWidth)
		]);
	return A4($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, style, _List_Nil, _List_Nil);
};
var $rtfeldman$elm_css$Css$borderLeftStyle = $rtfeldman$elm_css$Css$prop1('border-left-style');
var $author$project$CssShorthand$borderLeftSolidColor = $author$project$CssShorthand$borderSidesSolidColor(
	_List_fromArray(
		[$rtfeldman$elm_css$Css$borderLeftStyle]));
var $rtfeldman$elm_css$Css$lastOfType = $rtfeldman$elm_css$Css$pseudoClass('last-of-type');
var $author$project$View$Resume$viewItem = function (nodes) {
	var verticalRuleStyle = _List_fromArray(
		[
			$author$project$CssShorthand$marginTopBottom(
			$rtfeldman$elm_css$Css$em(0.25)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$em(0.4)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$em(0.8)),
			$author$project$CssShorthand$borderLeftSolidColor($author$project$View$Colors$printPaleGreen),
			$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$printBorderWidth)
		]);
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.4)),
			$rtfeldman$elm_css$Css$lastOfType(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$em(0.6))
				]))
		]);
	var innerStyle = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$div,
		style,
		_List_Nil,
		_List_fromArray(
			[
				A4($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, verticalRuleStyle, _List_Nil, _List_Nil),
				A4($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, innerStyle, _List_Nil, nodes)
			]));
};
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$View$Resume$viewItemLineFlex0 = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$baseline),
			$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal)
		]);
	return A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$h3, style, _List_Nil);
}();
var $author$project$View$Resume$viewSubheading = function (subheading) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.05)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$h2,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(subheading)
			]));
};
var $author$project$View$Resume$viewSection = F2(
	function (subheading, nodes) {
		var style = _List_fromArray(
			[$author$project$CssShorthand$displayFlexColumn]);
		return A2(
			$elm$core$Basics$composeL,
			A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$section, style, _List_Nil),
			$elm$core$List$concat)(
			_List_fromArray(
				[
					$elm$core$List$singleton(
					$author$project$View$Resume$viewSubheading(subheading)),
					nodes
				]));
	});
var $author$project$View$Resume$viewEducation = function (data) {
	var sectionData = data.cc;
	return A2(
		$author$project$View$Resume$viewSection,
		'Education',
		_List_fromArray(
			[
				$author$project$View$Resume$viewItem(
				_List_fromArray(
					[
						$author$project$View$Resume$viewItemLineFlex0(
						_List_fromArray(
							[
								A2($author$project$HtmlShorthand$styledSpanText, _List_Nil, sectionData.cD + (' / ' + sectionData.de))
							]))
					]))
			]));
};
var $author$project$View$Resume$viewIntro = function (data) {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$em(0.6))
		]);
	var sectionData = data.bV;
	var highlightStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]);
	return A2(
		$elm$core$Basics$composeL,
		A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$section, style, _List_Nil),
		$elm$core$List$concat)(
		_List_fromArray(
			[
				A3(
				$author$project$MarkedString$transform,
				$rtfeldman$elm_css$Html$Styled$text,
				$author$project$HtmlShorthand$styledSpanText(highlightStyle),
				sectionData.c4)
			]));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$View$Resume$viewSkillsLineItem = F2(
	function (borderColor, item) {
		var style = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$em(0.25)),
				$author$project$CssShorthand$borderSolidColor(borderColor),
				$rtfeldman$elm_css$Css$borderWidth($author$project$View$Metrics$printBorderWidth),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$em(0.3)),
				$rtfeldman$elm_css$Css$paddingTop($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$em(0.1)),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(0.4)),
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$span,
			style,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(item)
				]));
	});
var $author$project$View$Resume$viewSkillsLine = F3(
	function (textColor, borderColor, skills) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$marginRight(
				$rtfeldman$elm_css$Css$em(0.2)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num(2.1)),
				$rtfeldman$elm_css$Css$color(textColor)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$p,
			style,
			_List_Nil,
			A2(
				$elm$core$List$intersperse,
				$rtfeldman$elm_css$Html$Styled$text(' '),
				A2(
					$elm$core$List$map,
					$author$project$View$Resume$viewSkillsLineItem(borderColor),
					skills)));
	});
var $author$project$View$Resume$viewStartupSkills = function (data) {
	var sectionData = data.df;
	var skills = sectionData.bA;
	return A2(
		$author$project$View$Resume$viewSection,
		sectionData.cD,
		_List_fromArray(
			[
				$author$project$View$Resume$viewItem(
				_List_fromArray(
					[
						A3($author$project$View$Resume$viewSkillsLine, $author$project$View$Colors$printGreen, $author$project$View$Colors$printPaleGreen, skills)
					]))
			]));
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Data$Visibility$filterVisible = F2(
	function (test, selector) {
		return $elm$core$List$filter(
			A2($elm$core$Basics$composeR, selector, test));
	});
var $author$project$Data$Visibility$filterResumeVisible = function (resumeVariant) {
	return $author$project$Data$Visibility$filterVisible(
		$elm$core$List$member(resumeVariant));
};
var $author$project$View$Resume$resumeVariant = 0;
var $author$project$View$Resume$viewTechSkills = function (data) {
	var sectionData = data.dl;
	var skills = A2(
		$elm$core$List$map,
		function (item) {
			return A2($elm$core$Maybe$withDefault, item.cD, item.fz);
		},
		A3(
			$author$project$Data$Visibility$filterResumeVisible,
			$author$project$View$Resume$resumeVariant,
			function ($) {
				return $.fU;
			},
			sectionData.bA));
	return A2(
		$author$project$View$Resume$viewSection,
		sectionData.cD,
		_List_fromArray(
			[
				$author$project$View$Resume$viewItem(
				_List_fromArray(
					[
						A3($author$project$View$Resume$viewSkillsLine, $author$project$View$Colors$printGreen, $author$project$View$Colors$printPaleGreen, skills)
					]))
			]));
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $rtfeldman$elm_css$Css$letterSpacing = $rtfeldman$elm_css$Css$prop1('letter-spacing');
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $author$project$View$Resume$viewItemDotsMargin = A2(
	$author$project$HtmlShorthand$styledSpanText,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$em(0.6)),
			$rtfeldman$elm_css$Css$flexShrink(
			$rtfeldman$elm_css$Css$num(0.2))
		]),
	'');
var $author$project$CssShorthand$wordBreakBreakAll = A2($rtfeldman$elm_css$Css$property, 'word-break', 'break-all');
var $author$project$View$Resume$viewItemDots = function () {
	var style = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.8)),
			$author$project$CssShorthand$displayFlexRow,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$baseline),
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$em(0)),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em($author$project$View$Metrics$printLineHeight - 0.1)),
			$author$project$CssShorthand$wordBreakBreakAll,
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$letterSpacing(
			$rtfeldman$elm_css$Css$em(0.05)),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$printPaleGreen)
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$span,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Resume$viewItemDotsMargin,
				$rtfeldman$elm_css$Html$Styled$text(
				A2(
					$elm$core$String$repeat,
					80,
					'.' + $elm$core$String$fromChar(
						$elm$core$Char$fromCode(8201)))),
				$author$project$View$Resume$viewItemDotsMargin
			]));
}();
var $author$project$View$Resume$viewItemName = $author$project$HtmlShorthand$styledSpanText(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]));
var $author$project$View$Resume$viewItemPeriod = $author$project$HtmlShorthand$styledSpanText(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]));
var $author$project$View$Resume$viewWorkItemNameTitlePeriod = F3(
	function (name, title, period) {
		return $author$project$View$Resume$viewItemLineFlex0(
			_List_fromArray(
				[
					$author$project$View$Resume$viewItemName(name + (' / ' + title)),
					$author$project$View$Resume$viewItemDots,
					$author$project$View$Resume$viewItemPeriod(period)
				]));
	});
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement('before');
var $author$project$CssShorthand$pseudoElementContentText = F3(
	function (pseudoElement, text, style) {
		return pseudoElement(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\'' + (text + '\'')),
					$rtfeldman$elm_css$Css$batch(style)
				]));
	});
var $author$project$CssShorthand$beforeText = $author$project$CssShorthand$pseudoElementContentText($rtfeldman$elm_css$Css$before);
var $author$project$View$Resume$viewItemLineBulletStyle = A2(
	$author$project$CssShorthand$beforeText,
	'-',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$em(-0.8)),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$printGreen)
		]));
var $author$project$View$Resume$viewItemLine2 = function () {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$marginTopBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$em(1.0)),
			$author$project$View$Resume$viewItemLineBulletStyle
		]);
	return A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$p, style, _List_Nil);
}();
var $author$project$View$Resume$viewMarkedString = function () {
	var highlightStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$color($author$project$View$Colors$printGreen)
		]);
	return A2(
		$author$project$MarkedString$transform,
		$rtfeldman$elm_css$Html$Styled$text,
		$author$project$HtmlShorthand$styledSpanText(highlightStyle));
}();
var $author$project$View$Resume$viewWorkItemPoint = function (point) {
	return $author$project$View$Resume$viewItemLine2(
		$author$project$View$Resume$viewMarkedString(point));
};
var $author$project$View$Resume$viewWorkItem = function (item) {
	return A2($elm$core$Basics$composeL, $author$project$View$Resume$viewItem, $elm$core$List$concat)(
		_List_fromArray(
			[
				$elm$core$List$singleton(
				A3($author$project$View$Resume$viewWorkItemNameTitlePeriod, item.cD, item.fs, item.fq)),
				A2($elm$core$List$map, $author$project$View$Resume$viewWorkItemPoint, item.fr)
			]));
};
var $author$project$View$Resume$viewWork = F2(
	function (data, itemsSelector) {
		var sectionData = data.du;
		return A2(
			$author$project$View$Resume$viewSection,
			sectionData.cD,
			A2(
				$elm$core$List$map,
				$author$project$View$Resume$viewWorkItem,
				itemsSelector(sectionData)));
	});
var $author$project$View$Resume$viewMain = function (data) {
	var style = _List_fromArray(
		[
			$author$project$CssShorthand$displayFlexColumn,
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1))
		]);
	return A4(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$main_,
		style,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Resume$viewIntro(data),
				$author$project$View$Resume$viewTechSkills(data),
				A2(
				$author$project$View$Resume$viewWork,
				data,
				function ($) {
					return $.c5;
				}),
				$author$project$View$Resume$viewStartupSkills(data),
				$author$project$View$Resume$viewEducation(data)
			]));
};
var $author$project$View$Resume$viewResume = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$em(2.8)),
				$rtfeldman$elm_css$Css$paddingBottom(
				$rtfeldman$elm_css$Css$em(2.1)),
				$author$project$CssShorthand$paddingRightLeft(
				$rtfeldman$elm_css$Css$em(3.8)),
				$rtfeldman$elm_css$Css$flexGrow(
				$rtfeldman$elm_css$Css$num(1)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num($author$project$View$Metrics$printLineHeight)),
				$rtfeldman$elm_css$Css$color($author$project$View$Colors$printBlack)
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$Resume$viewHeader, assets, data),
					$author$project$View$Resume$viewHorizontalRule(
					$rtfeldman$elm_css$Css$em(0.6)),
					$author$project$View$Resume$viewMain(data),
					A2($author$project$View$Resume$viewFooter, assets, data)
				]));
	});
var $author$project$View$ResumePreview$viewPage = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				A5(
				$rtfeldman$elm_css$Css$boxShadow5,
				$rtfeldman$elm_css$Css$px(2),
				$rtfeldman$elm_css$Css$px(2),
				$rtfeldman$elm_css$Css$px(14),
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$hex('#313131')),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$em(1))
					])),
				$rtfeldman$elm_css$Css$width(
				$author$project$View$ResumePreview$ptToEm($author$project$View$ResumePreview$pageWidthPt)),
				$rtfeldman$elm_css$Css$height(
				$author$project$View$ResumePreview$ptToEm($author$project$View$ResumePreview$pageHeightPt)),
				$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Colors$white),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$vw(($author$project$View$Metrics$standardPrintFontSize.eZ / ($author$project$View$ResumePreview$pageWidthPt + (1.5 * 72))) * 100)),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$em(1))
					])),
				$author$project$CssShorthand$animation(
				A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						['fadeIn', '200ms', 'ease-in'])))
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$Resume$viewResume, assets, data)
				]));
	});
var $author$project$View$ResumePreview$viewResumePreviewStatic = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayFlexColumn,
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$author$project$CssShorthand$displayFlexRow,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
					])),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$author$project$CssShorthand$paddingTopBottom(
				$rtfeldman$elm_css$Css$em(1.8)),
				$author$project$View$Breakpoints$breakpointResumePreviewMedium(
				_List_fromArray(
					[
						$author$project$CssShorthand$paddingTopBottom(
						$rtfeldman$elm_css$Css$em(2.5))
					])),
				$author$project$View$Breakpoints$breakpointResumePreviewLarge(
				_List_fromArray(
					[
						$author$project$CssShorthand$paddingTopBottom(
						$rtfeldman$elm_css$Css$em(4))
					])),
				$rtfeldman$elm_css$Css$minHeight(
				$rtfeldman$elm_css$Css$vh(100)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$rtfeldman$elm_css$Css$hex('#dadada'))
			]);
		return $author$project$LazyHtml$toLazyHtml(
			A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$div,
				style,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$View$ResumePreview$viewActions, assets, data),
						A2($author$project$View$ResumePreview$viewPage, assets, data)
					])));
	});
var $author$project$View$ResumePreview$viewResumePreview = F3(
	function (assets, data, display) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$willChangeTransform,
				$author$project$CssShorthand$displayNone,
				display.c9 ? $author$project$CssShorthand$mediaNotPrint(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexColumn])) : $author$project$CssShorthand$noStyle
			]);
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$div,
			style,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$LazyHtml$fromLazyHtml2, $author$project$View$ResumePreview$viewResumePreviewStatic, assets, data)
				]));
	});
var $rtfeldman$elm_css$Css$Structure$OnlyQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$only = $rtfeldman$elm_css$Css$Structure$OnlyQuery;
var $author$project$CssShorthand$mediaPrint = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$Media$only, $rtfeldman$elm_css$Css$Media$print, _List_Nil)
		]));
var $author$project$View$ResumePrint$viewResumePrint = F2(
	function (assets, data) {
		var style = _List_fromArray(
			[
				$author$project$CssShorthand$displayNone,
				$rtfeldman$elm_css$Css$minHeight(
				$rtfeldman$elm_css$Css$vh(100)),
				$rtfeldman$elm_css$Css$fontSize($author$project$View$Metrics$standardPrintFontSize),
				$author$project$CssShorthand$mediaPrint(
				_List_fromArray(
					[$author$project$CssShorthand$displayFlexColumn]))
			]);
		return $author$project$LazyHtml$toLazyHtml(
			A4(
				$rtfeldman$elm_css$Html$Styled$styled,
				$rtfeldman$elm_css$Html$Styled$div,
				style,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$View$Resume$viewResume, assets, data)
					])));
	});
var $author$project$View$view = F2(
	function (data, _v0) {
		var assets = _v0.bR;
		var display = _v0.b8;
		var style = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
			]);
		return A2(
			$elm$core$Basics$composeL,
			A3($rtfeldman$elm_css$Html$Styled$styled, $rtfeldman$elm_css$Html$Styled$div, style, _List_Nil),
			$elm$core$List$concat)(
			_List_fromArray(
				[
					$elm$core$List$singleton(
					A3($author$project$View$Portfolio$viewPortfolio, assets, data, display)),
					$author$project$MaybeEx$toList(
					A2($author$project$View$Details$maybeViewDetails, assets, display)),
					$elm$core$List$singleton(
					A3($author$project$View$ResumePreview$viewResumePreview, assets, data, display)),
					$elm$core$List$singleton(
					A3($author$project$LazyHtml$fromLazyHtml2, $author$project$View$ResumePrint$viewResumePrint, assets, data))
				]));
	});
var $author$project$Main$main = function () {
	var data = $author$project$Data$initData;
	return $elm$browser$Browser$element(
		{
			ew: A2(
				$elm$core$Basics$composeR,
				$author$project$Model$init(data),
				$author$project$View$alsoViewHead(data)),
			fD: $author$project$View$subscribe,
			fP: F3(
				function (f, a, b) {
					return f(
						_Utils_Tuple2(a, b));
				})(
				A2(
					$elm$core$Basics$composeR,
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return A2($author$project$Update$update, a, b);
					},
					$author$project$View$alsoViewHead(data))),
			fT: A2(
				$elm$core$Basics$composeR,
				$author$project$View$view(data),
				$rtfeldman$elm_css$Html$Styled$toUnstyled)
		});
}();
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (iconSource) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (hash) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (faviconSource) {
							return $elm$json$Json$Decode$succeed(
								{bv: faviconSource, el: hash, by: iconSource});
						},
						A2(
							$elm$json$Json$Decode$field,
							'faviconSource',
							A2(
								$elm$json$Json$Decode$andThen,
								function (resume) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (portfolio) {
											return $elm$json$Json$Decode$succeed(
												{fb: portfolio, fp: resume});
										},
										A2($elm$json$Json$Decode$field, 'portfolio', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'resume', $elm$json$Json$Decode$string))));
				},
				A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'iconSource',
			A2(
				$elm$json$Json$Decode$andThen,
				function (xSquare) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (user) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (twitter) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (printer) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (mapPin) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (mail) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (linkedin) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (home) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (heart) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (github) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (eye) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (externalLink) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (download) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (chevronRight) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (chevronLeft) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (calendar) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (box) {
																																					return $elm$json$Json$Decode$succeed(
																																						{dJ: box, dN: calendar, dR: chevronLeft, dS: chevronRight, d9: download, ee: externalLink, eg: eye, ek: github, em: heart, eo: home, eF: linkedin, eG: mail, eI: mapPin, fm: printer, fM: twitter, fS: user, fW: xSquare});
																																				},
																																				A2($elm$json$Json$Decode$field, 'box', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'calendar', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'chevronLeft', $elm$json$Json$Decode$string));
																														},
																														A2($elm$json$Json$Decode$field, 'chevronRight', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'download', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'externalLink', $elm$json$Json$Decode$string));
																								},
																								A2($elm$json$Json$Decode$field, 'eye', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'github', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'heart', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'home', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'linkedin', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'mail', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'mapPin', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'printer', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'twitter', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'user', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'xSquare', $elm$json$Json$Decode$string)))))(0)}});}(this));